var al = Object.defineProperty, rl = Object.defineProperties;
var ol = Object.getOwnPropertyDescriptors;
var sr = Object.getOwnPropertySymbols;
var Fo = Object.prototype.hasOwnProperty, Mo = Object.prototype.propertyIsEnumerable;
var Qr = (e, t, r) => t in e ? al(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, v = (e, t) => {
  for (var r in t || (t = {}))
    Fo.call(t, r) && Qr(e, r, t[r]);
  if (sr)
    for (var r of sr(t))
      Mo.call(t, r) && Qr(e, r, t[r]);
  return e;
}, B = (e, t) => rl(e, ol(t));
var U = (e, t) => {
  var r = {};
  for (var o in e)
    Fo.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && sr)
    for (var o of sr(e))
      t.indexOf(o) < 0 && Mo.call(e, o) && (r[o] = e[o]);
  return r;
};
var eo = (e, t, r) => Qr(e, typeof t != "symbol" ? t + "" : t, r);
import * as b from "react";
import { useState as ce, useCallback as vt, useLayoutEffect as _l, useEffect as z, createContext as g_, useContext as h_, useMemo as ka, useRef as Kt, useReducer as ll, memo as il } from "react";
import f_ from "lodash.debounce";
import { jsx as a, jsxs as h, Fragment as Q } from "react/jsx-runtime";
import { ChevronDown as na, Check as wa, Close as ct, Info as Ir, Warning as b_, CheckCircle as So, Block as v_, ChevronRight as Mr, VisibilityOn as nl, VisibilityOff as cl, Person as sl, ChevronUp as Rr, DoubleArrowLeft as dl, ChevronLeft as ul, DoubleArrowRight as ml, Error as k_, People as pl, Bot as gl, Add as hl, ChatBotColored as fl, PersonAdd as bl, TextLogoFull as vl, LiveChatMono as kl, ChatBotMono as yl, HelpDeskMono as Cl, KnowledgeBaseMono as wl, OpenWidgetMono as $l, HelloMono as Nl, TextLogo as Sl, Calendar as xl, Search as El, LockBlack as Tl, ArrowDownward as Bl, ArrowUpward as Il, ArrowsSort as Al, Call as Dl, OneColored as y_, Refresh as Ol } from "@livechat/design-system-icons";
import u from "clsx";
import { useFloatingParentNodeId as Gr, useFloatingNodeId as ar, useFloating as rr, offset as or, flip as Ur, size as C_, autoUpdate as _r, useClick as lr, useDismiss as ir, useRole as nr, useInteractions as cr, useTransitionStyles as Lr, FloatingNode as $a, FloatingTree as qr, shift as xo, arrow as Pl, hide as Fl, useHover as Ml, safePolygon as Rl, useFocus as Gl, useTransitionStatus as Ul, FloatingArrow as Ll, FloatingPortal as Ca, FloatingFocusManager as ko, useListNavigation as ql, FloatingOverlay as Hl } from "@floating-ui/react";
import * as zl from "react-dom";
import { flushSync as Vl, createPortal as Wl } from "react-dom";
import { Virtuoso as Kl } from "react-virtuoso";
import { getContrast as Eo } from "polished";
import { DayPicker as Yl } from "react-day-picker";
import { isSameMonth as Ja, subMonths as ra, differenceInCalendarMonths as Ro, addMonths as Go, isSameDay as yo, isAfter as Co, differenceInCalendarDays as w_, isBefore as Xl, isPast as Zl, format as dr, startOfToday as $_, subDays as ur, startOfMonth as Uo, endOfMonth as jl } from "date-fns";
import "react-day-picker/style.css";
import Lo from "lodash.escape";
import { TransitionGroup as N_, CSSTransition as S_ } from "react-transition-group";
import { useFloating as Jl, shift as Ql, flip as ei, autoUpdate as ti } from "@floating-ui/react-dom";
const ai = (e, t) => {
  b.useEffect(() => {
    const r = () => {
      document.visibilityState === "visible" && e();
    };
    return t && document.addEventListener("visibilitychange", r), () => {
      t && document.removeEventListener(
        "visibilitychange",
        r
      );
    };
  }, [e, t]);
}, la = ({
  isVisible: e,
  elementRef: t,
  includeSleepWakeScenario: r = !1
}) => {
  const [o, _] = b.useState(e), [l, i] = b.useState(e), [n, d] = b.useState(e), s = b.useRef(null), c = () => {
    _(!1), s.current && clearTimeout(s.current);
  };
  return b.useEffect(() => {
    const p = t.current;
    if (!n && p)
      return p.addEventListener("transitionend", c), i(!1), s.current = window.setTimeout(c, 300), () => {
        clearTimeout(s.current), p.removeEventListener(
          "transitionend",
          c
        );
      };
    n && (_(!0), requestAnimationFrame(() => i(!0)));
  }, [n]), b.useEffect(() => {
    d(e);
  }, [e]), ai(
    () => d(e),
    r
  ), {
    isOpen: l,
    isMounted: o,
    setShouldBeVisible: d
  };
}, qo = /* @__PURE__ */ (() => {
  let e = null;
  const t = /* @__PURE__ */ new Map();
  return {
    observe: (_, l) => {
      e || (e = new ResizeObserver((i) => {
        i.forEach((n) => {
          const d = n.target, s = t.get(d);
          s && s(n.contentRect);
        });
      })), _ && (t.set(_, l), e.observe(_));
    },
    unobserve: (_) => {
      e && _ && (e.unobserve(_), t.delete(_), t.size === 0 && (e.disconnect(), e = null));
    }
  };
})(), er = (e, t) => {
  window.ResizeObserver && (e !== null ? qo.observe(e, (o) => {
    t(o);
  }) : qo.unobserve(e));
}, x_ = () => {
  const [e, t] = b.useState(0), r = b.useCallback(
    (o) => er(
      o,
      (_) => t(_.height)
    ),
    []
  );
  return {
    size: e,
    handleResizeRef: r
  };
}, ri = ({
  mobileBreakpoint: e
}) => {
  const [t, r] = b.useState(!1), o = b.useCallback(
    (_) => er(
      _,
      (l) => r(l.width <= e)
    ),
    []
  );
  return {
    isMobile: t,
    handleResizeRef: o
  };
}, oi = ["input", "button", "select", "textarea", "a"], _i = ({
  onClick: e
}) => ({
  handleInteractiveClick: b.useCallback(
    (r) => {
      const o = r.target;
      if (!(o instanceof HTMLElement)) return;
      const _ = o.tagName.toLowerCase();
      oi.includes(_) || e(r);
    },
    [e]
  )
}), li = (e = !1) => {
  const [t, r] = ce(e);
  return {
    isHovered: t,
    handleMouseOver: () => r(!0),
    handleMouseOut: () => r(!1)
  };
}, ii = (e) => {
  const [t, r] = ce(!1), o = vt(() => {
    if (e.current) {
      const l = e.current.scrollHeight > e.current.offsetHeight || e.current.scrollWidth > e.current.offsetWidth;
      r(l);
    }
  }, [e]), _ = f_(() => {
    o();
  }, 100);
  return _l(() => {
    o();
    const l = e.current;
    return l && er(l, () => {
      _();
    }), () => {
      er(null, () => {
      });
    };
  }, [e, _, o]), z(() => () => {
    _.cancel();
  }, [_]), t;
}, Vd = {
  Background01: "--background-01",
  Background02: "--background-02",
  Background03: "--background-03",
  SurfacePrimaryDefault: "--surface-primary-default",
  SurfaceSecondaryDefault: "--surface-secondary-default",
  SurfaceSecondaryHover: "--surface-secondary-hover",
  SurfaceSecondaryActive: "--surface-secondary-active",
  SurfaceSecondaryDisabled: "--surface-secondary-disabled",
  SurfacePrimaryHover: "--surface-primary-hover",
  SurfacePrimaryActive: "--surface-primary-active",
  SurfacePrimaryActiveColored: "--surface-primary-active-colored",
  SurfacePrimaryDisabled: "--surface-primary-disabled",
  SurfaceTertiaryDefault: "--surface-tertiary-default",
  SurfaceModerateDefault: "--surface-moderate-default",
  SurfaceModerateHover: "--surface-moderate-hover",
  SurfaceModerateActive: "--surface-moderate-active",
  SurfaceTertiaryHover: "--surface-tertiary-hover",
  SurfaceTertiaryActive: "--surface-tertiary-active",
  SurfaceTertiaryDisabled: "--surface-tertiary-disabled",
  SurfaceAccentEmphasisLowInfo: "--surface-accent-emphasis-low-info",
  SurfaceAccentEmphasisLowNegative: "--surface-accent-emphasis-low-negative",
  SurfaceAccentEmphasisLowWarning: "--surface-accent-emphasis-low-warning",
  SurfaceAccentEmphasisLowPositive: "--surface-accent-emphasis-low-positive",
  SurfaceAccentEmphasisLowPurple: "--surface-accent-emphasis-low-purple",
  SurfaceAccentEmphasisMinInfo: "--surface-accent-emphasis-min-info",
  SurfaceAccentEmphasisMinNegative: "--surface-accent-emphasis-min-negative",
  SurfaceAccentEmphasisMinWarning: "--surface-accent-emphasis-min-warning",
  SurfaceAccentEmphasisMinPositive: "--surface-accent-emphasis-min-positive",
  SurfaceAccentEmphasisMinPurple: "--surface-accent-emphasis-min-purple",
  SurfaceAccentOndarkNegativeDefault: "--surface-accent-ondark-negative-default",
  SurfaceAccentOndarkNegativeHover: "--surface-accent-ondark-negative-hover",
  SurfaceAccentOndarkWarningDefault: "--surface-accent-ondark-warning-default",
  SurfaceAccentOndarkWarningHover: "--surface-accent-ondark-warning-hover",
  SurfaceAccentOndarkInfoDefault: "--surface-accent-ondark-info-default",
  SurfaceAccentOndarkInfoHover: "--surface-accent-ondark-info-hover",
  SurfaceAccentOndarkPositiveDefault: "--surface-accent-ondark-positive-default",
  SurfaceAccentOndarkPositiveHover: "--surface-accent-ondark-positive-hover",
  SurfaceAccentEmphasisSubtleNegative: "--surface-accent-emphasis-subtle-negative",
  SurfaceAccentEmphasisSubtleWarning: "--surface-accent-emphasis-subtle-warning",
  SurfaceAccentEmphasisSubtleInfo: "--surface-accent-emphasis-subtle-info",
  SurfaceAccentEmphasisSubtlePositive: "--surface-accent-emphasis-subtle-positive",
  SurfaceInvertPrimary: "--surface-invert-primary",
  SurfaceInvertSecondary: "--surface-invert-secondary",
  SurfaceInvertDisabled: "--surface-invert-disabled",
  SurfaceLockedDefault: "--surface-locked-default",
  SurfaceLockedHover: "--surface-locked-hover",
  SurfaceLockedActive: "--surface-locked-active",
  SurfaceLockedDisabled: "--surface-locked-disabled",
  SurfaceLockedWhite: "--surface-locked-white",
  SurfaceLockedBlack: "--surface-locked-black",
  SurfaceAccentEmphasisMediumNegative: "--surface-accent-emphasis-medium-negative",
  SurfaceAccentEmphasisMediumPositive: "--surface-accent-emphasis-medium-positive",
  SurfaceAccentEmphasisHighInfo: "--surface-accent-emphasis-high-info",
  SurfaceAccentEmphasisHighNegative: "--surface-accent-emphasis-high-negative",
  SurfaceAccentEmphasisHighWarning: "--surface-accent-emphasis-high-warning",
  SurfaceAccentEmphasisHighPositive: "--surface-accent-emphasis-high-positive",
  SurfaceAccentEmphasisHighPurple: "--surface-accent-emphasis-high-purple",
  SurfaceOpacityBasicHover: "--surface-opacity-basic-hover",
  SurfaceOpacityBasicActive: "--surface-opacity-basic-active",
  SurfaceOpacityInvertHover: "--surface-opacity-invert-hover",
  SurfaceOpacityInvertActive: "--surface-opacity-invert-active",
  SurfaceGradient01: "--surface-gradient-01",
  SurfaceGradient02: "--surface-gradient-02",
  SurfaceGradient03: "--surface-gradient-03",
  SurfaceGradient04: "--surface-gradient-04",
  SurfaceGradient05: "--surface-gradient-05",
  SurfaceGradient06: "--surface-gradient-06",
  SurfaceGradient07: "--surface-gradient-07",
  SurfaceGradient08: "--surface-gradient-08",
  SurfaceGradient09: "--surface-gradient-09",
  SurfaceGradient10: "--surface-gradient-10",
  SurfaceGradient11: "--surface-gradient-11",
  SurfaceGradient12: "--surface-gradient-12",
  SurfaceGradient13: "--surface-gradient-13",
  SurfaceGradient14: "--surface-gradient-14",
  SurfaceOtherOverlay: "--surface-other-overlay",
  SurfaceOtherAgent: "--surface-other-agent",
  SurfaceOtherAgentHover: "--surface-other-agent-hover",
  SurfaceOtherSkeleton: "--surface-other-skeleton",
  SurfaceOtherInternalNoteHover: "--surface-other-internal-note-hover",
  SurfaceOtherVisitor: "--surface-other-visitor",
  SurfaceOtherVisitorHover: "--surface-other-visitor-hover",
  ContentBasicPrimary: "--content-basic-primary",
  ContentBasicSecondary: "--content-basic-secondary",
  ContentBasicDisabled: "--content-basic-disabled",
  ContentBasicNegative: "--content-basic-negative",
  ContentBasicWarning: "--content-basic-warning",
  ContentBasicPositive: "--content-basic-positive",
  ContentBasicInfo: "--content-basic-info",
  ContentBasicPurple: "--content-basic-purple",
  ContentBasicGradient01: "--content-basic-gradient-01",
  ContentLockedWhite: "--content-locked-white",
  ContentLockedBlack: "--content-locked-black",
  ContentLockedDefault: "--content-locked-default",
  ContentLockedHover: "--content-locked-hover",
  ContentLockedActive: "--content-locked-active",
  ContentLockedDisabled: "--content-locked-disabled",
  ContentInvertPrimary: "--content-invert-primary",
  ContentInvertSecondary: "--content-invert-secondary",
  ContentInvertDisabled: "--content-invert-disabled",
  ContentInvertGradient01: "--content-invert-gradient-01",
  BorderBasicPrimary: "--border-basic-primary",
  BorderBasicSecondary: "--border-basic-secondary",
  BorderBasicTertiary: "--border-basic-tertiary",
  BorderBasicHover: "--border-basic-hover",
  BorderBasicDisabled: "--border-basic-disabled",
  BorderBasicNegative: "--border-basic-negative",
  BorderBasicWarning: "--border-basic-warning",
  BorderBasicPositive: "--border-basic-positive",
  BorderBasicInfo: "--border-basic-info",
  BorderBasicPurple: "--border-basic-purple",
  BorderBasicContrast: "--border-basic-contrast",
  BorderInvertPrimary: "--border-invert-primary",
  BorderInvertSecondary: "--border-invert-secondary",
  BorderInvertHover: "--border-invert-hover",
  BorderInvertDisabled: "--border-invert-disabled",
  ActionPrimaryActive: "--action-primary-active",
  ActionPrimaryHover: "--action-primary-hover",
  ActionPrimaryDefault: "--action-primary-default",
  ColorActionDefaultRgb: "--color-action-default-rgb",
  ActionPrimaryDisabled: "--action-primary-disabled",
  ActionNegativeActive: "--action-negative-active",
  ActionNegativeHover: "--action-negative-hover",
  ActionNegativeDefault: "--action-negative-default",
  ActionNegativeDisabled: "--action-negative-disabled",
  ActionWarningDefault: "--action-warning-default",
  ActionWarningHover: "--action-warning-hover",
  ActionWarningDisabled: "--action-warning-disabled",
  ActionPositiveDefault: "--action-positive-default",
  ActionPositiveHover: "--action-positive-hover",
  ActionPositiveDisabled: "--action-positive-disabled",
  ActionNeutralDefault: "--action-neutral-default",
  ActionNeutralHover: "--action-neutral-hover",
  ActionNeutralDisabled: "--action-neutral-disabled",
  ActionHighContrastDefault: "--action-high-contrast-default",
  ActionHighContrastHover: "--action-high-contrast-hover",
  ActionHighContrastActive: "--action-high-contrast-active",
  ActionHighContrastDisabled: "--action-high-contrast-disabled",
  SurfaceOtherBot: "--surface-other-bot",
  SurfaceOtherBotHover: "--surface-other-bot-hover",
  ColorBlack: "--color-black",
  ColorWhite: "--color-white",
  DecorBlue900: "--decor-blue900",
  DecorBlue800: "--decor-blue800",
  DecorBlue700: "--decor-blue700",
  DecorBlue600: "--decor-blue600",
  DecorBlue500: "--decor-blue500",
  DecorBlue400: "--decor-blue400",
  DecorBlue300: "--decor-blue300",
  DecorBlue200: "--decor-blue200",
  DecorBlue100: "--decor-blue100",
  DecorBlue50: "--decor-blue50",
  DecorOrange900: "--decor-orange900",
  DecorOrange800: "--decor-orange800",
  DecorOrange700: "--decor-orange700",
  DecorOrange600: "--decor-orange600",
  DecorOrange500: "--decor-orange500",
  DecorOrange400: "--decor-orange400",
  DecorOrange300: "--decor-orange300",
  DecorOrange200: "--decor-orange200",
  DecorOrange100: "--decor-orange100",
  DecorOrange50: "--decor-orange50",
  DecorYellow900: "--decor-yellow900",
  DecorYellow800: "--decor-yellow800",
  DecorYellow700: "--decor-yellow700",
  DecorYellow600: "--decor-yellow600",
  DecorYellow500: "--decor-yellow500",
  DecorYellow400: "--decor-yellow400",
  DecorYellow300: "--decor-yellow300",
  DecorYellow200: "--decor-yellow200",
  DecorYellow100: "--decor-yellow100",
  DecorYellow50: "--decor-yellow50",
  DecorGray950: "--decor-gray950",
  DecorGray900: "--decor-gray900",
  DecorGray800: "--decor-gray800",
  DecorGray700: "--decor-gray700",
  DecorGray600: "--decor-gray600",
  DecorGray500: "--decor-gray500",
  DecorGray400: "--decor-gray400",
  DecorGray300: "--decor-gray300",
  DecorGray200: "--decor-gray200",
  DecorGray150: "--decor-gray150",
  DecorGray100: "--decor-gray100",
  DecorGray75: "--decor-gray75",
  DecorGray50: "--decor-gray50",
  DecorGray40: "--decor-gray40",
  DecorGray20: "--decor-gray20",
  DecorGreen900: "--decor-green900",
  DecorGreen800: "--decor-green800",
  DecorGreen700: "--decor-green700",
  DecorGreen600: "--decor-green600",
  DecorGreen500: "--decor-green500",
  DecorGreen400: "--decor-green400",
  DecorGreen300: "--decor-green300",
  DecorGreen200: "--decor-green200",
  DecorGreen100: "--decor-green100",
  DecorGreen50: "--decor-green50",
  DecorRed900: "--decor-red900",
  DecorRed800: "--decor-red800",
  DecorRed700: "--decor-red700",
  DecorRed600: "--decor-red600",
  DecorRed500: "--decor-red500",
  DecorRed400: "--decor-red400",
  DecorRed300: "--decor-red300",
  DecorRed200: "--decor-red200",
  DecorRed100: "--decor-red100",
  DecorRed50: "--decor-red50",
  DecorPurple900: "--decor-purple900",
  DecorPurple800: "--decor-purple800",
  DecorPurple700: "--decor-purple700",
  DecorPurple600: "--decor-purple600",
  DecorPurple500: "--decor-purple500",
  DecorPurple400: "--decor-purple400",
  DecorPurple300: "--decor-purple300",
  DecorPurple200: "--decor-purple200",
  DecorPurple100: "--decor-purple100",
  DecorPurple50: "--decor-purple50",
  DecorBrown50: "--decor-brown50",
  DecorBrown300: "--decor-brown300",
  ProductsLivechat: "--products-livechat",
  ProductsHelpdesk: "--products-helpdesk",
  ProductsChatbot: "--products-chatbot",
  ProductsKnowledgebase: "--products-knowledgebase",
  IllustrationsPrimary: "--illustrations-primary",
  IllustrationsSecondary: "--illustrations-secondary",
  IllustrationsStroke: "--illustrations-stroke",
  TagSurface01: "--tag-surface-01",
  TagContent01: "--tag-content-01",
  BtnBasicBackgroundEnabled: "--btn-basic-background-enabled",
  BtnBasicBackgroundHover: "--btn-basic-background-hover",
  BtnBasicBackgroundDisabled: "--btn-basic-background-disabled",
  BtnBasicBackgroundActive: "--btn-basic-background-active",
  BtnBasicBackgroundLoading: "--btn-basic-background-loading",
  BtnSecondaryBackgroundEnabled: "--btn-secondary-background-enabled",
  BtnSecondaryBackgroundHover: "--btn-secondary-background-hover",
  BtnSecondaryBackgroundDisabled: "--btn-secondary-background-disabled",
  BtnSecondaryBackgroundActive: "--btn-secondary-background-active",
  BtnSecondaryBackgroundLoading: "--btn-secondary-background-loading",
  BtnPlainIconBackgroundHover: "--btn-plain-icon-background-hover",
  BtnPlainIconBackgroundActive: "--btn-plain-icon-background-active",
  PickerListBackground: "--picker-list-background",
  PickerListGroupBackground: "--picker-list-group-background",
  PickerListOptionBackgroundHover: "--picker-list-option-background-hover",
  PickerListOptionBackgroundActiveHover: "--picker-list-option-background-active-hover",
  PickerListOptionBackgroundFocus: "--picker-list-option-background-focus",
  PickerListOptionBackgroundActive: "--picker-list-option-background-active",
  PopoverBackground: "--popover-background",
  SurfaceAvatar1: "--surface-avatar-1",
  SurfaceAvatar2: "--surface-avatar-2",
  SurfaceAvatar3: "--surface-avatar-3",
  SurfaceAvatar4: "--surface-avatar-4",
  SurfaceAvatar5: "--surface-avatar-5",
  SurfaceAvatar6: "--surface-avatar-6",
  SurfaceAvatar7: "--surface-avatar-7",
  SurfaceAvatar8: "--surface-avatar-8",
  SurfaceAvatar9: "--surface-avatar-9",
  SurfaceAvatar10: "--surface-avatar-10",
  NavbarBackground: "--navbar-background",
  TooltipBackgroundBasic: "--tooltip-background-basic",
  TooltipBackgroundInvert: "--tooltip-background-invert",
  TooltipBorder: "--tooltip-border",
  TooltipBorderForSvg: "--tooltip-border-for-svg",
  AnimatedGradientValue1: "--animated-gradient-value-1",
  AnimatedGradientValue2: "--animated-gradient-value-2",
  AnimatedGradientValue3: "--animated-gradient-value-3",
  ContentBasicInternalNote: "--content-basic-internal-note",
  ContentBasicBot: "--content-basic-bot",
  ActionLockDefault: "--action-lock-default",
  ActionLockHover: "--action-lock-hover",
  ActionLockActive: "--action-lock-active",
  ActionLockDisabled: "--action-lock-disabled",
  SurfaceOtherInternalNoteMessageArea: "--surface-other-internal-note-message-area",
  SurfaceOtherInternalNoteDefault: "--surface-other-internal-note-default",
  ContentBasicInternalNoteMessagePlaceholder: "--content-basic-internal-note-message-placeholder",
  ContentBasicInternalNoteMessageActive: "--content-basic-internal-note-message-active",
  OnePopoverMessageBackgroundDefault: "--one-popover-message-background-default",
  OnePopoverBorderDefault: "--one-popover-border-default",
  OnePopoverBorderActive: "--one-popover-border-active",
  OneTooltipBackground: "--one-tooltip-background",
  ContentBasicAutofill: "--content-basic-autofill",
  ProductsHello: "--products-hello",
  ProductsPlatform: "--products-platform",
  SurfaceCheckListItemOpenBackground: "--surface-check-list-item-open-background",
  SurfaceCheckListBackground: "--surface-check-list-background",
  ContentBasicPlaceholder: "--content-basic-placeholder",
  InputPromoBorderDefault: "--input-promo-border-default",
  InputPromoBorderHover: "--input-promo-border-hover",
  SurfaceAiCopilotBasicDefault: "--surface-ai-copilot-basic-default",
  SurfaceAiCopilotBasicHover: "--surface-ai-copilot-basic-hover",
  SurfaceAiCopilotBasicActive: "--surface-ai-copilot-basic-active",
  SurfaceAiCopilotInvert01: "--surface-ai-copilot-invert-01",
  SurfaceAiCopilotInvert02: "--surface-ai-copilot-invert-02",
  SurfaceAiOther01Default: "--surface-ai-other-01-default",
  SurfaceAiOther01Hover: "--surface-ai-other-01-hover",
  SurfaceAiOther01Active: "--surface-ai-other-01-active",
  SurfaceAiOther02Default: "--surface-ai-other-02-default",
  BorderAiCopilotBasicDefault: "--border-ai-copilot-basic-default",
  BorderAiCopilotBasicHover: "--border-ai-copilot-basic-hover",
  BorderAiCopilotBasicActive: "--border-ai-copilot-basic-active",
  BorderAiOther01: "--border-ai-other-01",
  ContentAiCopilotBasic: "--content-ai-copilot-basic",
  ContentAiCopilotInvert: "--content-ai-copilot-invert",
  ContentAiOther1Default: "--content-ai-other-1-default",
  CategoricalMain1: "--categorical-main-1",
  CategoricalMain2: "--categorical-main-2",
  CategoricalMain3: "--categorical-main-3",
  CategoricalMain4: "--categorical-main-4",
  CategoricalMain5: "--categorical-main-5",
  CategoricalMain6: "--categorical-main-6",
  CategoricalMain7: "--categorical-main-7",
  CategoricalMain8: "--categorical-main-8",
  CategoricalMain9: "--categorical-main-9",
  CategoricalMain10: "--categorical-main-10",
  CategoricalMain11: "--categorical-main-11",
  CategoricalMain12: "--categorical-main-12",
  CategoricalMain13: "--categorical-main-13",
  CategoricalMain14: "--categorical-main-14",
  SequentialBlue25: "--sequential-blue-25",
  SequentialBlue50: "--sequential-blue-50",
  SequentialBlue100: "--sequential-blue-100",
  SequentialBlue200: "--sequential-blue-200",
  SequentialBlue300: "--sequential-blue-300",
  SequentialBlue400: "--sequential-blue-400",
  SequentialBlue500: "--sequential-blue-500",
  SequentialBlue600: "--sequential-blue-600",
  SequentialBlue700: "--sequential-blue-700",
  SequentialBlue800: "--sequential-blue-800",
  SequentialBlue900: "--sequential-blue-900",
  SequentialBlue950: "--sequential-blue-950",
  SequentialYellow25: "--sequential-yellow-25",
  SequentialYellow50: "--sequential-yellow-50",
  SequentialYellow100: "--sequential-yellow-100",
  SequentialYellow200: "--sequential-yellow-200",
  SequentialYellow300: "--sequential-yellow-300",
  SequentialYellow400: "--sequential-yellow-400",
  SequentialYellow500: "--sequential-yellow-500",
  SequentialYellow600: "--sequential-yellow-600",
  SequentialYellow700: "--sequential-yellow-700",
  SequentialYellow800: "--sequential-yellow-800",
  SequentialYellow900: "--sequential-yellow-900",
  SequentialYellow950: "--sequential-yellow-950",
  SequentialGreen25: "--sequential-green-25",
  SequentialGreen50: "--sequential-green-50",
  SequentialGreen100: "--sequential-green-100",
  SequentialGreen200: "--sequential-green-200",
  SequentialGreen300: "--sequential-green-300",
  SequentialGreen400: "--sequential-green-400",
  SequentialGreen500: "--sequential-green-500",
  SequentialGreen600: "--sequential-green-600",
  SequentialGreen700: "--sequential-green-700",
  SequentialGreen800: "--sequential-green-800",
  SequentialGreen900: "--sequential-green-900",
  SequentialGreen950: "--sequential-green-950",
  SequentialMagenta25: "--sequential-magenta-25",
  SequentialMagenta50: "--sequential-magenta-50",
  SequentialMagenta100: "--sequential-magenta-100",
  SequentialMagenta200: "--sequential-magenta-200",
  SequentialMagenta300: "--sequential-magenta-300",
  SequentialMagenta400: "--sequential-magenta-400",
  SequentialMagenta500: "--sequential-magenta-500",
  SequentialMagenta600: "--sequential-magenta-600",
  SequentialMagenta700: "--sequential-magenta-700",
  SequentialMagenta800: "--sequential-magenta-800",
  SequentialMagenta900: "--sequential-magenta-900",
  SequentialMagenta950: "--sequential-magenta-950",
  SequentialOrange25: "--sequential-orange-25",
  SequentialOrange50: "--sequential-orange-50",
  SequentialOrange100: "--sequential-orange-100",
  SequentialOrange200: "--sequential-orange-200",
  SequentialOrange300: "--sequential-orange-300",
  SequentialOrange400: "--sequential-orange-400",
  SequentialOrange500: "--sequential-orange-500",
  SequentialOrange600: "--sequential-orange-600",
  SequentialOrange700: "--sequential-orange-700",
  SequentialOrange800: "--sequential-orange-800",
  SequentialOrange900: "--sequential-orange-900",
  SequentialOrange950: "--sequential-orange-950",
  SequentialPurple25: "--sequential-purple-25",
  SequentialPurple50: "--sequential-purple-50",
  SequentialPurple100: "--sequential-purple-100",
  SequentialPurple200: "--sequential-purple-200",
  SequentialPurple300: "--sequential-purple-300",
  SequentialPurple400: "--sequential-purple-400",
  SequentialPurple500: "--sequential-purple-500",
  SequentialPurple600: "--sequential-purple-600",
  SequentialPurple700: "--sequential-purple-700",
  SequentialPurple800: "--sequential-purple-800",
  SequentialPurple900: "--sequential-purple-900",
  SequentialPurple950: "--sequential-purple-950",
  SequentialRed25: "--sequential-red-25",
  SequentialRed50: "--sequential-red-50",
  SequentialRed100: "--sequential-red-100",
  SequentialRed200: "--sequential-red-200",
  SequentialRed300: "--sequential-red-300",
  SequentialRed400: "--sequential-red-400",
  SequentialRed500: "--sequential-red-500",
  SequentialRed600: "--sequential-red-600",
  SequentialRed700: "--sequential-red-700",
  SequentialRed800: "--sequential-red-800",
  SequentialRed900: "--sequential-red-900",
  SequentialRed950: "--sequential-red-950",
  Categorical1colorColor1: "--categorical-1color-color1",
  Categorical1colorColor2: "--categorical-1color-color2",
  Categorical1colorColor3: "--categorical-1color-color3",
  Categorical1colorColor4: "--categorical-1color-color4",
  Categorical2colorsOption1Color1: "--categorical-2colors-option1-color1",
  Categorical2colorsOption1Color2: "--categorical-2colors-option1-color2",
  Categorical2colorsOption2Color1: "--categorical-2colors-option2-color1",
  Categorical2colorsOption2Color2: "--categorical-2colors-option2-color2",
  Categorical2colorsOption3Color1: "--categorical-2colors-option3-color1",
  Categorical2colorsOption3Color2: "--categorical-2colors-option3-color2",
  Categorical2colorsOption4Color1: "--categorical-2colors-option4-color1",
  Categorical2colorsOption4Color2: "--categorical-2colors-option4-color2",
  Categorical2colorsOption5Color1: "--categorical-2colors-option5-color1",
  Categorical2colorsOption5Color2: "--categorical-2colors-option5-color2",
  Categorical2colorsOption6Color1: "--categorical-2colors-option6-color1",
  Categorical2colorsOption6Color2: "--categorical-2colors-option6-color2",
  Categorical3colorsOption1Color1: "--categorical-3colors-option1-color1",
  Categorical3colorsOption1Color2: "--categorical-3colors-option1-color2",
  Categorical3colorsOption1Color3: "--categorical-3colors-option1-color3",
  Categorical3colorsOption2Color1: "--categorical-3colors-option2-color1",
  Categorical3colorsOption2Color2: "--categorical-3colors-option2-color2",
  Categorical3colorsOption2Color3: "--categorical-3colors-option2-color3",
  Categorical3colorsOption3Color1: "--categorical-3colors-option3-color1",
  Categorical3colorsOption3Color2: "--categorical-3colors-option3-color2",
  Categorical3colorsOption3Color3: "--categorical-3colors-option3-color3",
  Categorical3colorsOption4Color1: "--categorical-3colors-option4-color1",
  Categorical3colorsOption4Color2: "--categorical-3colors-option4-color2",
  Categorical3colorsOption4Color3: "--categorical-3colors-option4-color3",
  Categorical3colorsOption5Color1: "--categorical-3colors-option5-color1",
  Categorical3colorsOption5Color2: "--categorical-3colors-option5-color2",
  Categorical3colorsOption5Color3: "--categorical-3colors-option5-color3",
  Categorical3colorsOption6Color1: "--categorical-3colors-option6-color1",
  Categorical3colorsOption6Color2: "--categorical-3colors-option6-color2",
  Categorical3colorsOption6Color3: "--categorical-3colors-option6-color3",
  Categorical4colorsOption1Color1: "--categorical-4colors-option1-color1",
  Categorical4colorsOption1Color2: "--categorical-4colors-option1-color2",
  Categorical4colorsOption1Color3: "--categorical-4colors-option1-color3",
  Categorical4colorsOption1Color4: "--categorical-4colors-option1-color4",
  Categorical4colorsOption2Color1: "--categorical-4colors-option2-color1",
  Categorical4colorsOption2Color2: "--categorical-4colors-option2-color2",
  Categorical4colorsOption2Color3: "--categorical-4colors-option2-color3",
  Categorical4colorsOption2Color4: "--categorical-4colors-option2-color4",
  Categorical4colorsOption3Color1: "--categorical-4colors-option3-color1",
  Categorical4colorsOption3Color2: "--categorical-4colors-option3-color2",
  Categorical4colorsOption3Color3: "--categorical-4colors-option3-color3",
  Categorical4colorsOption3Color4: "--categorical-4colors-option3-color4",
  Categorical5colorsOption1Color1: "--categorical-5colors-option1-color1",
  Categorical5colorsOption1Color2: "--categorical-5colors-option1-color2",
  Categorical5colorsOption1Color3: "--categorical-5colors-option1-color3",
  Categorical5colorsOption1Color4: "--categorical-5colors-option1-color4",
  Categorical5colorsOption1Color5: "--categorical-5colors-option1-color5",
  Categorical5colorsOption2Color1: "--categorical-5colors-option2-color1",
  Categorical5colorsOption2Color2: "--categorical-5colors-option2-color2",
  Categorical5colorsOption2Color3: "--categorical-5colors-option2-color3",
  Categorical5colorsOption2Color4: "--categorical-5colors-option2-color4",
  Categorical5colorsOption2Color5: "--categorical-5colors-option2-color5",
  UifoundationSurfaceDefault: "--uifoundation-surface-default",
  UifoundationBorderGrid: "--uifoundation-border-grid",
  UifoundationBorderAxis: "--uifoundation-border-axis"
}, Wd = {
  Spacing0: "--spacing-0",
  Spacing05: "--spacing-05",
  Spacing1: "--spacing-1",
  Spacing2: "--spacing-2",
  Spacing3: "--spacing-3",
  Spacing4: "--spacing-4",
  Spacing5: "--spacing-5",
  Spacing6: "--spacing-6",
  Spacing7: "--spacing-7",
  Spacing8: "--spacing-8",
  Spacing9: "--spacing-9",
  Spacing10: "--spacing-10",
  Spacing11: "--spacing-11",
  Spacing12: "--spacing-12",
  Spacing14: "--spacing-14",
  Spacing16: "--spacing-16",
  Spacing18: "--spacing-18",
  Spacing20: "--spacing-20",
  Spacing24: "--spacing-24"
}, Kd = {
  Float: "--shadow-float",
  PopOver: "--shadow-pop-over",
  Modal: "--shadow-modal",
  Tooltip: "--shadow-tooltip",
  TooltipArrowBottom: "--shadow-tooltip-arrow-bottom",
  TooltipArrowTop: "--shadow-tooltip-arrow-top",
  TooltipArrowRight: "--shadow-tooltip-arrow-right",
  TooltipArrowLeft: "--shadow-tooltip-arrow-left",
  TooltipArrow: "--shadow-tooltip-arrow",
  Focus: "--shadow-focus",
  DividerBottom: "--shadow-divider-bottom",
  DividerTop: "--shadow-divider-top",
  DividerRight: "--shadow-divider-right",
  DividerLeft: "--shadow-divider-left",
  DividerBottomLeft: "--shadow-divider-bottom-left",
  DividerTopLeft: "--shadow-divider-top-left",
  DividerTopRight: "--shadow-divider-top-right",
  DividerBottomRight: "--shadow-divider-bottom-right",
  MessageBox: "--shadow-message-box",
  FixedRight: "--shadow-fixed-right",
  FixedLeft: "--shadow-fixed-left",
  FixedTop: "--shadow-fixed-top",
  FixedBottom: "--shadow-fixed-bottom",
  ShadowAiCopilotAnimationStart: "--shadow-ai-copilot-animation-start",
  ShadowAiCopilotAnimationMedium1: "--shadow-ai-copilot-animation-medium1",
  ShadowAiCopilotAnimationMedium2: "--shadow-ai-copilot-animation-medium2",
  ShadowAiCopilotAnimationMedium3: "--shadow-ai-copilot-animation-medium3",
  ShadowAiCopilotAnimationEnd: "--shadow-ai-copilot-animation-end",
  ShadowAiOtherFloat: "--shadow-ai-other-float",
  ShadowAiOtherActiveField: "--shadow-ai-other-active-field",
  ShadowTourAnimationEnd: "--shadow-tour-animation-end"
}, Yd = {
  Radius0: "--radius-0",
  Radius1: "--radius-1",
  Radius2: "--radius-2",
  Radius3: "--radius-3",
  Radius4: "--radius-4",
  UiFoundationRadiusBar: "--uifoundation-radius-bar",
  0: "--radius-0",
  // deprecated
  1: "--radius-1",
  // deprecated
  2: "--radius-2",
  // deprecated
  3: "--radius-3",
  // deprecated
  4: "--radius-4"
  // deprecated
}, Xd = {
  Fast1: "--transition-duration-fast-1",
  Fast2: "--transition-duration-fast-2",
  Moderate1: "--transition-duration-moderate-1"
}, Zd = {
  EaseIn: "--transition-timing-ease-in",
  EaseOut: "--transition-timing-ease-out"
}, jd = {
  Instant: "--delay-instant",
  Moderate: "--delay-moderate",
  Slow: "--delay-slow"
};
var jt = /* @__PURE__ */ ((e) => (e.Dark = "lc-dark-theme", e.Light = "lc-light-theme", e))(jt || {});
const Jd = (e) => e === "dark" ? jt.Dark : jt.Light, E_ = g_(void 0), Qd = () => {
  const e = h_(E_);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}, eu = ({
  children: e,
  initialTheme: t = "light",
  customVariables: r = {}
}) => {
  const [o, _] = ce(t), [l, i] = ce(r);
  z(() => {
    document.body.classList.remove(jt.Light, jt.Dark), document.body.classList.add(`lc-${o}-theme`);
    for (const [d, s] of Object.entries(l))
      document.body.style.setProperty(d, s);
  }, [o, l]);
  const n = ka(
    () => ({
      theme: o,
      toggleTheme: () => _((d) => d === "light" ? "dark" : "light"),
      setTheme: _,
      setCustomVariables: (d) => {
        i(d);
      }
    }),
    [o, _, i]
  );
  return /* @__PURE__ */ a(E_.Provider, { value: n, children: e });
}, T_ = b.createContext(
  void 0
), To = () => {
  const e = b.useContext(T_);
  if (!e)
    throw new Error("useAppFrame must be used within a AppFrameProvider");
  return e;
}, ni = ({
  children: e,
  isSideNavigationVisible: t = !0,
  isMobileViewVisible: r = !1
}) => {
  const [o, _] = b.useState(t), [l, i] = b.useState(r), n = b.useMemo(
    () => ({
      isSideNavigationVisible: o,
      toggleSideNavigationVisibility: () => _(!o),
      isMobileViewEnabled: l,
      setIsMobileViewEnabled: (d) => i(d)
    }),
    [
      o,
      _,
      l,
      i
    ]
  );
  return /* @__PURE__ */ a(T_.Provider, { value: n, children: e });
}, tu = (e, t) => `color-mix(in srgb, var(${e}) ${t}, transparent)`, ci = "lc-Icon-module__icon___J5RH5", Ho = {
  icon: ci,
  "icon--primary": "lc-Icon-module__icon--primary___lclud",
  "icon--subtle": "lc-Icon-module__icon--subtle___d17Qj",
  "icon--inverted": "lc-Icon-module__icon--inverted___Cb4ml",
  "icon--inverted-subtle": "lc-Icon-module__icon--inverted-subtle___kw-gq",
  "icon--link": "lc-Icon-module__icon--link___TM17Q",
  "icon--success": "lc-Icon-module__icon--success___Jbdc3",
  "icon--warning": "lc-Icon-module__icon--warning___2xp2W",
  "icon--error": "lc-Icon-module__icon--error___95ah2",
  "icon--negative": "lc-Icon-module__icon--negative___Ds5e2",
  "icon--positive": "lc-Icon-module__icon--positive___Uy-GO",
  "icon--info": "lc-Icon-module__icon--info___sIO63",
  "icon--action-primary": "lc-Icon-module__icon--action-primary___iKKt4",
  "icon--action-negative": "lc-Icon-module__icon--action-negative___n9ONx",
  "icon--action-positive": "lc-Icon-module__icon--action-positive___Xq7UP",
  "icon--action-warning": "lc-Icon-module__icon--action-warning___UsFlk",
  "icon--action-neutral": "lc-Icon-module__icon--action-neutral___Hhno9",
  "icon--disabled--primary": "lc-Icon-module__icon--disabled--primary___M6mL2",
  "icon--disabled--subtle": "lc-Icon-module__icon--disabled--subtle___gs7xm",
  "icon--disabled--inverted": "lc-Icon-module__icon--disabled--inverted___SJMuj",
  "icon--disabled--inverted-subtle": "lc-Icon-module__icon--disabled--inverted-subtle___4YUA4",
  "icon--disabled--link": "lc-Icon-module__icon--disabled--link___sLus3",
  "icon--disabled--success": "lc-Icon-module__icon--disabled--success___XqRSR",
  "icon--disabled--warning": "lc-Icon-module__icon--disabled--warning___72dUP",
  "icon--disabled--error": "lc-Icon-module__icon--disabled--error___-0U0g",
  "icon--disabled--negative": "lc-Icon-module__icon--disabled--negative___V7paN",
  "icon--disabled--positive": "lc-Icon-module__icon--disabled--positive___X0-e0",
  "icon--disabled--info": "lc-Icon-module__icon--disabled--info___IlUe5",
  "icon--disabled--action-primary": "lc-Icon-module__icon--disabled--action-primary___4GYxP",
  "icon--disabled--action-negative": "lc-Icon-module__icon--disabled--action-negative___WP3Hi",
  "icon--disabled--action-positive": "lc-Icon-module__icon--disabled--action-positive___3Gz5e",
  "icon--disabled--action-warning": "lc-Icon-module__icon--disabled--action-warning___GHGY2",
  "icon--disabled--action-neutral": "lc-Icon-module__icon--disabled--action-neutral___a53XD",
  "icon--disabled--lock-black": "lc-Icon-module__icon--disabled--lock-black___JaNzw"
}, si = {
  xsmall: {
    width: 12,
    height: 12
  },
  small: {
    width: 16,
    height: 16
  },
  medium: {
    width: 20,
    height: 20
  },
  large: {
    width: 24,
    height: 24
  },
  xlarge: {
    width: 32,
    height: 32
  },
  xxlarge: {
    width: 48,
    height: 48
  },
  xxxlarge: {
    width: 64,
    height: 64
  }
}, zo = "icon", R = (e) => {
  const c = e, {
    source: t,
    size: r = "medium",
    kind: o,
    disabled: _,
    className: l,
    customColor: i
  } = c, n = U(c, [
    "source",
    "size",
    "kind",
    "disabled",
    "className",
    "customColor"
  ]), d = b.createElement(t, v(v({}, si[r]), i ? { color: i } : {})), s = u(
    l,
    Ho[zo],
    o && Ho[`${zo}--${_ ? "disabled--" : ""}${o}`]
  );
  return /* @__PURE__ */ a("span", B(v({}, n), { className: s, children: d }));
}, lt = {
  "heading-xl": "lc-Typography-module__heading-xl___jTpRq",
  "heading-lg": "lc-Typography-module__heading-lg___VGjgP",
  "heading-md": "lc-Typography-module__heading-md___U-DUC",
  "heading-sm": "lc-Typography-module__heading-sm___SgG32",
  "heading-xs": "lc-Typography-module__heading-xs___cKzMb",
  "heading-2xs": "lc-Typography-module__heading-2xs___K6Lmw",
  "heading-3xs": "lc-Typography-module__heading-3xs___roTs0",
  "heading-uppercase": "lc-Typography-module__heading-uppercase___DC8Ro",
  "heading-bold": "lc-Typography-module__heading-bold___5Ez7T",
  "paragraph-lg": "lc-Typography-module__paragraph-lg___KmMBe",
  "paragraph-md": "lc-Typography-module__paragraph-md___Ogs8k",
  "paragraph-sm": "lc-Typography-module__paragraph-sm___5KRhm",
  "paragraph-xs": "lc-Typography-module__paragraph-xs___TlVSn",
  "paragraph--semi-bold": "lc-Typography-module__paragraph--semi-bold___Ya1Sm",
  "paragraph--bold": "lc-Typography-module__paragraph--bold___HVepi",
  "paragraph--underline": "lc-Typography-module__paragraph--underline___M3l4C",
  "paragraph--strike": "lc-Typography-module__paragraph--strike___gmYoG",
  "paragraph--uppercase": "lc-Typography-module__paragraph--uppercase___8bXNL",
  "paragraph--no-margin": "lc-Typography-module__paragraph--no-margin___7wc0Y",
  "display-md": "lc-Typography-module__display-md___i1Zgu",
  "display-sm": "lc-Typography-module__display-sm___f46hM",
  "display-lg": "lc-Typography-module__display-lg___wAcSa",
  "display-max": "lc-Typography-module__display-max___W4YZ0",
  "display--bold": "lc-Typography-module__display--bold___tIiWp"
}, di = {
  xl: "h1",
  lg: "h2",
  md: "h3",
  sm: "h4",
  xs: "h5",
  "2xs": "h6",
  // HTML only provides h1-h6 elements, so smaller heading sizes reuse h6
  "3xs": "h6"
}, pe = (s) => {
  var c = s, {
    as: e,
    size: t = "md",
    children: r,
    className: o,
    uppercase: _,
    bold: l,
    customColor: i,
    textAlign: n
  } = c, d = U(c, [
    "as",
    "size",
    "children",
    "className",
    "uppercase",
    "bold",
    "customColor",
    "textAlign"
  ]);
  return b.createElement(
    e || di[t],
    v({
      className: u(
        {
          [lt[`heading-${t}`]]: !0,
          [lt["heading-uppercase"]]: _,
          [lt["heading-bold"]]: l
        },
        o
      ),
      style: v(v({}, i && { color: i }), n && { textAlign: n })
    }, d),
    r
  );
}, F = (g) => {
  var y = g, {
    as: e = "p",
    size: t = "md",
    caps: r = !1,
    uppercase: o = !1,
    bold: _ = !1,
    semiBold: l = !1,
    underline: i = !1,
    strike: n = !1,
    children: d,
    className: s,
    customColor: c,
    textAlign: p,
    noMargin: m
  } = y, f = U(y, [
    "as",
    "size",
    "caps",
    "uppercase",
    "bold",
    "semiBold",
    "underline",
    "strike",
    "children",
    "className",
    "customColor",
    "textAlign",
    "noMargin"
  ]);
  const x = "paragraph";
  return b.createElement(
    e,
    v({
      className: u(
        {
          [lt[`${x}-${t}`]]: !0,
          [lt[`${x}--semi-bold`]]: l && !_,
          [lt[`${x}--bold`]]: _ && !l,
          [lt[`${x}--strike`]]: n,
          [lt[`${x}--underline`]]: i,
          [lt[`${x}--uppercase`]]: o || r,
          [lt[`${x}--no-margin`]]: m
        },
        s
      ),
      style: v(v({}, c && { color: c }), p && { textAlign: p })
    }, f),
    d
  );
}, Vo = (d) => {
  var s = d, {
    as: e = "div",
    size: t = "md",
    children: r,
    className: o,
    customColor: _,
    textAlign: l,
    bold: i = !0
  } = s, n = U(s, [
    "as",
    "size",
    "children",
    "className",
    "customColor",
    "textAlign",
    "bold"
  ]);
  return b.createElement(
    e,
    v({
      className: u(
        lt[`display-${t}`],
        {
          [lt["display--bold"]]: i
        },
        o
      ),
      style: v(v({}, _ && { color: _ }), l && { textAlign: l })
    }, n),
    r
  );
}, au = [
  "xl",
  "lg",
  "md",
  "sm",
  "xs",
  "2xs",
  "3xs"
], Sa = {
  "accordion-animated-label": "lc-AccordionAnimatedLabel-module__accordion-animated-label___zYrr7",
  "accordion-animated-label__open": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open___l8gMd",
  "accordion-animated-label__close": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close___c5sxF",
  "accordion-animated-label__open--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open--visible___y16mk",
  "accordion-animated-label__close--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close--visible___JWsqj"
}, xa = "accordion-animated-label", ui = ({
  open: e,
  closed: t,
  isOpen: r
}) => {
  const o = b.useRef(null), _ = b.useRef(null), [l, i] = b.useState(void 0), { isOpen: n, isMounted: d } = la({
    isVisible: r,
    elementRef: o
  }), { isOpen: s, isMounted: c } = la(
    {
      isVisible: !r,
      elementRef: _
    }
  );
  return b.useEffect(() => {
    const p = r ? o.current : _.current;
    if (p) {
      const m = p.getBoundingClientRect().height;
      i(m);
    }
  }, [r, d, c]), /* @__PURE__ */ h(
    "div",
    {
      className: Sa[xa],
      style: { height: l ? `${l}px` : "auto" },
      children: [
        d && /* @__PURE__ */ a(
          "div",
          {
            ref: o,
            className: u(Sa[`${xa}__open`], {
              [Sa[`${xa}__open--visible`]]: n
            }),
            children: e
          }
        ),
        c && /* @__PURE__ */ a(
          "div",
          {
            ref: _,
            className: u(Sa[`${xa}__close`], {
              [Sa[`${xa}__close--visible`]]: s
            }),
            children: t
          }
        )
      ]
    }
  );
}, Wo = {
  "accordion-multiline": "lc-AccordionMultilineElement-module__accordion-multiline___lXTFn",
  "accordion-multiline__inner": "lc-AccordionMultilineElement-module__accordion-multiline__inner___tu-HW"
}, Ko = "accordion-multiline", mi = ({ children: e, isExpanded: t }) => {
  const r = b.useRef(null), { isOpen: o, isMounted: _ } = la({
    isVisible: !t,
    elementRef: r
  }), { size: l, handleResizeRef: i } = x_();
  return /* @__PURE__ */ a(
    "div",
    {
      className: Wo[`${Ko}`],
      style: { maxHeight: o ? l : 0 },
      ref: r,
      children: /* @__PURE__ */ a("div", { ref: i, children: _ && /* @__PURE__ */ a("div", { className: Wo[`${Ko}__inner`], children: e }) })
    }
  );
}, pi = (e) => e.open !== void 0 && e.closed !== void 0, gi = (e, t) => {
  if (pi(e)) {
    const r = {
      open: e.open,
      closed: e.closed,
      isOpen: t
    };
    return /* @__PURE__ */ a(ui, v({}, r));
  }
  return e;
}, hi = ({
  isControlled: e,
  isExpanded: t,
  setShouldBeVisible: r,
  onOpen: o,
  onClose: _
}) => {
  const l = (n) => {
    n ? _ == null || _() : o == null || o(), !e && r(!n);
  }, i = b.useCallback(
    (n) => {
      (!t && (n.key === "Enter" || n.key === " ") || t && n.key === "Escape") && l(t);
    },
    [t, l]
  );
  return {
    handleExpandChange: l,
    handleKeyDown: i
  };
}, fi = "lc-Accordion-module__accordion___wD27Q", bi = "lc-Accordion-module__accordion__chevron___3-rGN", vi = "lc-Accordion-module__accordion__label___1MyYP", ki = "lc-Accordion-module__accordion__content___vfjP2", yi = "lc-Accordion-module__accordion__content__inner___Z-9cB", Ci = "lc-Accordion-module__accordion__footer___KHIrl", be = {
  accordion: fi,
  "accordion--warning": "lc-Accordion-module__accordion--warning___PJg4j",
  "accordion--error": "lc-Accordion-module__accordion--error___rage8",
  "accordion--promo": "lc-Accordion-module__accordion--promo___KYLtP",
  "accordion--open": "lc-Accordion-module__accordion--open___q9p79",
  accordion__chevron: bi,
  "accordion__chevron--open": "lc-Accordion-module__accordion__chevron--open___Yax5V",
  "accordion__chevron--promo": "lc-Accordion-module__accordion__chevron--promo___VXb92",
  accordion__label: vi,
  "accordion__label--promo": "lc-Accordion-module__accordion__label--promo___SDMpV",
  accordion__content: ki,
  accordion__content__inner: yi,
  "accordion__content__inner--open": "lc-Accordion-module__accordion__content__inner--open___BhKjm",
  "accordion__content__inner--promo": "lc-Accordion-module__accordion__content__inner--promo___o4mw9",
  "accordion__content__inner--full-width": "lc-Accordion-module__accordion__content__inner--full-width___HpIN0",
  accordion__footer: Ci,
  "accordion__footer--promo": "lc-Accordion-module__accordion__footer--promo___N1Ebg"
}, B_ = (g) => {
  var y = g, {
    className: e,
    mainClassName: t,
    children: r,
    label: o,
    multilineElement: _,
    openOnInit: l = !1,
    fullWidthContent: i,
    hideChevron: n,
    isOpen: d,
    isPromo: s,
    footer: c,
    onClose: p,
    onOpen: m
  } = y, f = U(y, [
    "className",
    "mainClassName",
    "children",
    "label",
    "multilineElement",
    "openOnInit",
    "fullWidthContent",
    "hideChevron",
    "isOpen",
    "isPromo",
    "footer",
    "onClose",
    "onOpen"
  ]);
  const x = d !== void 0, S = x ? d : l, E = b.useRef(null), {
    isOpen: $,
    isMounted: w,
    setShouldBeVisible: N
  } = la({
    isVisible: S,
    elementRef: E
  }), { size: k, handleResizeRef: C } = x_(), { handleExpandChange: I, handleKeyDown: T } = hi({
    isControlled: x,
    isExpanded: $,
    setShouldBeVisible: N,
    onOpen: m,
    onClose: p
  }), M = u(
    t,
    {
      [be[`${ve}--open`]]: $
    },
    e
  ), A = (D) => {
    const G = D ? pe : F, P = v({
      "aria-expanded": $,
      as: "div",
      className: u(be[`${ve}__label`], {
        [be[`${ve}__label--promo`]]: D
      }),
      onClick: () => I($),
      bold: D ? void 0 : !0
    }, D ? { size: "xs" } : {});
    return /* @__PURE__ */ a(G, B(v({}, P), { children: gi(o, $) }));
  };
  return /* @__PURE__ */ h(
    "div",
    B(v({
      tabIndex: 0,
      "aria-expanded": $,
      className: M,
      onKeyDown: T
    }, f), {
      children: [
        !n && /* @__PURE__ */ a(
          R,
          {
            source: na,
            className: u(be[`${ve}__chevron`], {
              [be[`${ve}__chevron--open`]]: $,
              [be[`${ve}__chevron--promo`]]: s
            })
          }
        ),
        A(s),
        _ && /* @__PURE__ */ a(mi, { isExpanded: $, children: _ }),
        /* @__PURE__ */ a(
          "div",
          {
            className: be[`${ve}__content`],
            style: { maxHeight: $ ? k : 0 },
            ref: E,
            children: /* @__PURE__ */ a("div", { ref: C, children: w && /* @__PURE__ */ h(Q, { children: [
              /* @__PURE__ */ a(
                F,
                {
                  as: "div",
                  className: u(be[`${ve}__content__inner`], {
                    [be[`${ve}__content__inner--open`]]: $,
                    [be[`${ve}__content__inner--promo`]]: s,
                    [be[`${ve}__content__inner--full-width`]]: i
                  }),
                  children: r
                }
              ),
              c && /* @__PURE__ */ a(
                F,
                {
                  as: "div",
                  "aria-label": "Accordion footer",
                  role: "complementary",
                  className: u(be[`${ve}__footer`], {
                    [be[`${ve}__footer--promo`]]: s
                  }),
                  children: c
                }
              )
            ] }) })
          }
        )
      ]
    })
  );
}, ve = "accordion", ru = (r) => {
  var o = r, { kind: e } = o, t = U(o, ["kind"]);
  const _ = u(be[ve], be[`${ve}--${e}`]);
  return /* @__PURE__ */ a(B_, v({ mainClassName: _ }, t));
}, wi = `${ve}--promo`, ou = (e) => {
  const t = u(be[ve], be[wi]);
  return /* @__PURE__ */ a(B_, v({ mainClassName: t, isPromo: !0 }, e));
}, se = {
  esc: "Escape",
  enter: "Enter",
  backspace: "Backspace",
  delete: "Delete",
  spacebar: " ",
  tab: "Tab",
  semicolon: ";",
  comma: ",",
  arrowUp: "ArrowUp",
  arrowDown: "ArrowDown"
}, yt = {
  "action-menu": "lc-ActionMenu-module__action-menu___tmkcK",
  "action-menu__trigger-button": "lc-ActionMenu-module__action-menu__trigger-button___fTjxP",
  "action-menu__list": "lc-ActionMenu-module__action-menu__list___sEn6L",
  "action-menu__list__group-header": "lc-ActionMenu-module__action-menu__list__group-header___TWiz0",
  "action-menu__list__item": "lc-ActionMenu-module__action-menu__list__item___PhQbO",
  "action-menu__list__item--with-divider": "lc-ActionMenu-module__action-menu__list__item--with-divider___KF1dE",
  "action-menu__list__item--disabled": "lc-ActionMenu-module__action-menu__list__item--disabled___VfZx3",
  "action-menu__list__item--selected": "lc-ActionMenu-module__action-menu__list__item--selected___aT2Ab",
  "action-menu__list__item__icon": "lc-ActionMenu-module__action-menu__list__item__icon___f3k8k",
  "action-menu__list--with-footer": "lc-ActionMenu-module__action-menu__list--with-footer___21-ar",
  "action-menu__footer": "lc-ActionMenu-module__action-menu__footer___pb-RE"
}, Ct = "action-menu", I_ = (y) => {
  var x = y, {
    className: e,
    triggerClassName: t,
    options: r,
    triggerRenderer: o,
    placement: _ = "bottom-end",
    openedOnInit: l = !1,
    keepOpenOnClick: i,
    flipOptions: n,
    visible: d,
    onClose: s,
    onOpen: c,
    floatingStrategy: p,
    selectedOptions: m,
    footer: f
  } = x, g = U(x, [
    "className",
    "triggerClassName",
    "options",
    "triggerRenderer",
    "placement",
    "openedOnInit",
    "keepOpenOnClick",
    "flipOptions",
    "visible",
    "onClose",
    "onOpen",
    "floatingStrategy",
    "selectedOptions",
    "footer"
  ]);
  const S = d !== void 0, [E, $] = b.useState(l), [w, N] = b.useState(null), k = b.useRef(-1), C = Gr(), I = ar(), T = b.useRef(null), M = S ? d : E, A = () => {
    M ? (s == null || s(), !S && $(!1)) : (c == null || c(), !S && $(!0));
  }, { x: D, y: G, strategy: P, refs: L, context: O } = rr({
    nodeId: I,
    middleware: [
      or(4),
      Ur(n),
      C_({
        apply({ availableHeight: H }) {
          Vl(() => N(H));
        }
      })
    ],
    placement: _,
    open: M,
    strategy: p,
    onOpenChange: A,
    whileElementsMounted: _r
  }), q = lr(O), Y = ir(O, {
    enabled: M
  }), te = nr(O), { getReferenceProps: ye, getFloatingProps: ge } = cr([
    q,
    Y,
    te
  ]), { styles: K } = Lr(O, {
    initial: ({ side: H }) => v({
      opacity: 0
    }, H === "bottom" && {
      marginTop: -10
    } || H === "top" && {
      marginTop: 10
    } || H === "left" && {
      marginLeft: 10
    } || H === "right" && {
      marginLeft: -10
    })
  }), Z = (H) => {
    var Ie, oe;
    const re = k.current;
    let de = re + H;
    for (; (Ie = r[de]) != null && Ie.disabled || (oe = r[de]) != null && oe.groupHeader; )
      if (de += H, de === -1) {
        de = re;
        break;
      }
    return de;
  }, st = (H) => {
    var Ie, oe;
    k.current = Z(H);
    const re = (Ie = T.current) == null ? void 0 : Ie.children, de = re && ((oe = re[k.current]) == null ? void 0 : oe.children[0]);
    return de == null ? void 0 : de.focus();
  }, kt = (H) => {
    H.key === se.arrowUp && k.current > 0 && (H.preventDefault(), st(-1)), H.key === se.arrowDown && k.current + 1 < r.length && (H.preventDefault(), st(1));
  };
  b.useEffect(() => {
    if (M)
      return document.addEventListener("keydown", kt), () => document.removeEventListener("keydown", kt);
    k.current = -1;
  }, [M, kt]);
  const Jt = (H, re) => {
    k.current = H, re == null || re(), !S && !i && ($(!1), s == null || s());
  }, Dt = (H, re) => H.groupHeader ? /* @__PURE__ */ a(
    "li",
    {
      role: "none",
      className: yt[`${Ct}__list__group-header`],
      children: H.element
    },
    H.key
  ) : /* @__PURE__ */ a("li", { role: "none", children: /* @__PURE__ */ h(
    "button",
    {
      "data-testid": H.key,
      tabIndex: -1,
      disabled: H.disabled,
      onClick: () => Jt(re, H.onClick),
      role: "menuitem",
      className: u(yt[`${Ct}__list__item`], {
        [yt[`${Ct}__list__item--disabled`]]: H.disabled,
        [yt[`${Ct}__list__item--with-divider`]]: H.withDivider,
        [yt[`${Ct}__list__item--selected`]]: m == null ? void 0 : m.includes(H.key)
      }),
      children: [
        H.element,
        (m == null ? void 0 : m.includes(H.key)) && /* @__PURE__ */ a(
          "div",
          {
            "data-testid": `${H.key}-selected-icon`,
            className: yt[`${Ct}__list__item__icon`],
            children: /* @__PURE__ */ a(R, { source: wa, kind: "action-primary" })
          }
        )
      ]
    },
    H.key
  ) }, H.key), Ot = /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ a(
      "div",
      B(v({
        "aria-label": "Toggle menu",
        "data-testid": "action-menu-trigger-button",
        ref: L.setReference
      }, ye()), {
        className: t,
        children: o
      })
    ),
    /* @__PURE__ */ a($a, { id: I, children: M && /* @__PURE__ */ h(
      "div",
      B(v({
        ref: L.setFloating,
        className: yt[Ct],
        style: v(v({
          position: P,
          top: G != null ? G : "",
          left: D != null ? D : ""
        }, !!w && { maxHeight: w }), K)
      }, ge()), {
        children: [
          r.length > 0 && /* @__PURE__ */ a(
            "ul",
            B(v({}, g), {
              className: u(
                yt[`${Ct}__list`],
                {
                  [yt[`${Ct}__list--with-footer`]]: f
                },
                e
              ),
              role: "menu",
              ref: T,
              children: r.map(Dt)
            })
          ),
          f && /* @__PURE__ */ a(
            F,
            {
              size: "sm",
              as: "div",
              className: yt[`${Ct}__footer`],
              children: f
            }
          )
        ]
      })
    ) })
  ] });
  return C === null ? /* @__PURE__ */ a(qr, { children: Ot }) : Ot;
}, $i = "lc-Loader-module__loader___Ukoov", Ni = "lc-Loader-module__loader__spinner___cp5N7", Si = "lc-Loader-module__rotate___p-j1x", xi = "lc-Loader-module__loader__label___CF5-C", Ea = {
  loader: $i,
  loader__spinner: Ni,
  "loader__spinner--small": "lc-Loader-module__loader__spinner--small___9XXkz",
  "loader__spinner--medium": "lc-Loader-module__loader__spinner--medium___oTzt2",
  "loader__spinner--large": "lc-Loader-module__loader__spinner--large___vDCTc",
  "loader__spinner-circle": "lc-Loader-module__loader__spinner-circle___LyuTm",
  rotate: Si,
  loader__label: xi
}, A_ = "loader", Yo = `${A_}__spinner`, Bo = (i) => {
  var n = i, {
    primaryColor: e,
    secondaryColor: t,
    label: r,
    className: o,
    size: _ = "medium"
  } = n, l = U(n, [
    "primaryColor",
    "secondaryColor",
    "label",
    "className",
    "size"
  ]);
  return /* @__PURE__ */ h("div", B(v({ className: u(Ea[A_], o) }, l), { children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: u(Ea[Yo], Ea[`${Yo}--${_}`]),
        children: /* @__PURE__ */ a(
          "div",
          {
            role: "status",
            className: Ea["loader__spinner-circle"],
            style: {
              /* stylelint-disable */
              borderColor: t,
              borderTopColor: e
            }
          }
        )
      }
    ),
    r && /* @__PURE__ */ a(F, { as: "div", size: "md", className: Ea.loader__label, children: r })
  ] }));
}, Ei = (e) => {
  if (e === "primary" || e === "destructive")
    return {
      primaryColor: "var(--action-primary-default)",
      secondaryColor: "var(--border-invert-primary)"
    };
  if (e === "link-inverted")
    return {
      primaryColor: "var(--content-invert-primary)",
      secondaryColor: "var(--surface-invert-secondary)"
    };
}, Xo = (e, t, r) => {
  t(), r == null || r(e);
}, Ti = (e, t, r) => {
  t(), r == null || r(e);
}, Bi = (e, t) => {
  const r = e == null ? void 0 : e.offsetWidth;
  r && t(r);
}, Ii = "lc-Button-module__btn___daEdK", Ai = "lc-Button-module__btn__loader___L9GCi", Di = "lc-Button-module__btn__icon___-CG5y", Oi = "lc-Button-module__btn__content___rMx0W", Ce = {
  btn: Ii,
  "btn--disabled": "lc-Button-module__btn--disabled___ATZwt",
  "btn--full-width": "lc-Button-module__btn--full-width___ViUNm",
  "btn--xcompact": "lc-Button-module__btn--xcompact___0AZjf",
  "btn--with-left-icon": "lc-Button-module__btn--with-left-icon___32jlN",
  "btn--with-right-icon": "lc-Button-module__btn--with-right-icon___MnSZq",
  "btn--compact": "lc-Button-module__btn--compact___230yl",
  "btn--medium": "lc-Button-module__btn--medium___7lzYn",
  "btn--large": "lc-Button-module__btn--large___D38zo",
  "btn--basic": "lc-Button-module__btn--basic___r7FM2",
  "btn--primary": "lc-Button-module__btn--primary___RKxUy",
  "btn--secondary": "lc-Button-module__btn--secondary___-lgbN",
  "btn--destructive": "lc-Button-module__btn--destructive___frCNL",
  "btn--destructive-outline": "lc-Button-module__btn--destructive-outline___3Q-D2",
  "btn--text": "lc-Button-module__btn--text___lb44N",
  "btn--link": "lc-Button-module__btn--link___Q-xHu",
  "btn--link-light": "lc-Button-module__btn--link-light___s-d01",
  "btn--link-inverted": "lc-Button-module__btn--link-inverted___xOUjH",
  "btn--plain": "lc-Button-module__btn--plain___BOFMA",
  "btn--float": "lc-Button-module__btn--float___3O7kc",
  "btn--dotted": "lc-Button-module__btn--dotted___kFW2N",
  "btn--high-contrast": "lc-Button-module__btn--high-contrast___IZkuG",
  "btn--loading": "lc-Button-module__btn--loading___kGPe4",
  btn__loader: Ai,
  btn__icon: Di,
  "btn__icon--left": "lc-Button-module__btn__icon--left___Xke3Q",
  "btn__icon--right": "lc-Button-module__btn__icon--right___c-N-B",
  "btn__icon--small": "lc-Button-module__btn__icon--small___2gmZG",
  "btn--icon-only": "lc-Button-module__btn--icon-only___7J-XP",
  "btn--icon-only--bg": "lc-Button-module__btn--icon-only--bg___Kn-y-",
  "btn--plain-lock-black": "lc-Button-module__btn--plain-lock-black___EsXu7",
  "btn--text-lock-black": "lc-Button-module__btn--text-lock-black___r4V6e",
  "btn--animated-label": "lc-Button-module__btn--animated-label___8uZTa",
  btn__content: Oi,
  "btn--animated-label--expanded": "lc-Button-module__btn--animated-label--expanded___dTfmD"
}, we = "btn", W = b.forwardRef(
  (x, y) => {
    var S = x, {
      loading: e = !1,
      disabled: t = !1,
      type: r = "button",
      fullWidth: o = !1,
      kind: _ = "secondary",
      size: l = "medium",
      icon: i = null,
      iconPosition: n = "left",
      loaderLabel: d,
      className: s,
      children: c,
      href: p,
      onClick: m,
      animatedLabel: f
    } = S, g = U(S, [
      "loading",
      "disabled",
      "type",
      "fullWidth",
      "kind",
      "size",
      "icon",
      "iconPosition",
      "loaderLabel",
      "className",
      "children",
      "href",
      "onClick",
      "animatedLabel"
    ]);
    const [E, $] = b.useState(0), [w, N] = b.useState(!1), k = e || t, C = !c && i, I = f && c && i, T = ["text", "link", "link-light"].includes(_), M = p ? "a" : "button", A = u(
      Ce[we],
      Ce[`${we}--${_}`],
      Ce[`${we}--${l}`],
      {
        [Ce[`${we}--loading`]]: e,
        [Ce[`${we}--full-width`]]: o,
        [Ce[`${we}--with-${n}-icon`]]: i && !C && !T,
        [Ce[`${we}--icon-only`]]: C,
        [Ce[`${we}--icon-only--bg`]]: C && T,
        [Ce[`${we}--disabled`]]: k,
        [Ce[`${we}--animated-label`]]: I,
        [Ce[`${we}--animated-label--expanded`]]: I && w
      },
      s
    );
    return /* @__PURE__ */ h(
      M,
      B(v(v(v({
        ref: y,
        className: A,
        "aria-disabled": k,
        type: r,
        disabled: k
      }, !k && { href: p, onClick: m }), g), I && {
        onMouseEnter: (D) => Xo(
          D,
          () => N(!0),
          g == null ? void 0 : g.onMouseEnter
        ),
        onMouseLeave: (D) => Xo(
          D,
          () => N(!1),
          g == null ? void 0 : g.onMouseLeave
        ),
        onBlur: (D) => Ti(
          D,
          () => N(!1),
          g == null ? void 0 : g.onBlur
        ),
        onKeyUp: (D) => {
          var G;
          (D.key === "Enter" || D.key === " ") && N(!0), D.key === "Escape" && N(!1), (G = g == null ? void 0 : g.onKeyUp) == null || G.call(g, D);
        }
      }), {
        children: [
          e && /* @__PURE__ */ a(
            Bo,
            v({
              "data-testid": "button-loader",
              size: "small",
              label: d,
              className: Ce[`${we}__loader`]
            }, Ei(_))
          ),
          i && b.cloneElement(i, {
            className: u(
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              i.props.className,
              Ce[`${we}__icon`],
              Ce[`${we}__icon--${n}`],
              {
                [Ce[`${we}__icon--small`]]: l === "xcompact"
              }
            ),
            disabled: t,
            size: l === "xcompact" ? "small" : "medium"
          }),
          /* @__PURE__ */ a(
            "div",
            {
              className: Ce[`${we}__content`],
              style: I ? { maxWidth: w ? E : 0 } : void 0,
              children: I ? /* @__PURE__ */ a("span", { ref: (D) => Bi(D, $), children: c }) : c
            }
          )
        ]
      })
    );
  }
), Ta = {
  "list-item": "lc-ListItem-module__list-item___22kWE",
  "list-item__left-node": "lc-ListItem-module__list-item__left-node___EIetr",
  "list-item__right-node": "lc-ListItem-module__list-item__right-node___An9i9",
  "list-item__label": "lc-ListItem-module__list-item__label___E8L87",
  "list-item--warning": "lc-ListItem-module__list-item--warning___-yfsq"
}, Ba = "list-item", Ar = ({
  leftNode: e,
  rightNode: t,
  children: r,
  kind: o
}) => /* @__PURE__ */ h(
  "div",
  {
    className: u(Ta[Ba], {
      [Ta[`${Ba}--warning`]]: o === "warning"
    }),
    children: [
      e && /* @__PURE__ */ a("div", { className: Ta[`${Ba}__left-node`], children: e }),
      /* @__PURE__ */ a(F, { as: "div", className: Ta[`${Ba}__label`], children: r }),
      t && /* @__PURE__ */ a("div", { className: Ta[`${Ba}__right-node`], children: t })
    ]
  }
), _u = (e) => (z(() => {
  console.warn("`ActionMenuItem` is deprecated. Use `ListItem` instead.");
}, []), /* @__PURE__ */ a(Ar, v({}, e)));
function D_(e) {
  switch (e) {
    case "invert":
      return "inverted";
    case "important":
      return "lock-black";
    default:
      return "primary";
  }
}
function Pi(e, t, r, o) {
  if (r)
    return {
      top: e ? r + e : r
    };
  if (o)
    return {
      left: t ? o + t : o
    };
}
const Fi = (e) => {
  switch (e) {
    case "invert":
      return {
        stroke: "var(--tooltip-background-invert)",
        fill: "var(--tooltip-background-invert)"
      };
    case "important":
      return {
        stroke: "var(--surface-accent-emphasis-high-warning)",
        fill: "var(--surface-accent-emphasis-high-warning)"
      };
    default:
      return {
        stroke: "var(--tooltip-border-for-svg)",
        fill: "var(--tooltip-background-basic)"
      };
  }
}, Mi = "lc-Tooltip-module__tooltip___LjRUX", Ri = "lc-Tooltip-module__tooltip__content___cxaIe", Gi = "lc-Tooltip-module__tooltip__arrow___vLFFP", Ui = "lc-Tooltip-module__tooltip__interactive___WTll9", X = {
  tooltip: Mi,
  tooltip__content: Ri,
  "tooltip--invert": "lc-Tooltip-module__tooltip--invert___J4i3t",
  tooltip__arrow: Gi,
  "tooltip--important": "lc-Tooltip-module__tooltip--important___7KDXC",
  tooltip__interactive: Ui,
  "tooltip__user-guide-step": "lc-Tooltip-module__tooltip__user-guide-step___zwAvq",
  "tooltip--full-space": "lc-Tooltip-module__tooltip--full-space___YXy-C",
  "tooltip-header": "lc-Tooltip-module__tooltip-header___gnWkw",
  "tooltip-header--info": "lc-Tooltip-module__tooltip-header--info___VLXJo",
  "tooltip-media-container": "lc-Tooltip-module__tooltip-media-container___82zyJ",
  "tooltip-media": "lc-Tooltip-module__tooltip-media___F81U-",
  "tooltip-text--info": "lc-Tooltip-module__tooltip-text--info___eFPj0",
  "tooltip-close": "lc-Tooltip-module__tooltip-close___3t8it",
  "tooltip-step": "lc-Tooltip-module__tooltip-step___WnQFV",
  "tooltip-footer": "lc-Tooltip-module__tooltip-footer___Ila6T",
  "tooltip-footer--interactive": "lc-Tooltip-module__tooltip-footer--interactive___8WwVX",
  "tooltip-footer--user-guide-step": "lc-Tooltip-module__tooltip-footer--user-guide-step___hIsO4",
  "guide-tooltip": "lc-Tooltip-module__guide-tooltip___lBG0P",
  "guide-tooltip--slide": "lc-Tooltip-module__guide-tooltip--slide___XuCdK",
  "guide-tooltip__overlay": "lc-Tooltip-module__guide-tooltip__overlay___BAueg",
  "guide-tooltip__overlay--slide": "lc-Tooltip-module__guide-tooltip__overlay--slide___uYqoN",
  "guide-tooltip__overlay--visible": "lc-Tooltip-module__guide-tooltip__overlay--visible___Tk1Yr",
  "reports-tooltip": "lc-Tooltip-module__reports-tooltip___g6vxb",
  "reports-tooltip__heading": "lc-Tooltip-module__reports-tooltip__heading___TxORk",
  "reports-tooltip__heading__title": "lc-Tooltip-module__reports-tooltip__heading__title___0foO-",
  "reports-tooltip__heading__description": "lc-Tooltip-module__reports-tooltip__heading__description___E6Gb3",
  "reports-tooltip__content": "lc-Tooltip-module__reports-tooltip__content___yfOcf"
}, mr = "tooltip", ia = ({
  children: e,
  className: t,
  triggerClassName: r,
  triggerRenderer: o,
  theme: _,
  kind: l,
  placement: i = "bottom",
  isVisible: n,
  fullSpaceContent: d,
  onClose: s,
  onOpen: c,
  withFadeAnimation: p = !0,
  transitionDuration: m = 200,
  hoverOnDuration: f,
  hoverOffDuration: g,
  transitionDelay: y = 0,
  hoverOnDelay: x,
  hoverOffDelay: S,
  triggerOnClick: E = !1,
  triggerOnHover: $ = !0,
  offsetMainAxis: w = 8,
  offsetCrossAxis: N = 0,
  referenceElement: k,
  activationThreshold: C = 0,
  useDismissHookProps: I,
  useClickHookProps: T,
  hoverOutDelayTimeout: M = 100,
  arrowOffsetY: A,
  arrowOffsetX: D,
  closeOnTriggerBlur: G = !1,
  floatingStrategy: P,
  portal: L,
  portalProps: O,
  hideWhenReferenceHidden: q = !1
}) => {
  const Y = n !== void 0, [te, ye] = b.useState(!1), ge = b.useRef(null), K = Y ? n : te, Z = l || _, st = Gr(), kt = ar(), Jt = u(
    X[mr],
    t,
    Z && X[`${mr}--${Z}`],
    d && X[`${mr}--full-space`]
  ), Dt = typeof o == "function", Ot = (he) => {
    he !== K && (he ? c == null || c() : s == null || s(), !Y && ye(he));
  }, H = (he) => p ? he != null ? he : m : 0, re = (he) => he != null ? he : y, {
    floatingStyles: de,
    refs: Ie,
    context: oe,
    middlewareData: { arrow: { x: ca, y: ue } = {}, hide: qe }
  } = rr({
    nodeId: kt,
    middleware: [
      or({ mainAxis: w, crossAxis: N }),
      xo(),
      Ur(),
      Pl({ element: ge, padding: 8 }),
      q ? Fl() : void 0
    ],
    placement: i,
    open: K,
    strategy: P,
    onOpenChange: Ot,
    whileElementsMounted: _r
  }), Pt = Ml(oe, {
    move: !1,
    restMs: C,
    delay: {
      open: re(x),
      close: re(S || M)
    },
    enabled: $,
    handleClose: G ? null : Rl()
  }), sa = Gl(oe), da = ir(oe, I), Vr = nr(oe, { role: "tooltip" }), Wr = lr(oe, v({
    enabled: E
  }, T)), { isMounted: Kr, styles: Yr } = Lr(oe, {
    duration: {
      open: H(f),
      close: H(g)
    }
  }), { status: Xr } = Ul(oe), { getReferenceProps: Zr, getFloatingProps: jr } = cr([
    Pt,
    sa,
    da,
    Vr,
    Wr
  ]);
  b.useEffect(() => {
    k && Ie.setReference(k);
  }, [Ie.setReference, k]);
  const ua = /* @__PURE__ */ a($a, { id: kt, children: Kr && /* @__PURE__ */ h(
    "div",
    B(v({
      ref: Ie.setFloating,
      style: B(v(v({}, de), Yr), {
        visibility: qe != null && qe.referenceHidden ? "hidden" : "visible"
      }),
      className: Jt
    }, jr()), {
      "data-status": Xr,
      children: [
        /* @__PURE__ */ a(F, { as: "div", className: X[`${mr}__content`], children: e }),
        /* @__PURE__ */ a(
          Ll,
          v({
            ref: ge,
            context: oe,
            strokeWidth: 1,
            width: 10,
            height: 5,
            style: v({}, Pi(
              A,
              D,
              ue,
              ca
            ))
          }, Fi(Z))
        )
      ]
    })
  ) }), Jr = () => st === null ? /* @__PURE__ */ a(qr, { children: L ? /* @__PURE__ */ a(Ca, B(v({}, O), { children: ua })) : ua }) : L ? /* @__PURE__ */ a(Ca, B(v({}, O), { children: ua })) : ua;
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ a(
      "div",
      B(v({
        "data-testid": "tooltip-trigger",
        ref: Ie.setReference
      }, Zr()), {
        className: r,
        children: Dt ? o() : o
      })
    ),
    Jr()
  ] });
}, lu = ({ text: e }) => /* @__PURE__ */ a("div", { children: e }), Ia = "tooltip", iu = ({
  className: e,
  header: t,
  text: r,
  closeWithX: o,
  theme: _,
  handleCloseAction: l
}) => /* @__PURE__ */ h("div", { className: e, children: [
  (o || l) && /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      "aria-label": "Close tooltip",
      className: X[`${Ia}-close`],
      onClick: l,
      children: /* @__PURE__ */ a(R, { source: ct, kind: _ ? D_(_) : "primary" })
    }
  ),
  t && /* @__PURE__ */ a(
    pe,
    {
      as: "div",
      size: "xs",
      className: u(X[`${Ia}-header`], {
        [X[`${Ia}-header--info`]]: o
      }),
      children: t
    }
  ),
  /* @__PURE__ */ a(
    F,
    {
      as: "div",
      className: u({
        [X[`${Ia}-text`]]: o,
        [X[`${Ia}-text--info`]]: o
      }),
      children: r
    }
  )
] }), wt = "tooltip", Li = ({
  header: e,
  text: t,
  image: r,
  video: o,
  closeWithX: _,
  theme: l,
  handleCloseAction: i,
  primaryButton: n,
  secondaryButton: d
}) => {
  const s = (m) => m === "invert" ? "secondary" : m === "important" ? "plain-lock-black" : "high-contrast", c = (m) => m === "invert" ? "link-inverted" : m === "important" ? "text-lock-black" : "text", p = (m, f = !0) => {
    if (!m) return null;
    if (b.isValidElement(m))
      return m;
    const g = m, y = f ? g.kind || s(l) : g.kind || c(l);
    return /* @__PURE__ */ a(
      W,
      B(v({}, g), {
        kind: y,
        onClick: g.handleClick,
        children: g.label
      })
    );
  };
  return /* @__PURE__ */ h("div", { className: X[`${wt}__interactive`], children: [
    (_ || i) && /* @__PURE__ */ a(
      "button",
      {
        type: "button",
        "aria-label": "Close tooltip",
        className: X[`${wt}-close`],
        onClick: i,
        children: /* @__PURE__ */ a(R, { source: ct, kind: l ? D_(l) : "primary" })
      }
    ),
    r && /* @__PURE__ */ a("div", { className: X[`${wt}-media-container`], children: /* @__PURE__ */ a(
      "img",
      {
        className: X[`${wt}-media`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    o && /* @__PURE__ */ a("div", { className: X[`${wt}-media-container`], children: /* @__PURE__ */ a(
      "video",
      {
        className: X[`${wt}-media`],
        autoPlay: !0,
        loop: !0,
        muted: !0,
        playsInline: !0,
        controls: !1,
        children: /* @__PURE__ */ a("source", { src: o })
      }
    ) }),
    e && /* @__PURE__ */ a(pe, { as: "div", size: "xs", className: X[`${wt}-header`], children: e }),
    /* @__PURE__ */ a("div", { className: X[`${wt}-text`], children: t }),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(
          X[`${wt}-footer`],
          X[`${wt}-footer--interactive`]
        ),
        children: [
          p(n, !0),
          p(d, !1)
        ]
      }
    )
  ] });
}, Aa = "reports-tooltip", nu = ({
  title: e,
  description: t,
  children: r
}) => /* @__PURE__ */ h("div", { className: X[Aa], children: [
  /* @__PURE__ */ h("div", { className: X[`${Aa}__heading`], children: [
    /* @__PURE__ */ a(F, { as: "div", className: X[`${Aa}__heading__title`], children: e }),
    /* @__PURE__ */ a(
      F,
      {
        as: "div",
        size: "xs",
        className: X[`${Aa}__heading__description`],
        children: t
      }
    )
  ] }),
  /* @__PURE__ */ a("div", { className: X[`${Aa}__content`], children: /* @__PURE__ */ a(F, { as: "div", children: r }) })
] }), ae = {
  "action-bar": "lc-ActionBar-module__action-bar___yfLdO",
  "action-bar__items": "lc-ActionBar-module__action-bar__items___E8fX6",
  "action-bar__items--scroll": "lc-ActionBar-module__action-bar__items--scroll___izP27",
  "action-bar__items__button-wrapper": "lc-ActionBar-module__action-bar__items__button-wrapper___sgdUc",
  "action-bar__items__button-wrapper--active": "lc-ActionBar-module__action-bar__items__button-wrapper--active___TZteM",
  "action-bar__items__button-wrapper--hidden": "lc-ActionBar-module__action-bar__items__button-wrapper--hidden___43H6t",
  "action-bar__items__button-wrapper--vertical": "lc-ActionBar-module__action-bar__items__button-wrapper--vertical___8Aq0c",
  "action-bar__items__button-wrapper__button": "lc-ActionBar-module__action-bar__items__button-wrapper__button___r5jpx",
  "action-bar__items__button-wrapper__button--with-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-divider___bTyao",
  "action-bar__items__button-wrapper__button--with-vertical-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-vertical-divider___DkEFm",
  "action-bar__items__tooltip": "lc-ActionBar-module__action-bar__items__tooltip___BxN2p",
  "action-bar__menu-wrapper": "lc-ActionBar-module__action-bar__menu-wrapper___y26Bl",
  "action-bar__menu-wrapper--active": "lc-ActionBar-module__action-bar__menu-wrapper--active___E4iCs",
  "action-bar__menu-wrapper--vertical": "lc-ActionBar-module__action-bar__menu-wrapper--vertical___wU4tc",
  "action-bar__menu-wrapper__button": "lc-ActionBar-module__action-bar__menu-wrapper__button___0Nluq",
  "action-bar__menu-wrapper__button--active": "lc-ActionBar-module__action-bar__menu-wrapper__button--active___-NlsX",
  "action-bar__menu-wrapper__button__with-item": "lc-ActionBar-module__action-bar__menu-wrapper__button__with-item___Nvb-H",
  "fade-in": "lc-ActionBar-module__fade-in___NlmMy",
  "action-bar__menu-wrapper__button__icon": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon___dFIfe",
  "action-bar__menu-wrapper__button__icon--open": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon--open___shQMz",
  "action-bar__menu-wrapper__trigger-vertical": "lc-ActionBar-module__action-bar__menu-wrapper__trigger-vertical___yaJyY",
  "action-bar--vertical": "lc-ActionBar-module__action-bar--vertical___9uO-q",
  "action-bar__items--with-menu": "lc-ActionBar-module__action-bar__items--with-menu___OfqL0",
  "action-bar__items__button": "lc-ActionBar-module__action-bar__items__button___N1Qtp",
  "action-bar__items__button--active": "lc-ActionBar-module__action-bar__items__button--active___adIVs"
}, O_ = "action-bar__items", ma = `${O_}__button-wrapper`, qi = ({
  option: e,
  isActive: t,
  vertical: r
}) => {
  const o = u(ae[ma], {
    [ae[`${ma}--active`]]: t,
    [ae[`${ma}--vertical`]]: r
  }), _ = /* @__PURE__ */ a(
    W,
    {
      id: e.key,
      title: e != null && e.showTooltip ? void 0 : e.label,
      kind: "plain",
      onClick: e.onClick,
      icon: e.element,
      className: u(ae[`${ma}__button`], {
        [ae[`${ma}__button--with-vertical-divider`]]: r && e.withDivider,
        [ae[`${ma}__button--with-divider`]]: !r && e.withDivider
      })
    },
    e.key
  );
  return e.showTooltip ? /* @__PURE__ */ a(
    "div",
    {
      "data-testid": e.key,
      className: o,
      children: /* @__PURE__ */ a(
        ia,
        {
          kind: "invert",
          placement: r ? "left" : "bottom",
          triggerClassName: ae[`${O_}__tooltip`],
          triggerRenderer: () => _,
          floatingStrategy: "fixed",
          useClickHookProps: {
            ignoreMouse: !0
          },
          hoverOnDelay: 800,
          hoverOffDelay: 0,
          children: /* @__PURE__ */ a("div", { children: e.label })
        }
      )
    },
    e.key
  ) : /* @__PURE__ */ a("div", { "data-testid": e.key, className: o, children: _ });
}, pr = "action-bar", Ft = "action-bar__menu-wrapper", Hi = 44, cu = ({
  className: e,
  id: t = "action-bar-area",
  type: r = "menu",
  options: o,
  activeOptionKey: _,
  vertical: l,
  menuFooter: i
}) => {
  const [n, d] = b.useState(
    o.length
  ), [s, c] = b.useState([]), [p, m] = b.useState(!1), f = r === "scroll", g = u(
    ae[pr],
    e,
    l && ae[`${pr}--vertical`]
  ), y = !f && s.length !== 0;
  b.useEffect(() => {
    f || (o.length > n ? c(o.slice(n, o.length)) : c([]));
  }, [o, n]), b.useEffect(() => {
    const E = !!window.ResizeObserver;
    if (!f && E) {
      const $ = new ResizeObserver((w) => {
        const { width: N, height: k } = w[0].contentRect, C = l ? k : N, I = s.length > 0 ? 60 : 0, T = Math.floor(
          (C - I) / Hi
        );
        T >= 0 && T !== n && d(T);
      });
      return $.observe(document.querySelector(`#${t}`)), () => $.disconnect();
    }
  }, [s, f, n]);
  const x = b.useCallback(() => s.reduce(
    (E, $) => {
      if (!$.hideInMenu) {
        const w = {
          key: $.key,
          element: /* @__PURE__ */ a(Ar, { leftNode: $.element, children: $.label }),
          withDivider: $.withDivider,
          onClick: $.onClick
        };
        E.push(w);
      }
      return E;
    },
    []
  ), [s]), S = s.find((E) => E.key === _);
  return /* @__PURE__ */ h("div", { id: t, className: g, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: u(ae[`${pr}__items`], {
          [ae[`${pr}__items--scroll`]]: f
        }),
        children: o.slice(0, n).map((E) => /* @__PURE__ */ a(
          qi,
          {
            option: E,
            isActive: E.key === _,
            vertical: l
          }
        ))
      }
    ),
    y && /* @__PURE__ */ a(
      "div",
      {
        className: u(
          ae[Ft],
          S && ae[`${Ft}--active`],
          l && ae[`${Ft}--vertical`]
        ),
        children: /* @__PURE__ */ a(
          I_,
          {
            selectedOptions: _ ? [_] : [],
            onOpen: () => m(!0),
            onClose: () => m(!1),
            floatingStrategy: "fixed",
            placement: l ? "left-start" : "bottom-end",
            options: x(),
            triggerClassName: u(
              l && ae[`${Ft}__trigger-vertical`]
            ),
            triggerRenderer: /* @__PURE__ */ a(
              W,
              {
                id: `${t}-menu-button`,
                className: u(
                  ae[`${Ft}__button`],
                  S && ae[`${Ft}__button--active`]
                ),
                kind: "plain",
                icon: /* @__PURE__ */ a(
                  R,
                  {
                    source: na,
                    kind: "primary",
                    className: u(
                      ae[`${Ft}__button__icon`],
                      p && ae[`${Ft}__button__icon--open`]
                    )
                  }
                ),
                iconPosition: "right",
                children: S && /* @__PURE__ */ a(
                  "div",
                  {
                    className: u(
                      ae[`${Ft}__button__with-item`]
                    ),
                    children: S.element
                  }
                )
              }
            ),
            footer: i
          }
        )
      }
    )
  ] });
}, zi = "lc-ActionCard-module__loading___biGIO", Mt = {
  "visually-hidden": "lc-ActionCard-module__visually-hidden___hE6De",
  "main-wrapper": "lc-ActionCard-module__main-wrapper___-LUjH",
  "action-card--loading": "lc-ActionCard-module__action-card--loading___Ql9-s",
  "action-card": "lc-ActionCard-module__action-card___gPaoW",
  "action-card--loading--animated": "lc-ActionCard-module__action-card--loading--animated___lpz9i",
  loading: zi,
  "action-card__column": "lc-ActionCard-module__action-card__column___KgMRx",
  "action-card__column--first": "lc-ActionCard-module__action-card__column--first___BWQwi",
  "action-card__column--second": "lc-ActionCard-module__action-card__column--second___-X-gO"
}, Rt = "action-card", su = ({
  className: e,
  children: t,
  secondColumn: r,
  firstColumnClassName: o,
  secondColumnClassName: _,
  onClick: l,
  isLoading: i = !1,
  isLoadingAnimated: n = !1
}) => {
  const d = u(Mt[Rt], e), s = u(Mt["main-wrapper"], {
    [Mt[`${Rt}--loading`]]: i,
    [Mt[`${Rt}--loading--animated`]]: n
  }), c = (m) => {
    i || m.currentTarget === document.activeElement && (l == null || l());
  }, p = (m) => {
    i || m.currentTarget === document.activeElement && (m.key === "Enter" || m.key === " " || m.key === "Spacebar" || m.key === "Space") && (m.preventDefault(), l == null || l());
  };
  return /* @__PURE__ */ h("div", { className: s, children: [
    /* @__PURE__ */ a("div", { "aria-live": "polite", className: Mt["visually-hidden"], children: i ? "Loading content" : null }),
    /* @__PURE__ */ a(
      "div",
      {
        role: i ? "presentation" : "button",
        "aria-label": "Action Card",
        "aria-busy": i,
        tabIndex: i ? -1 : 0,
        className: d,
        onClick: c,
        onKeyDown: p,
        children: !i && /* @__PURE__ */ h(Q, { children: [
          /* @__PURE__ */ a(
            "div",
            {
              "data-testid": `${Rt}-first-column`,
              className: u(
                Mt[`${Rt}__column`],
                Mt[`${Rt}__column--first`],
                o
              ),
              children: t
            }
          ),
          r && /* @__PURE__ */ a(
            "div",
            {
              "data-testid": `${Rt}-second-column`,
              className: u(
                Mt[`${Rt}__column`],
                Mt[`${Rt}__column--second`],
                _
              ),
              children: r
            }
          )
        ] })
      }
    )
  ] });
}, Vi = 8, Wi = 100, wo = ({
  text: e,
  typingAnimation: t = !0,
  typingDelay: r = Wi,
  typingSpeed: o = Vi,
  onTypingEnd: _
}) => {
  const [l, i] = ce(""), n = Kt(0);
  return z(() => {
    if (!e) return;
    if (!t && _)
      return _();
    const s = setTimeout(() => {
      const c = setInterval(() => {
        const p = n.current;
        p < e.length ? (i((m) => m + e[p]), n.current = p + 1) : (clearInterval(c), _ == null || _());
      }, o);
    }, r);
    return () => {
      clearTimeout(s);
    };
  }, [e, t]), /* @__PURE__ */ a(Q, { children: t ? l : e });
}, Ki = "lc-Alert-module__alert___zP4AL", Yi = "lc-Alert-module__alert__icon___1SDHT", Xi = "lc-Alert-module__alert__content___wwP8E", Zi = "lc-Alert-module__alert__content__wrapper___gw9Mg", ji = "lc-Alert-module__alert__content__wrapper__text___2x5d-", Ji = "lc-Alert-module__alert__content__wrapper__cta___ocxGq", Qi = "lc-Alert-module__alert__content__wrapper__cta__link___ZqOjp", Ze = {
  alert: Ki,
  alert__icon: Yi,
  alert__content: Xi,
  alert__content__wrapper: Zi,
  alert__content__wrapper__text: ji,
  alert__content__wrapper__cta: Ji,
  alert__content__wrapper__cta__link: Qi,
  "alert__close-icon": "lc-Alert-module__alert__close-icon___jbDQJ",
  "alert--small": "lc-Alert-module__alert--small___GsHEV",
  "alert--medium": "lc-Alert-module__alert--medium___5PGR3",
  "alert--large": "lc-Alert-module__alert--large___068A5",
  "alert--info": "lc-Alert-module__alert--info___GLCTZ",
  "alert--warning": "lc-Alert-module__alert--warning___y0-zK",
  "alert--success": "lc-Alert-module__alert--success___RXWVi",
  "alert--error": "lc-Alert-module__alert--error___EK-vJ"
}, en = {
  info: {
    source: Ir,
    kind: "link"
  },
  warning: {
    source: b_,
    kind: "warning"
  },
  success: {
    source: So,
    kind: "success"
  },
  error: {
    source: v_,
    kind: "error"
  }
}, je = "alert", du = (n) => {
  var d = n, {
    children: e,
    className: t,
    primaryButton: r,
    secondaryButton: o,
    kind: _ = "info",
    onClose: l
  } = d, i = U(d, [
    "children",
    "className",
    "primaryButton",
    "secondaryButton",
    "kind",
    "onClose"
  ]);
  const s = b.useRef(null), [c, p] = b.useState(null), m = u(
    Ze[je],
    Ze[`${je}--${_}`],
    c === "large" && Ze[`${je}--large`],
    c === "medium" && Ze[`${je}--medium`],
    c === "small" && Ze[`${je}--small`],
    t
  );
  return b.useEffect(() => {
    const f = () => s.current && s.current.offsetWidth <= 400 ? p("small") : s.current && s.current.offsetWidth > 400 && s.current.offsetWidth <= 800 ? p("medium") : p("large"), g = f_(() => {
      f();
    }, 500);
    return window.addEventListener("resize", g), f(), () => window.removeEventListener("resize", g);
  }), /* @__PURE__ */ h("div", B(v({ ref: s, className: m }, i), { children: [
    /* @__PURE__ */ h("div", { className: Ze[`${je}__content`], children: [
      /* @__PURE__ */ h("div", { className: Ze[`${je}__content__wrapper`], children: [
        /* @__PURE__ */ a(
          R,
          B(v({}, en[_]), {
            size: "large",
            className: Ze[`${je}__icon`]
          })
        ),
        /* @__PURE__ */ a(
          F,
          {
            as: "div",
            className: Ze[`${je}__content__wrapper__text`],
            children: e
          }
        )
      ] }),
      (r || o) && /* @__PURE__ */ h("div", { className: Ze[`${je}__content__wrapper__cta`], children: [
        r && /* @__PURE__ */ a(
          W,
          B(v({
            kind: "high-contrast",
            onClick: r.handleClick
          }, r), {
            children: r.label
          })
        ),
        o && /* @__PURE__ */ a(
          W,
          B(v({
            className: u(
              Ze[`${je}__content__wrapper__cta__link`],
              o.className
            ),
            kind: "text",
            onClick: o.handleClick
          }, o), {
            children: o.label
          })
        )
      ] })
    ] }),
    l && /* @__PURE__ */ a(
      W,
      {
        "aria-label": "Close alert",
        className: Ze[`${je}__close-icon`],
        size: "compact",
        kind: "plain",
        icon: /* @__PURE__ */ a(R, { source: ct }),
        onClick: l
      }
    )
  ] }));
}, tn = 705, an = 751, Je = {
  "app-frame": "lc-AppFrame-module__app-frame___LeOAC",
  "app-frame__page-content-container": "lc-AppFrame-module__app-frame__page-content-container___XhCPO",
  "app-frame__page-content-container--mobile": "lc-AppFrame-module__app-frame__page-content-container--mobile___2HnOq",
  "app-frame__page-content-container__top-bar": "lc-AppFrame-module__app-frame__page-content-container__top-bar___cl5Ek",
  "app-frame__page-content-container__top-bar--visible": "lc-AppFrame-module__app-frame__page-content-container__top-bar--visible___ZfcRZ",
  "app-frame__page-content-container__content-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper___V0yIo",
  "app-frame__page-content-container__content-wrapper--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper--mobile___iUDnN",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper___eAkwB",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open___-rAxE",
  "app-frame__page-content-container__content-wrapper__content": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content___zHmoo",
  "app-frame__page-content-container__content-wrapper__content--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content--mobile___HKy-9",
  "app-frame__page-content-container__content-wrapper__mobile-top-bar": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__mobile-top-bar___JeGo3"
}, P_ = "app-frame", dt = `${P_}__page-content-container`, rn = (e) => {
  const {
    children: t,
    className: r,
    navigation: o,
    mobileNavigation: _,
    sideNavigation: l,
    topBar: i,
    topBarClassName: n,
    sideNavigationContainerClassName: d,
    contentClassName: s
  } = e, c = u(Je[P_], r), {
    isSideNavigationVisible: p,
    setIsMobileViewEnabled: m,
    isMobileViewEnabled: f
  } = To(), g = b.useRef(null), { isOpen: y, isMounted: x } = la({
    isVisible: p,
    elementRef: g
  }), { isMobile: S, handleResizeRef: E } = ri({
    mobileBreakpoint: tn
  });
  return b.useEffect(() => {
    m(S);
  }, [S]), /* @__PURE__ */ h("div", { className: c, ref: E, children: [
    !f && o,
    /* @__PURE__ */ h(
      "div",
      {
        className: u(Je[dt], {
          [Je[`${dt}--mobile`]]: f
        }),
        children: [
          !f && /* @__PURE__ */ a(
            "div",
            {
              className: u(
                Je[`${dt}__top-bar`],
                {
                  [Je[`${dt}__top-bar--visible`]]: i
                },
                n
              ),
              children: i
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              className: u(Je[`${dt}__content-wrapper`], {
                [Je[`${dt}__content-wrapper--mobile`]]: f
              }),
              children: [
                !f && l && /* @__PURE__ */ a(
                  "div",
                  {
                    ref: g,
                    className: u(
                      Je[`${dt}__content-wrapper__nav-bar-wrapper`],
                      "lc-dark-theme",
                      d,
                      {
                        [Je[`${dt}__content-wrapper__nav-bar-wrapper--open`]]: y
                      }
                    ),
                    children: x && l
                  }
                ),
                f && /* @__PURE__ */ a(
                  "div",
                  {
                    className: Je[`${dt}__content-wrapper__mobile-top-bar`],
                    children: i
                  }
                ),
                /* @__PURE__ */ a(
                  "div",
                  {
                    className: u(
                      Je[`${dt}__content-wrapper__content`],
                      s,
                      {
                        [Je[`${dt}__content-wrapper__content--mobile`]]: f
                      }
                    ),
                    children: t
                  }
                ),
                f && _
              ]
            }
          )
        ]
      }
    )
  ] });
}, uu = (e) => {
  const o = e, { isSideNavigationVisible: t } = o, r = U(o, ["isSideNavigationVisible"]);
  return /* @__PURE__ */ a(ni, { isSideNavigationVisible: t, children: /* @__PURE__ */ a(rn, v({}, r)) });
}, pa = {
  "side-navigation": "lc-SideNavigation-module__side-navigation___FuFGb",
  "side-navigation__header": "lc-SideNavigation-module__side-navigation__header___du0Jr",
  "side-navigation__header__title": "lc-SideNavigation-module__side-navigation__header__title___2dGWf",
  "side-navigation__footer": "lc-SideNavigation-module__side-navigation__footer___9LLon",
  "side-navigation__nav-wrapper": "lc-SideNavigation-module__side-navigation__nav-wrapper___8Opuh",
  "side-navigation__nav-wrapper--no-gaps": "lc-SideNavigation-module__side-navigation__nav-wrapper--no-gaps___1ApnT"
}, ga = "side-navigation", mu = ({
  children: e,
  className: t,
  title: r,
  customHeader: o,
  customFooter: _,
  noGaps: l,
  rightNode: i
}) => {
  const n = o || /* @__PURE__ */ h("div", { className: pa[`${ga}__header`], children: [
    /* @__PURE__ */ a(pe, { size: "sm", className: pa[`${ga}__header__title`], children: r }),
    i
  ] });
  return /* @__PURE__ */ h(
    "div",
    {
      "data-testid": "side-navigation",
      className: u(pa[ga], t),
      children: [
        n,
        /* @__PURE__ */ a(
          "div",
          {
            className: u(pa[`${ga}__nav-wrapper`], {
              [pa[`${ga}__nav-wrapper--no-gaps`]]: l
            }),
            children: e
          }
        ),
        _ && /* @__PURE__ */ a("div", { className: pa[`${ga}__footer`], children: _ })
      ]
    }
  );
};
function tr() {
}
const on = "side-navigation-item-test-id", _n = "side-navigation-active-item-test-id", ln = "side-navigation-parent-icon", Qe = {
  "side-navigation-item": "lc-SideNavigationItem-module__side-navigation-item___QCTSQ",
  "side-navigation-item__anchor": "lc-SideNavigationItem-module__side-navigation-item__anchor___PI--g",
  "side-navigation-item__custom-label": "lc-SideNavigationItem-module__side-navigation-item__custom-label___ATpTF",
  "side-navigation-item__anchor--main-entry": "lc-SideNavigationItem-module__side-navigation-item__anchor--main-entry___h9Lwx",
  "side-navigation-item__anchor--active": "lc-SideNavigationItem-module__side-navigation-item__anchor--active___iXojJ",
  "side-navigation-item__anchor--icon-hidden": "lc-SideNavigationItem-module__side-navigation-item__anchor--icon-hidden___KlK37",
  "side-navigation-item__left-node": "lc-SideNavigationItem-module__side-navigation-item__left-node___otK1S",
  "side-navigation-item__left-node--active": "lc-SideNavigationItem-module__side-navigation-item__left-node--active___5PNWM",
  "side-navigation-item__right-node": "lc-SideNavigationItem-module__side-navigation-item__right-node___MOwqj",
  "side-navigation-item__label": "lc-SideNavigationItem-module__side-navigation-item__label___dpMyX",
  "side-navigation-item__label--active": "lc-SideNavigationItem-module__side-navigation-item__label--active___4vImp",
  "side-navigation-item__custom-label--active": "lc-SideNavigationItem-module__side-navigation-item__custom-label--active___UWDu9"
}, et = "side-navigation-item", nn = (m) => {
  var f = m, {
    leftNode: e,
    shouldKeepIconSpace: t = !0,
    url: r,
    label: o,
    className: _,
    rightNode: l,
    onClick: i,
    isActive: n,
    isMainEntry: d,
    onItemHover: s,
    isIconHidden: c
  } = f, p = U(f, [
    "leftNode",
    "shouldKeepIconSpace",
    "url",
    "label",
    "className",
    "rightNode",
    "onClick",
    "isActive",
    "isMainEntry",
    "onItemHover",
    "isIconHidden"
  ]);
  const g = typeof o == "string", y = (S) => {
    S.preventDefault(), i == null || i();
  }, x = (S) => {
    S.key === "Enter" && (S.preventDefault(), i == null || i());
  };
  return /* @__PURE__ */ a(
    "li",
    B(v({
      className: u([Qe[et], _]),
      "data-testid": n ? _n : on,
      "data-active": n
    }, p), {
      children: /* @__PURE__ */ h(
        "a",
        {
          tabIndex: 0,
          className: u(Qe[`${et}__anchor`], {
            [Qe[`${et}__anchor--active`]]: n,
            [Qe[`${et}__anchor--main-entry`]]: d,
            [Qe[`${et}__anchor--icon-hidden`]]: c
          }),
          href: r,
          onClick: y,
          onKeyDown: x,
          onMouseEnter: s || tr,
          onFocus: s || tr,
          children: [
            t && /* @__PURE__ */ a(
              "span",
              {
                className: u(Qe[`${et}__left-node`], {
                  [Qe[`${et}__left-node--active`]]: n || d
                }),
                "data-testid": ln,
                children: e
              }
            ),
            g ? /* @__PURE__ */ a(
              F,
              {
                bold: n || d,
                className: u(Qe[`${et}__label`], {
                  [Qe[`${et}__label--active`]]: n || d
                }),
                children: o
              }
            ) : /* @__PURE__ */ a(
              "span",
              {
                className: u(Qe[`${et}__custom-label`], {
                  [Qe[`${et}__custom-label--active`]]: n || d
                }),
                children: o
              }
            ),
            l && /* @__PURE__ */ a("span", { className: Qe[`${et}__right-node`], children: l })
          ]
        }
      )
    })
  );
}, cn = "side-navigation-link-label-test-id", $t = {
  "side-navigation-group": "lc-SideNavigationGroup-module__side-navigation-group___Cgruk",
  "side-navigation-group__chevron": "lc-SideNavigationGroup-module__side-navigation-group__chevron___4wv4s",
  "side-navigation-group__chevron--active": "lc-SideNavigationGroup-module__side-navigation-group__chevron--active___v7QK7",
  "side-navigation-group__label": "lc-SideNavigationGroup-module__side-navigation-group__label___pDDzF",
  "side-navigation-group__simple-label-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__simple-label-wrapper___PJwbR",
  "side-navigation-group__simple-label": "lc-SideNavigationGroup-module__side-navigation-group__simple-label___-KO5t",
  "side-navigation-group__right-node": "lc-SideNavigationGroup-module__side-navigation-group__right-node___I90bd",
  "side-navigation-group__list-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper___moivM",
  "side-navigation-group__list-wrapper--expanded": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper--expanded___cwPUQ",
  "side-navigation-group__list": "lc-SideNavigationGroup-module__side-navigation-group__list___Srb-J"
}, Nt = "side-navigation-group", sn = 34, pu = ({
  label: e,
  rightNode: t,
  className: r,
  labelClassName: o,
  labelWrapperClassName: _,
  listWrapperClassName: l,
  children: i,
  isCollapsible: n,
  isLinkLabel: d,
  isActive: s,
  isOpen: c,
  isMounted: p,
  setShouldBeVisible: m,
  onItemHover: f,
  onClick: g,
  listWrapperRef: y,
  shouldOpenOnInit: x = !1
}) => {
  const [S, E] = b.useState(!1), [$, w] = b.useState(0), N = b.useRef(!1), k = b.useRef(null), C = y != null ? y : k, { isOpen: I, isMounted: T, setShouldBeVisible: M } = la({
    isVisible: !n || x,
    elementRef: C
  }), A = c != null ? c : I, D = p != null ? p : T, G = m != null ? m : M, P = typeof t == "function" ? t(A) : t, L = typeof e == "function" ? e(A) : e, O = () => G(!0), q = () => {
    n && G((te) => !te);
  }, Y = () => g ? g({ toggle: q }) : q();
  return b.useEffect(() => {
    if (!i || !n)
      return;
    const te = b.Children.toArray(
      i
    ), ye = !!(te != null && te.some(
      (K) => {
        var Z;
        return (Z = K.props) == null ? void 0 : Z.isActive;
      }
    ));
    E(ye);
    const ge = ((te == null ? void 0 : te.length) || 0) * sn;
    w(ge);
  }, [i]), b.useEffect(() => {
    !N.current && S && O(), N.current = S;
  }, [S, N.current, x]), /* @__PURE__ */ h("div", { "data-testid": "side-navigation-group", className: $t[Nt], children: [
    n || d ? /* @__PURE__ */ a(
      nn,
      {
        leftNode: /* @__PURE__ */ a(
          "div",
          {
            className: u($t[`${Nt}__chevron`], {
              [$t[`${Nt}__chevron--active`]]: A
            }),
            children: n ? /* @__PURE__ */ a(R, { source: Mr, size: "small" }) : null
          }
        ),
        label: /* @__PURE__ */ a(
          F,
          {
            className: u($t[`${Nt}__label`], o),
            bold: !0,
            children: L
          }
        ),
        isActive: s,
        isMainEntry: !0,
        onClick: Y,
        onItemHover: f,
        rightNode: P,
        className: _,
        "data-testid": d ? cn : void 0
      }
    ) : /* @__PURE__ */ h(
      "span",
      {
        className: u(
          $t[`${Nt}__simple-label-wrapper`],
          _
        ),
        children: [
          /* @__PURE__ */ a(
            F,
            {
              bold: !0,
              className: u($t[`${Nt}__simple-label`], o),
              onMouseEnter: f || tr,
              children: L
            }
          ),
          P && /* @__PURE__ */ a("span", { className: $t[`${Nt}__right-node`], children: P })
        ]
      }
    ),
    /* @__PURE__ */ a(
      "div",
      {
        ref: C,
        className: u([
          $t[`${Nt}__list-wrapper`],
          {
            [$t[`${Nt}__list-wrapper--expanded`]]: A
          },
          l
        ]),
        style: n ? { maxHeight: A ? $ : 0 } : void 0,
        children: D && /* @__PURE__ */ a("ul", { className: u($t[`${Nt}__list`], r), children: i })
      }
    )
  ] });
}, Zo = {
  "navigation-group": "lc-NavigationGroup-module__navigation-group___61JTX",
  "navigation-group--scrollable": "lc-NavigationGroup-module__navigation-group--scrollable___BL8-e"
}, jo = "navigation-group", gu = (_) => {
  var l = _, {
    children: e,
    className: t,
    scrollable: r
  } = l, o = U(l, [
    "children",
    "className",
    "scrollable"
  ]);
  return /* @__PURE__ */ a(
    "ul",
    B(v({
      className: u(
        Zo[jo],
        {
          [Zo[`${jo}--scrollable`]]: r
        },
        t
      )
    }, o), {
      children: e
    })
  );
};
function dn(e, t) {
  return e > t ? `${t}+` : `${e}`;
}
const un = "lc-Badge-module__badge___ZbEBU", mn = "lc-Badge-module__badge__dot___MSVVf", gr = {
  badge: un,
  badge__dot: mn,
  "badge--large": "lc-Badge-module__badge--large___P4qtE",
  "badge--medium": "lc-Badge-module__badge--medium___5HFVb",
  "badge--compact": "lc-Badge-module__badge--compact___AUaWg",
  "badge--primary": "lc-Badge-module__badge--primary___wOrp-",
  "badge--secondary": "lc-Badge-module__badge--secondary___mAh3w",
  "badge--tertiary": "lc-Badge-module__badge--tertiary___rFqKw"
}, hr = "badge", Dr = (n) => {
  var d = n, {
    className: e,
    count: t = 0,
    max: r = 99,
    kind: o = "primary",
    size: _ = "medium",
    type: l = "counter"
  } = d, i = U(d, [
    "className",
    "count",
    "max",
    "kind",
    "size",
    "type"
  ]);
  const s = u(
    e,
    gr[hr],
    gr[`${hr}--${o}`],
    gr[`${hr}--${_}`]
  ), c = {
    counter: dn(t, r),
    alert: "!",
    dot: /* @__PURE__ */ a("span", { "data-testid": "badge-dot", className: gr[`${hr}__dot`] })
  }[l];
  return /* @__PURE__ */ a("span", B(v({ className: s }, i), { children: c }));
}, zt = {
  "navigation-item": "lc-NavigationItem-module__navigation-item___KVL3Y",
  "navigation-item--disabled": "lc-NavigationItem-module__navigation-item--disabled___VY8pA",
  "navigation-item__badge": "lc-NavigationItem-module__navigation-item__badge___6RiK5",
  "navigation-item__button": "lc-NavigationItem-module__navigation-item__button___g-pAI",
  "navigation-item__button--disabled": "lc-NavigationItem-module__navigation-item__button--disabled___POYlQ",
  "navigation-item__button--active": "lc-NavigationItem-module__navigation-item__button--active___zsO2E",
  "navigation-item__button--opacity": "lc-NavigationItem-module__navigation-item__button--opacity___buZjS",
  "navigation-item__button--mobile": "lc-NavigationItem-module__navigation-item__button--mobile___GqQwP"
}, Vt = "navigation-item", pn = (e, t) => typeof e == "number" ? /* @__PURE__ */ a(
  Dr,
  {
    "data-testid": `${t}-badge-count`,
    className: zt[`${Vt}__badge`],
    size: "compact",
    count: e
  }
) : /* @__PURE__ */ a(
  Dr,
  {
    "data-testid": `${t}-badge`,
    className: zt[`${Vt}__badge`],
    size: "compact",
    type: e
  }
), hu = (p) => {
  var m = p, {
    id: e,
    label: t,
    icon: r,
    url: o,
    disableOpacity: _,
    disabled: l = !1,
    badge: i,
    isActive: n,
    onClick: d,
    className: s
  } = m, c = U(m, [
    "id",
    "label",
    "icon",
    "url",
    "disableOpacity",
    "disabled",
    "badge",
    "isActive",
    "onClick",
    "className"
  ]);
  const { isMobileViewEnabled: f } = To();
  return /* @__PURE__ */ a(
    "li",
    {
      id: e,
      className: u(
        zt[Vt],
        {
          [zt[`${Vt}--disabled`]]: l
        },
        s
      ),
      children: /* @__PURE__ */ a(
        ia,
        {
          floatingStrategy: "fixed",
          placement: "right",
          kind: "invert",
          isVisible: f || !t || l ? !1 : void 0,
          offsetMainAxis: 12,
          hoverOnDelay: 400,
          useClickHookProps: { ignoreMouse: !0 },
          useDismissHookProps: {
            referencePress: !0,
            referencePressEvent: "click"
          },
          triggerRenderer: /* @__PURE__ */ h(Q, { children: [
            /* @__PURE__ */ h(
              "a",
              B(v({
                tabIndex: l ? -1 : 0,
                "aria-label": t,
                className: u(
                  zt[`${Vt}__button`],
                  {
                    [zt[`${Vt}__button--active`]]: n,
                    [zt[`${Vt}__button--opacity`]]: _,
                    [zt[`${Vt}__button--disabled`]]: l,
                    [zt[`${Vt}__button--mobile`]]: f
                  },
                  "lc-dark-theme"
                ),
                onClick: (g) => !l && d(g, e),
                href: o
              }, c), {
                children: [
                  r,
                  f && t
                ]
              })
            ),
            !!i && pn(i, e)
          ] }),
          children: t
        }
      )
    },
    e
  );
}, gn = "lc-Navigation-module__navigation___oNBOL", hn = {
  navigation: gn
}, fn = "navigation", fu = (o) => {
  var _ = o, {
    children: e,
    className: t
  } = _, r = U(_, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ a("nav", B(v({ className: u(hn[fn], t) }, r), { children: e }));
}, bt = {
  "navigation-top-bar": "lc-NavigationTopBar-module__navigation-top-bar___WJzyv",
  "navigation-top-bar__title": "lc-NavigationTopBar-module__navigation-top-bar__title___ROYDp",
  "navigation-top-bar__alerts-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alerts-wrapper___wkJlE",
  "navigation-top-bar__alert": "lc-NavigationTopBar-module__navigation-top-bar__alert___x2xOO",
  "navigation-top-bar__alert--open": "lc-NavigationTopBar-module__navigation-top-bar__alert--open___ESpyQ",
  "navigation-top-bar__alert__wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper___rOnri",
  "navigation-top-bar__alert__wrapper--open": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper--open___v-NG3",
  "navigation-top-bar__alert--info": "lc-NavigationTopBar-module__navigation-top-bar__alert--info___kfakN",
  "navigation-top-bar__alert--success": "lc-NavigationTopBar-module__navigation-top-bar__alert--success___s3tbr",
  "navigation-top-bar__alert--warning": "lc-NavigationTopBar-module__navigation-top-bar__alert--warning___giSMt",
  "navigation-top-bar__alert--error": "lc-NavigationTopBar-module__navigation-top-bar__alert--error___N4jFl",
  "navigation-top-bar__alert__children-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__children-wrapper___cfSYX",
  "navigation-top-bar__alert__close-button": "lc-NavigationTopBar-module__navigation-top-bar__alert__close-button___odqcf",
  "navigation-top-bar__alert__cta-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__cta-wrapper___0QtM0"
}, Or = "navigation-top-bar", Yt = `${Or}__alert`, F_ = ({
  children: e,
  className: t,
  additionalNodes: r,
  id: o
}) => {
  const { isMobileViewEnabled: _ } = To();
  return /* @__PURE__ */ h("div", { className: u(bt[Or], t), id: o, children: [
    /* @__PURE__ */ a("div", { className: bt[`${Or}__alerts-wrapper`], children: e }),
    !_ && r
  ] });
}, bn = ({
  children: e,
  className: t,
  "data-testid": r
}) => /* @__PURE__ */ a(
  "div",
  {
    className: u(bt[`${Or}__title`], t),
    "data-testid": r,
    children: e
  }
), vn = ({
  className: e,
  kind: t = "info",
  closeButton: r,
  children: o,
  primaryCta: _,
  secondaryCta: l,
  isVisible: i = !0,
  id: n
}) => {
  const [d, s] = b.useState(!1), c = b.useRef(null), { isMounted: p, isOpen: m } = la({
    isVisible: i,
    elementRef: c,
    includeSleepWakeScenario: !0
  }), f = b.useCallback(
    (w) => er(
      w,
      (N) => s(N.width < an)
    ),
    []
  ), g = t === "warning" ? "link-inverted" : "text", y = t === "warning" ? "secondary" : "high-contrast", x = _ == null ? void 0 : _.kind, S = l == null ? void 0 : l.kind, E = _ || l ? /* @__PURE__ */ h("div", { className: bt[`${Yt}__cta-wrapper`], children: [
    _ && /* @__PURE__ */ a(
      W,
      B(v({
        size: "compact"
      }, _), {
        kind: d ? g : x || y,
        children: _.label
      })
    ),
    l && /* @__PURE__ */ a(
      W,
      B(v({
        size: "compact"
      }, l), {
        kind: d ? g : S || y,
        children: l.label
      })
    )
  ] }) : null, $ = /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ h("div", { className: bt[`${Yt}__children-wrapper`], children: [
      o,
      E
    ] }),
    r && /* @__PURE__ */ a(
      "button",
      B(v({
        className: bt[`${Yt}__close-button`]
      }, r), {
        children: /* @__PURE__ */ a(R, { source: ct })
      })
    )
  ] });
  return /* @__PURE__ */ a(Q, { children: p && /* @__PURE__ */ a("div", { ref: f, children: /* @__PURE__ */ a(
    "div",
    {
      className: u(
        bt[`${Yt}__wrapper`],
        {
          [bt[`${Yt}__wrapper--open`]]: m
        },
        "lc-dark-theme"
        // Alerts are forced into dark mode to maintain consistency of the colors
      ),
      ref: c,
      role: "status",
      children: /* @__PURE__ */ a(
        "div",
        {
          id: n,
          "data-testid": "navigation-top-bar-alert",
          className: u(
            bt[Yt],
            bt[`${Yt}--${t}`],
            {
              [bt[`${Yt}--open`]]: m
            },
            e
          ),
          children: $
        }
      )
    }
  ) }) });
};
F_.Alert = vn;
F_.Title = bn;
function Pr(e, t, r, o) {
  return e === 1 ? t : r;
}
const fr = {
  "expiration-counter": "lc-ExpirationCounter-module__expiration-counter___ro9nL",
  "expiration-counter__button": "lc-ExpirationCounter-module__expiration-counter__button___Xv5Nx",
  "expiration-counter__button__number": "lc-ExpirationCounter-module__expiration-counter__button__number___9hZV4",
  "expiration-counter__button__label": "lc-ExpirationCounter-module__expiration-counter__button__label___nJAOv"
}, br = "expiration-counter", bu = (i) => {
  var n = i, {
    id: e,
    daysLeft: t,
    url: r,
    onClick: o,
    className: _
  } = n, l = U(n, [
    "id",
    "daysLeft",
    "url",
    "onClick",
    "className"
  ]);
  return /* @__PURE__ */ a("li", { className: u(fr[br], _), children: /* @__PURE__ */ h(
    "a",
    B(v({
      id: e,
      tabIndex: 0,
      href: r,
      onClick: (d) => o(d, e),
      className: fr[`${br}__button`]
    }, l), {
      children: [
        /* @__PURE__ */ a("span", { className: fr[`${br}__button__number`], children: t }),
        /* @__PURE__ */ a("span", { className: fr[`${br}__button__label`], children: Pr(t, "day", "days") })
      ]
    })
  ) }, e);
}, kn = {
  "mobile-navigation": "lc-MobileNavigation-module__mobile-navigation___a--p5"
}, yn = "mobile-navigation", vu = (o) => {
  var _ = o, {
    children: e,
    className: t
  } = _, r = U(_, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ a("nav", B(v({ className: u(kn[yn], t) }, r), { children: e }));
}, M_ = g_({
  readOnly: !1,
  isEmpty: !1,
  setIsEmpty: () => {
  }
}), Cn = ({ children: e, readOnly: t = !1, defaultIsEmpty: r = !1 }) => {
  const [o, _] = ce(r);
  return /* @__PURE__ */ a(
    M_.Provider,
    {
      value: {
        readOnly: t,
        isEmpty: o,
        setIsEmpty: _
      },
      children: e
    }
  );
}, At = () => h_(M_), Na = ({
  value: e,
  noDataFallbackText: t = "No data"
}) => {
  const { setIsEmpty: r } = At();
  return z(() => {
    r(!e);
  }, [e, r]), /* @__PURE__ */ a(
    F,
    {
      noMargin: !0,
      semiBold: !!e,
      customColor: e ? void 0 : "var(--content-basic-secondary)",
      role: "textbox",
      "aria-readonly": "true",
      children: e || t
    }
  );
}, wn = "lc-Input-module__input___505b7", it = {
  input: wn,
  "input--promo": "lc-Input-module__input--promo___5hf0s",
  "input--focused": "lc-Input-module__input--focused___rmg2U",
  "input--disabled": "lc-Input-module__input--disabled___QA4ie",
  "input--crop": "lc-Input-module__input--crop___63BIX",
  "input--error": "lc-Input-module__input--error___d2Aqj",
  "input--xsmall": "lc-Input-module__input--xsmall___6hLud",
  "input--compact": "lc-Input-module__input--compact___9Sw7d",
  "input--medium": "lc-Input-module__input--medium___gb5Z2",
  "input--large": "lc-Input-module__input--large___hfmAH",
  "input__icon--disabled": "lc-Input-module__input__icon--disabled___uTYsP",
  "input__icon--left": "lc-Input-module__input__icon--left___IBzj8",
  "input__icon--right": "lc-Input-module__input__icon--right___lw1xQ",
  "input__visibility-button": "lc-Input-module__input__visibility-button___lmD5H"
}, nt = "input", Jo = (e, t) => b.cloneElement(e.source, {
  "data-testid": `input-icon-${e.place}`,
  className: u(
    it[`${nt}__icon`],
    it[`${nt}__icon--${e.place}`],
    {
      [it[`${nt}__icon--disabled`]]: t
    }
  )
}), R_ = b.forwardRef(
  (c, s) => {
    var p = c, {
      error: e = !1,
      disabled: t,
      icon: r = null,
      className: o,
      mainClassName: _,
      isPromo: l = !1,
      cropOnBlur: i = !0,
      noDataFallbackText: n = "No data"
    } = p, d = U(p, [
      "error",
      "disabled",
      "icon",
      "className",
      "mainClassName",
      "isPromo",
      "cropOnBlur",
      "noDataFallbackText"
    ]);
    var D;
    const m = b.useRef(null), { readOnly: f } = At(), g = f || d.readOnly;
    b.useImperativeHandle(s, () => m.current, []);
    const [y, x] = b.useState(!1), [S, E] = b.useState(!1), { type: $, onFocus: w, onBlur: N } = d, k = u(
      _,
      {
        [it[`${nt}--disabled`]]: t,
        [it[`${nt}--focused`]]: y,
        [it[`${nt}--error`]]: e,
        [it[`${nt}--crop`]]: i
      },
      o
    ), C = t ? "var(--content-basic-disabled)" : "var(--content-basic-primary)", I = S ? nl : cl, T = r && r.place === "left", M = r && $ !== "password" && r.place === "right", A = () => {
      var G;
      (G = m.current) == null || G.focus();
    };
    return g ? /* @__PURE__ */ a(
      Na,
      {
        value: (D = d.value) == null ? void 0 : D.toString(),
        noDataFallbackText: n
      }
    ) : /* @__PURE__ */ h(
      F,
      {
        as: "div",
        size: l ? "lg" : "md",
        className: k,
        "aria-disabled": t,
        "tab-index": "0",
        onClick: A,
        children: [
          T && Jo(r, t),
          /* @__PURE__ */ a(
            "input",
            B(v({}, d), {
              ref: m,
              onFocus: (G) => {
                x(!0), w == null || w(G);
              },
              onBlur: (G) => {
                x(!1), N == null || N(G);
              },
              disabled: t,
              type: $ && !S ? $ : "text"
            })
          ),
          M && Jo(r, t),
          $ === "password" && /* @__PURE__ */ a(
            W,
            {
              disabled: t,
              kind: "text",
              size: "compact",
              icon: /* @__PURE__ */ a(R, { customColor: C, source: I }),
              onClick: () => E((G) => !G),
              className: it[`${nt}__visibility-button`]
            }
          )
        ]
      }
    );
  }
), $n = b.forwardRef(
  (o, r) => {
    var _ = o, { inputSize: e = "medium" } = _, t = U(_, ["inputSize"]);
    const l = u(
      it[nt],
      it[`${nt}--${e}`]
    );
    return /* @__PURE__ */ a(R_, B(v({ mainClassName: l }, t), { ref: r }));
  }
), Nn = `${nt}--promo`, ku = b.forwardRef(
  (e, t) => {
    const r = u(it[nt], it[Nn]);
    return /* @__PURE__ */ a(
      R_,
      B(v({
        mainClassName: r,
        isPromo: !0
      }, e), {
        ref: t
      })
    );
  }
), Sn = 2, G_ = 200, U_ = 400;
[
  ...[...Array(100)].map((e, t) => ({
    key: `option${t + 8}`,
    name: `Option #${t + 8}`,
    disabled: t % 4 === 0
  }))
];
const ya = "select-all", xn = (e, t) => {
  const r = [];
  return e.forEach((o, _) => {
    t(o) && r.push(_);
  }), r;
}, $o = (e) => e.filter(
  ({ key: t, disabled: r, groupHeader: o }) => !(t === ya || r || o)
), Qo = ({ key: e }) => e, En = (e, t) => e.includes(t) ? e.filter((r) => r !== t) : [...e, t], e_ = Array.from(
  { length: 10 },
  (e, t) => `--surface-avatar-${t + 1}`
);
function Tn(e) {
  if (!e)
    return;
  const t = e.split("").reduce((r, o) => r + o.charCodeAt(0), 0);
  return `var(${e_[t % e_.length]})`;
}
function Bn(e = "", t = 2) {
  const r = e.trim().split(/\s+/), o = r.map((l) => [...l][0]);
  if (t < 1) return "";
  if (r.length <= t)
    return o.join("").toUpperCase();
  const _ = [o[0]];
  for (let l = r.length - t + 1; l < r.length; l++)
    _.push(o[l]);
  return _.join("").toUpperCase();
}
function In(e) {
  let t = e;
  if (e.startsWith("var(--") && e.endsWith(")")) {
    const r = e.slice(4, -1);
    t = window.getComputedStyle(document.documentElement).getPropertyValue(r).trim();
  }
  return t && Eo(t, "#FFFFFF") > 3 ? "var(--color-white)" : "var(--color-black)";
}
const An = "lc-Avatar-module__avatar___5-kP8", Dn = "lc-Avatar-module__avatar__status___HNURz", On = "lc-Avatar-module__avatar__rim___2AzYM", Pn = "lc-Avatar-module__avatar__image___OeTCV", He = {
  avatar: An,
  avatar__status: Dn,
  "avatar__status--available": "lc-Avatar-module__avatar__status--available___e8YYH",
  "avatar__status--unavailable": "lc-Avatar-module__avatar__status--unavailable___EZN8K",
  "avatar__status--unknown": "lc-Avatar-module__avatar__status--unknown___ig3u2",
  "avatar__status--xxxsmall": "lc-Avatar-module__avatar__status--xxxsmall___ywnfb",
  "avatar__status--circle": "lc-Avatar-module__avatar__status--circle___hluXh",
  "avatar__status--xxsmall": "lc-Avatar-module__avatar__status--xxsmall___1cyef",
  "avatar__status--xsmall": "lc-Avatar-module__avatar__status--xsmall___oamOI",
  "avatar__status--small": "lc-Avatar-module__avatar__status--small___mXtgJ",
  "avatar__status--medium": "lc-Avatar-module__avatar__status--medium___itZ--",
  "avatar__status--large": "lc-Avatar-module__avatar__status--large___xhFK7",
  "avatar__status--xlarge": "lc-Avatar-module__avatar__status--xlarge___Tt--f",
  "avatar__status--xxlarge": "lc-Avatar-module__avatar__status--xxlarge___nlhY4",
  "avatar__status--xxxlarge": "lc-Avatar-module__avatar__status--xxxlarge___jOQH-",
  "avatar__status--rounded-square": "lc-Avatar-module__avatar__status--rounded-square___vbnS3",
  avatar__rim: On,
  "avatar__rim--xxxsmall": "lc-Avatar-module__avatar__rim--xxxsmall___i9Sfv",
  "avatar__rim--xxsmall": "lc-Avatar-module__avatar__rim--xxsmall___oTxsG",
  "avatar__rim--xsmall": "lc-Avatar-module__avatar__rim--xsmall___EP67J",
  "avatar__rim--small": "lc-Avatar-module__avatar__rim--small___GO4DE",
  "avatar__rim--medium": "lc-Avatar-module__avatar__rim--medium___PwmzG",
  "avatar__rim--large": "lc-Avatar-module__avatar__rim--large___uvcTs",
  "avatar__rim--xlarge": "lc-Avatar-module__avatar__rim--xlarge___bjiXr",
  "avatar__rim--xxlarge": "lc-Avatar-module__avatar__rim--xxlarge___YjUzl",
  "avatar__rim--xxxlarge": "lc-Avatar-module__avatar__rim--xxxlarge___KvgAh",
  avatar__image: Pn,
  "avatar__icon--xxxsmall": "lc-Avatar-module__avatar__icon--xxxsmall___wMbtg",
  "avatar__icon--xxsmall": "lc-Avatar-module__avatar__icon--xxsmall___x736T",
  "avatar__icon--xsmall": "lc-Avatar-module__avatar__icon--xsmall___FEY-4",
  "avatar__icon--small": "lc-Avatar-module__avatar__icon--small___2YWc9",
  "avatar__icon--medium": "lc-Avatar-module__avatar__icon--medium___zNzZn",
  "avatar__icon--large": "lc-Avatar-module__avatar__icon--large___xKot9",
  "avatar__icon--xlarge": "lc-Avatar-module__avatar__icon--xlarge___SaIEW",
  "avatar__icon--xxlarge": "lc-Avatar-module__avatar__icon--xxlarge___nKxnM",
  "avatar__icon--xxxlarge": "lc-Avatar-module__avatar__icon--xxxlarge___2MVJa",
  "avatar--circle": "lc-Avatar-module__avatar--circle___Ys84D",
  "avatar--rounded-square": "lc-Avatar-module__avatar--rounded-square___awk7U",
  "avatar--xxxsmall": "lc-Avatar-module__avatar--xxxsmall___S5mVR",
  "avatar--xxsmall": "lc-Avatar-module__avatar--xxsmall___i7spO",
  "avatar--xsmall": "lc-Avatar-module__avatar--xsmall___WWgCM",
  "avatar--small": "lc-Avatar-module__avatar--small___KH6pw",
  "avatar--medium": "lc-Avatar-module__avatar--medium___un4U9",
  "avatar--large": "lc-Avatar-module__avatar--large___C8hm4",
  "avatar--xlarge": "lc-Avatar-module__avatar--xlarge___hjIy5",
  "avatar--xxlarge": "lc-Avatar-module__avatar--xxlarge___AjkHw",
  "avatar--xxxlarge": "lc-Avatar-module__avatar--xxxlarge___4Hhp9"
}, $e = "avatar", Io = (m) => {
  var f = m, {
    alt: e,
    className: t,
    color: r,
    shape: o = "circle",
    size: _ = "medium",
    src: l,
    status: i,
    text: n,
    type: d,
    withRim: s = !1,
    style: c
  } = f, p = U(f, [
    "alt",
    "className",
    "color",
    "shape",
    "size",
    "src",
    "status",
    "text",
    "type",
    "withRim",
    "style"
  ]);
  const g = d === "image" && !l, [y, x] = b.useState(g), S = d === "image" && !!l && !y, E = d === "text", $ = ["xxxsmall", "xxsmall", "xsmall"].includes(_) ? 1 : 2, w = Bn(n, $), N = ["xxxsmall", "xxsmall", "xsmall", "small"].includes(_), k = r || Tn(n), C = k ? In(k) : void 0, I = E ? { backgroundColor: k } : {}, T = u(v({
    [He[$e]]: !0,
    [He[`${$e}--${o}`]]: !0,
    [He[`${$e}--${_}`]]: !0,
    [He[`${$e}--with-rim`]]: s
  }, t ? { [`${t}`]: t } : {})), M = u(
    He[`${$e}__status`],
    He[`${$e}__status--${o}`],
    He[`${$e}__status--${_}`],
    ...i ? [He[`${$e}__status--${i}`]] : []
  ), A = u(
    He[`${$e}__icon`],
    He[`${$e}__icon--${_}`]
  ), D = u(
    He[`${$e}__rim`],
    He[`${$e}__rim--${_}`]
  ), G = (L) => N ? "2xs" : ["medium"].includes(L) ? "xs" : ["large", "xlarge"].includes(L) ? "sm" : ["xxlarge"].includes(L) ? "lg" : "xl", P = b.useCallback(() => x(!0), []);
  return b.useEffect(() => {
    x(g);
  }, [g]), /* @__PURE__ */ h(
    "div",
    B(v({
      className: T,
      style: v(v({}, I), c)
    }, p), {
      children: [
        s && /* @__PURE__ */ a(
          "div",
          {
            "data-testid": `${$e}__rim`,
            className: D
          }
        ),
        i && /* @__PURE__ */ a(
          "div",
          {
            "data-testid": `${$e}__status`,
            className: M
          }
        ),
        S && /* @__PURE__ */ a(
          "img",
          {
            className: He[`${$e}__image`],
            src: l,
            alt: e,
            onError: P
          }
        ),
        E && /* @__PURE__ */ a(
          pe,
          {
            as: "span",
            size: G(_),
            style: { color: C },
            bold: N,
            uppercase: N,
            children: w
          }
        ),
        y && /* @__PURE__ */ a(
          R,
          {
            "data-testid": `${$e}__icon`,
            className: A,
            source: sl
          }
        )
      ]
    })
  );
}, Fn = {
  "field-description": "lc-FieldDescription-module__field-description___x5rXY"
}, Mn = "field-description", Hr = (o) => {
  var _ = o, { children: e, className: t = "" } = _, r = U(_, ["children", "className"]);
  const l = u(Fn[Mn], t);
  return /* @__PURE__ */ a(F, B(v({ as: "span", size: "sm" }, r), { className: l, children: e }));
}, Rn = "lc-Checkbox-module__checkbox___D0D4S", Gn = "lc-Checkbox-module__checkbox__label___I472A", Un = "lc-Checkbox-module__checkbox__text___Ex7K1", Ln = "lc-Checkbox-module__checkbox__input___3krUF", qn = "lc-Checkbox-module__checkbox__checkmark___eZIG1", Hn = "lc-Checkbox-module__checkbox__helper___hwxAV", zn = "lc-Checkbox-module__checkbox__square___yjtrH", Gt = {
  checkbox: Rn,
  checkbox__label: Gn,
  checkbox__text: Un,
  checkbox__input: Ln,
  checkbox__checkmark: qn,
  "checkbox--read-only": "lc-Checkbox-module__checkbox--read-only___zeYW7",
  checkbox__helper: Hn,
  "checkbox--selected": "lc-Checkbox-module__checkbox--selected___pU3Xh",
  checkbox__square: zn,
  "checkbox--disabled": "lc-Checkbox-module__checkbox--disabled___kRNDo"
}, Ut = "checkbox", zr = b.forwardRef(
  (d, n) => {
    var s = d, {
      checked: e,
      indeterminate: t = !1,
      disabled: r,
      children: o,
      description: _,
      className: l
    } = s, i = U(s, [
      "checked",
      "indeterminate",
      "disabled",
      "children",
      "description",
      "className"
    ]);
    const { readOnly: c } = At(), p = c || i.readOnly;
    return /* @__PURE__ */ h(
      "div",
      {
        className: u(Gt[Ut], l, {
          [Gt[`${Ut}--selected`]]: e,
          [Gt[`${Ut}--disabled`]]: r,
          [Gt[`${Ut}--indeterminate`]]: t,
          [Gt[`${Ut}--read-only`]]: p
        }),
        children: [
          /* @__PURE__ */ h("label", { className: Gt[`${Ut}__label`], children: [
            /* @__PURE__ */ a(
              "input",
              B(v({}, i), {
                ref: (m) => {
                  m && (m.indeterminate = t, typeof n == "function" ? n(m) : n && (n.current = m));
                },
                checked: e,
                disabled: r,
                className: Gt[`${Ut}__input`],
                type: "checkbox"
              })
            ),
            o && /* @__PURE__ */ a(F, { as: "div", size: "md", className: Gt[`${Ut}__text`], children: o })
          ] }),
          _ && /* @__PURE__ */ a(Hr, { className: Gt[`${Ut}__helper`], children: _ })
        ]
      }
    );
  }
), Ae = {
  "item-wrapper": "lc-PickerListItem-module__item-wrapper___xIByl",
  "item-wrapper__first": "lc-PickerListItem-module__item-wrapper__first___qcOML",
  "item-wrapper__last": "lc-PickerListItem-module__item-wrapper__last___Ac2Y-",
  "picker-list__item": "lc-PickerListItem-module__picker-list__item___Pvh-4",
  "picker-list__item--select-all": "lc-PickerListItem-module__picker-list__item--select-all___P0GzV",
  "picker-list__item__header": "lc-PickerListItem-module__picker-list__item__header___Besp-",
  "picker-list__item__custom": "lc-PickerListItem-module__picker-list__item__custom___UbY70",
  "picker-list__item__checkbox": "lc-PickerListItem-module__picker-list__item__checkbox___d5uLj",
  "picker-list__item__avatar": "lc-PickerListItem-module__picker-list__item__avatar___9AS0i",
  "picker-list__item__icon": "lc-PickerListItem-module__picker-list__item__icon___x6wiv",
  "picker-list__item__label-container": "lc-PickerListItem-module__picker-list__item__label-container___emTD1",
  "picker-list__item__label": "lc-PickerListItem-module__picker-list__item__label___kAkZc",
  "picker-list__item__main-label": "lc-PickerListItem-module__picker-list__item__main-label___8CJdc",
  "picker-list__item__secondary-label": "lc-PickerListItem-module__picker-list__item__secondary-label___i-DOd"
}, ut = "picker-list__item", Vn = ({
  index: e,
  isActive: t,
  isSelected: r,
  listElementsRef: o,
  onSelect: _,
  getItemProps: l,
  item: i,
  numberOfItems: n
}) => {
  const d = (c) => {
    var m, f;
    if ((m = c == null ? void 0 : c.customElement) != null && m.listItemBody)
      return /* @__PURE__ */ a("div", { className: Ae[`${ut}__custom`], children: c.customElement.listItemBody });
    const p = (g) => {
      var y;
      return ((y = g.avatar) == null ? void 0 : y.type) || (g.avatarSrc ? "image" : "text");
    };
    return /* @__PURE__ */ h(Q, { children: [
      c.showCheckbox && /* @__PURE__ */ a(
        zr,
        {
          className: Ae[`${ut}__checkbox`],
          checked: r
        }
      ),
      c.icon && /* @__PURE__ */ a(
        R,
        {
          className: Ae[`${ut}__icon`],
          kind: "link",
          source: c.icon
        }
      ),
      (c.avatar || c.avatarSrc) && /* @__PURE__ */ a(
        Io,
        {
          className: Ae[`${ut}__avatar`],
          src: ((f = c.avatar) == null ? void 0 : f.src) || c.avatarSrc,
          type: p(c),
          text: c.name,
          alt: c.name,
          size: "xxsmall"
        }
      ),
      /* @__PURE__ */ h("div", { className: Ae[`${ut}__label-container`], children: [
        /* @__PURE__ */ a(
          F,
          {
            as: "span",
            className: u([Ae[`${ut}__label`]], {
              [Ae[`${ut}__main-label`]]: c.secondaryText
            }),
            "aria-disabled": c.disabled,
            children: c.name
          }
        ),
        c.secondaryText && /* @__PURE__ */ a("span", { className: Ae[`${ut}__secondary-label`], children: c.secondaryText })
      ] })
    ] });
  };
  if (i.groupHeader)
    return /* @__PURE__ */ a(
      "div",
      B(v({
        id: `item-${e}`,
        role: "group",
        className: Ae[`${ut}__header`]
      }, l()), {
        children: /* @__PURE__ */ a(pe, { size: "2xs", uppercase: !0, bold: !0, as: "div", children: i.name })
      }),
      i.key
    );
  const s = (c) => {
    !i.disabled && _(c);
  };
  return /* @__PURE__ */ a(
    "div",
    B(v({
      id: i.key,
      tabIndex: t ? 0 : -1,
      ref: (c) => {
        c && (o.current[e] = c);
      },
      role: "option",
      "aria-setsize": n,
      "aria-posinset": e + 1
    }, l({
      onClick: () => s(i.key)
    })), {
      className: u(Ae["item-wrapper"], {
        [Ae["item-wrapper__first"]]: e === 0 && !i.groupHeader,
        [Ae["item-wrapper__last"]]: e === n - 1 && !i.groupHeader
      }),
      children: /* @__PURE__ */ h(
        "div",
        {
          "aria-selected": r,
          "aria-disabled": i.disabled,
          "aria-current": t && !i.disabled,
          className: u(Ae[ut], {
            [Ae[`${ut}--select-all`]]: i.key === ya
          }),
          children: [
            d(i),
            r && !i.showCheckbox && /* @__PURE__ */ a(
              R,
              {
                kind: "link",
                source: wa,
                customColor: "var(--content-basic-info)"
              }
            )
          ]
        }
      )
    }),
    i.key
  );
}, Wn = "lc-PickerList-module__listbox___GgFk0", Da = {
  listbox: Wn,
  "no-results": "lc-PickerList-module__no-results___JSeou",
  "listbox-wrapper": "lc-PickerList-module__listbox-wrapper___1mIgW",
  "no-results-text": "lc-PickerList-module__no-results-text___r-f51"
}, L_ = ({
  context: e,
  setFloating: t,
  floatingStyles: r,
  maxHeight: o,
  options: _,
  activeIndex: l,
  selectedKeys: i,
  listElementsRef: n,
  isPositioned: d,
  searchDisabled: s,
  onItemRemove: c,
  setPointer: p,
  onSelect: m,
  getFloatingProps: f,
  getItemProps: g,
  emptyStateText: y = "No results found",
  hideWhenEmpty: x = !1,
  pickerType: S = "single",
  listClassName: E,
  virtuosoProps: $
}) => {
  const [w, N] = b.useState(0), k = Kt(null), C = _.length, I = b.useCallback(
    (A) => {
      A !== w && (A < o ? N(A + (C - 1) * Sn) : N(o));
    },
    [C]
  );
  if (z(() => {
    var A;
    s && d && l !== null && ((A = k.current) == null || A.focus());
  }, [s, d, l]), z(() => {
    n.current = new Array(_.length);
  }, [_.length]), _.length === 0)
    return x ? null : /* @__PURE__ */ a(ko, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ a(
      "div",
      {
        className: u(Da.listbox, Da["no-results"]),
        ref: t,
        tabIndex: -1,
        style: r,
        children: /* @__PURE__ */ a("div", { className: Da["no-results-text"], children: y })
      }
    ) });
  const T = (A) => i.includes(A) || A === ya && i.length === $o(_).length, M = () => {
    S === "multi" && c(i[i.length - 1]);
  };
  return /* @__PURE__ */ a(ko, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ a(
    "div",
    {
      "data-testid": "picker-list",
      ref: t,
      tabIndex: -1,
      className: u(Da.listbox, E),
      style: B(v({}, r), {
        maxHeight: o
      }),
      children: /* @__PURE__ */ a(
        "div",
        B(v({
          ref: k,
          tabIndex: 0,
          "aria-multiselectable": S === "multi",
          className: Da["listbox-wrapper"]
        }, f({
          onKeyDown(A) {
            p(!1), A.key === "Enter" && l !== null && m(_[l].key), (A.key === "Backspace" || A.key === "Delete") && M(), A.key === " " && A.preventDefault();
          },
          onKeyUp(A) {
            A.key === " " && l !== null && m(_[l].key);
          },
          onPointerMove() {
            p(!0);
          }
        })), {
          children: /* @__PURE__ */ a(
            Kl,
            B(v({
              totalListHeightChanged: I,
              style: { height: `${w}px`, maxHeight: o },
              totalCount: _.length,
              data: _,
              increaseViewportBy: 200
            }, $), {
              itemContent: (A, D) => /* @__PURE__ */ a(
                Vn,
                {
                  index: A,
                  getItemProps: g,
                  listElementsRef: n,
                  isActive: l === A,
                  isSelected: T(D.key),
                  onSelect: m,
                  item: D,
                  numberOfItems: C
                }
              )
            })
          )
        })
      )
    }
  ) });
}, De = {
  "picker-trigger": "lc-PickerTrigger-module__picker-trigger___nSDgb",
  "picker-trigger--multi-select": "lc-PickerTrigger-module__picker-trigger--multi-select___XCt1K",
  "picker-trigger--multi-select--with-items": "lc-PickerTrigger-module__picker-trigger--multi-select--with-items___0VU14",
  "picker-trigger__content": "lc-PickerTrigger-module__picker-trigger__content___tAfyM",
  "picker-trigger__content--compact": "lc-PickerTrigger-module__picker-trigger__content--compact___iudK8",
  "picker-trigger__content--medium": "lc-PickerTrigger-module__picker-trigger__content--medium___1TZtT",
  "picker-trigger__content--large": "lc-PickerTrigger-module__picker-trigger__content--large___VUVXl",
  "picker-trigger__content--with-items": "lc-PickerTrigger-module__picker-trigger__content--with-items___6R0wr",
  "picker-trigger__controls": "lc-PickerTrigger-module__picker-trigger__controls___W7nRe",
  "picker-trigger__controls--compact": "lc-PickerTrigger-module__picker-trigger__controls--compact___y9w3B",
  "picker-trigger__controls--medium": "lc-PickerTrigger-module__picker-trigger__controls--medium___FYWxm",
  "picker-trigger__controls--large": "lc-PickerTrigger-module__picker-trigger__controls--large___jHbAJ",
  "picker-trigger__clear-icon": "lc-PickerTrigger-module__picker-trigger__clear-icon___Jgz6U",
  "picker-trigger__chevron-icon": "lc-PickerTrigger-module__picker-trigger__chevron-icon___Itnmh",
  "picker-trigger--disabled": "lc-PickerTrigger-module__picker-trigger--disabled___PKfb-",
  "picker-trigger--focused": "lc-PickerTrigger-module__picker-trigger--focused___xbQpR",
  "picker-trigger--error": "lc-PickerTrigger-module__picker-trigger--error___As8hf"
}, Ne = "picker-trigger", Kn = ({
  setReference: e,
  getReferenceProps: t,
  testId: r,
  size: o = "medium",
  isMultiSelect: _,
  isItemSelected: l,
  hideClearButton: i,
  isDisabled: n,
  isRequired: d,
  isOpen: s,
  isError: c,
  onClear: p,
  children: m,
  setTriggerFocus: f,
  onToggle: g
}) => {
  const y = u(
    De[Ne],
    De[`${Ne}--${o}`],
    _ && De[`${Ne}--multi-select`],
    _ && l && De[`${Ne}--multi-select--with-items`],
    n && De[`${Ne}--disabled`],
    s && De[`${Ne}--focused`],
    c && De[`${Ne}--error`]
  ), x = !i && l && !n && !d, S = ($) => {
    $.stopPropagation(), p();
  }, E = ($) => {
    !n && !(s && $.target.tagName === "BUTTON") && g();
  };
  return b.useEffect(() => {
    s || f(!1);
  }, [s]), /* @__PURE__ */ h(
    "button",
    B(v({
      tabIndex: n ? -1 : 0,
      "aria-disabled": n,
      disabled: n,
      className: y,
      "data-testid": r,
      ref: e,
      type: "button"
    }, t()), {
      onFocus: () => f(!0),
      onBlur: () => f(!1),
      onClick: E,
      children: [
        /* @__PURE__ */ a(
          F,
          {
            as: "div",
            className: u(
              De[`${Ne}__content`],
              De[`${Ne}__content--${o}`],
              _ && l && De[`${Ne}__content--with-items`]
            ),
            children: m
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: u(
              De[`${Ne}__controls`],
              De[`${Ne}__controls--${o}`]
            ),
            children: [
              x && /* @__PURE__ */ a(
                "div",
                {
                  "data-testid": `${Ne}__clear-icon`,
                  className: De[`${Ne}__clear-icon`],
                  onClick: S,
                  children: /* @__PURE__ */ a(R, { kind: "primary", size: "small", source: ct })
                }
              ),
              /* @__PURE__ */ a(
                R,
                {
                  "data-testid": `${Ne}__chevron-icon`,
                  className: De[`${Ne}__chevron-icon`],
                  source: s ? Rr : na,
                  size: "medium",
                  disabled: n
                }
              )
            ]
          }
        )
      ]
    })
  );
}, Yn = "lc-Tag-module__tag___0Cfjz", Xn = "lc-Tag-module__tag__remove___dYHt9", Zn = "lc-Tag-module__tag__node___3hHHq", jn = "lc-Tag-module__tag__content___w-HK1", ze = {
  tag: Yn,
  "tag__content-wrapper": "lc-Tag-module__tag__content-wrapper___QrjSg",
  "tag--success": "lc-Tag-module__tag--success___Jr03z",
  tag__remove: Xn,
  "tag--error": "lc-Tag-module__tag--error___zAr59",
  "tag--warning": "lc-Tag-module__tag--warning___6FwV2",
  "tag--info": "lc-Tag-module__tag--info___Zk-om",
  "tag--purple": "lc-Tag-module__tag--purple___8cY3y",
  "tag--black": "lc-Tag-module__tag--black___hGskP",
  "tag--outline": "lc-Tag-module__tag--outline___d-iCv",
  "tag--gray": "lc-Tag-module__tag--gray___EKXt6",
  "tag--gradient01": "lc-Tag-module__tag--gradient01___MStHW",
  "tag--gradient02": "lc-Tag-module__tag--gradient02___9tDwp",
  "tag--gradient03": "lc-Tag-module__tag--gradient03___-Sy8M",
  "tag--gradient04": "lc-Tag-module__tag--gradient04___WA5o6",
  "tag--gradient05": "lc-Tag-module__tag--gradient05___RUXqI",
  "tag--gradient06": "lc-Tag-module__tag--gradient06___FucnK",
  "tag--gradient07": "lc-Tag-module__tag--gradient07___d4-hS",
  "tag--gradient08": "lc-Tag-module__tag--gradient08___cSb8n",
  "tag--gradient09": "lc-Tag-module__tag--gradient09___rqbii",
  "tag--gradient10": "lc-Tag-module__tag--gradient10___5GHLp",
  "tag--gradient11": "lc-Tag-module__tag--gradient11___c6LfC",
  "tag--medium": "lc-Tag-module__tag--medium___lxV77",
  "tag--small": "lc-Tag-module__tag--small___plGiu",
  "tag--icon-only": "lc-Tag-module__tag--icon-only___WYMzu",
  "tag--large": "lc-Tag-module__tag--large___IUzeG",
  "tag--xlarge": "lc-Tag-module__tag--xlarge___2i2T7",
  "tag--text-white": "lc-Tag-module__tag--text-white___Gc3-T",
  "tag--text-black": "lc-Tag-module__tag--text-black___0UD4h",
  "tag--dismissible-on-hover": "lc-Tag-module__tag--dismissible-on-hover___Id-yT",
  "tag__remove--hover": "lc-Tag-module__tag__remove--hover___tILiT",
  tag__node: Zn,
  tag__content: jn
}, Ve = "tag", Jn = (e) => e ? Eo(e, "#FFFFFF") > 4.5 ? "text-white" : "text-black" : "", q_ = (g) => {
  var y = g, {
    className: e = "",
    children: t,
    dismissibleOnHover: r = !1,
    disabled: o = !1,
    size: _ = "medium",
    kind: l = "default",
    onRemove: i,
    outline: n = !1,
    leftNode: d,
    rightNode: s,
    customColor: c,
    iconOnly: p = !1,
    value: m
  } = y, f = U(y, [
    "className",
    "children",
    "dismissibleOnHover",
    "disabled",
    "size",
    "kind",
    "onRemove",
    "outline",
    "leftNode",
    "rightNode",
    "customColor",
    "iconOnly",
    "value"
  ]);
  const x = r || i && p, S = u(
    ze[Ve],
    e,
    ze[`${Ve}--${_}`],
    ze[`${Ve}--${l}`],
    {
      [ze[`${Ve}--outline`]]: n,
      [ze[`${Ve}--${Jn(c)}`]]: !!c,
      [ze[`${Ve}--icon-only`]]: p,
      [ze[`${Ve}--dismissible-on-hover`]]: x
    }
  ), E = _ === "small" ? "small" : "medium", $ = _ === "small" ? "sm" : "md", w = () => c ? n ? {
    style: {
      backgroundColor: "transparent",
      color: c,
      borderColor: c
    }
  } : { style: { backgroundColor: c } } : {}, N = () => {
    if (c)
      return n ? c : Eo(c, "#FFFFFF") > 4.5 ? "#FFFFFF" : "#000000";
  };
  return /* @__PURE__ */ h(
    F,
    B(v(v({
      className: S
    }, f), w()), {
      as: "div",
      size: $,
      children: [
        /* @__PURE__ */ h("div", { className: ze[`${Ve}__content-wrapper`], children: [
          d && !p && /* @__PURE__ */ a(
            "div",
            {
              "data-testid": "lc-tag-left-node",
              className: ze[`${Ve}__node`],
              style: { color: N() },
              children: d
            }
          ),
          /* @__PURE__ */ a("div", { className: ze[`${Ve}__content`], children: m || t }),
          s && !p && /* @__PURE__ */ a(
            "div",
            {
              "data-testid": "lc-tag-right-node",
              className: ze[`${Ve}__node`],
              style: { color: N() },
              children: s
            }
          )
        ] }),
        i && !o && /* @__PURE__ */ a(
          "span",
          {
            tabIndex: -1,
            title: "Remove",
            onClick: i,
            role: "button",
            "aria-label": "Remove tag",
            className: u(ze[`${Ve}__remove`], {
              [ze[`${Ve}__remove--hover`]]: x
            }),
            children: /* @__PURE__ */ a(
              R,
              {
                "data-dismiss-icon": !0,
                source: ct,
                size: E,
                customColor: N()
              }
            )
          }
        )
      ]
    })
  );
}, Oe = {
  "picker-trigger-body": "lc-PickerTriggerBody-module__picker-trigger-body___598fZ",
  "picker-trigger-body--single": "lc-PickerTriggerBody-module__picker-trigger-body--single___irxmq",
  "picker-trigger-body__item-container": "lc-PickerTriggerBody-module__picker-trigger-body__item-container___AnGk3",
  "picker-trigger-body__item": "lc-PickerTriggerBody-module__picker-trigger-body__item___k1S-g",
  "picker-trigger-body__item__content": "lc-PickerTriggerBody-module__picker-trigger-body__item__content___SKkl7",
  "picker-trigger-body__item__avatar": "lc-PickerTriggerBody-module__picker-trigger-body__item__avatar___gW6Qa",
  "picker-trigger-body__item__icon": "lc-PickerTriggerBody-module__picker-trigger-body__item__icon___TQrP2",
  "picker-trigger-body__placeholder": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder___IdI0e",
  "picker-trigger-body__placeholder--disabled": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder--disabled___24BT1",
  "picker-trigger-body__input": "lc-PickerTriggerBody-module__picker-trigger-body__input___O7ypn",
  "picker-trigger-body__input--compact": "lc-PickerTriggerBody-module__picker-trigger-body__input--compact___0ml2Q",
  "picker-trigger-body__input--medium": "lc-PickerTriggerBody-module__picker-trigger-body__input--medium___Hstke",
  "picker-trigger-body__input--large": "lc-PickerTriggerBody-module__picker-trigger-body__input--large___jQE7Q",
  "picker-trigger-body__tag": "lc-PickerTriggerBody-module__picker-trigger-body__tag___usvP3",
  "picker-trigger-body__tag--compact": "lc-PickerTriggerBody-module__picker-trigger-body__tag--compact___o4dKd",
  "picker-trigger-body__tag--medium": "lc-PickerTriggerBody-module__picker-trigger-body__tag--medium___uU1CL",
  "picker-trigger-body__tag--large": "lc-PickerTriggerBody-module__picker-trigger-body__tag--large___IBtox"
}, Pe = "picker-trigger-body", Qn = ({
  isOpen: e,
  isSearchDisabled: t,
  isDisabled: r,
  placeholder: o,
  selectedItems: _,
  type: l,
  clearSearchAfterSelection: i,
  size: n = "medium",
  onItemRemove: d,
  onSelect: s,
  onFilter: c,
  onClear: p,
  searchPhrase: m,
  virtualItemRef: f,
  isTriggerFocused: g,
  inputRef: y,
  inputProps: x
}) => {
  const S = e && !t;
  b.useEffect(() => {
    i && y != null && y.current && y.current.focus();
  }, [_, i]);
  const E = (C) => {
    C.key === "Backspace" && _ && _.length > 0 && (C.preventDefault(), l === "multi" ? d(_[_.length - 1].key) : p()), C.key === "Delete" && (C.preventDefault(), p());
  };
  b.useEffect(() => (!e && g ? document.addEventListener("keydown", E) : document.removeEventListener("keydown", E), () => document.removeEventListener("keydown", E)), [e, _, g]);
  const $ = (C) => {
    var I;
    return l === "single" && e && !t ? null : (I = C == null ? void 0 : C.customElement) != null && I.selectedItemBody ? /* @__PURE__ */ a("div", { className: Oe[`${Pe}__item`], children: C.customElement.selectedItemBody }) : /* @__PURE__ */ h("div", { className: Oe[`${Pe}__item`], children: [
      C.icon && /* @__PURE__ */ a(
        R,
        {
          source: C.icon,
          className: Oe[`${Pe}__item__icon`]
        }
      ),
      C.avatarSrc && /* @__PURE__ */ a(
        "img",
        {
          src: C.avatarSrc,
          alt: "",
          className: Oe[`${Pe}__item__avatar`]
        }
      ),
      /* @__PURE__ */ a("div", { className: Oe[`${Pe}__item__content`], children: C.name })
    ] });
  }, w = (C) => c(C.target.value), N = (C) => {
    var I, T;
    (I = f.current) != null && I.id && C.key === "Enter" && s((T = f.current) == null ? void 0 : T.id), l === "multi" && (C.key === "Backspace" || C.key === "Delete") && !m && _ && (_ == null ? void 0 : _.length) > 0 && d(_[_.length - 1].key);
  }, k = () => /* @__PURE__ */ a(
    "input",
    B(v({}, x), {
      ref: y,
      className: u(
        Oe[`${Pe}__input`],
        Oe[`${Pe}__input--${n}`]
      ),
      placeholder: o,
      onChange: w,
      onKeyDown: N,
      autoFocus: !0,
      value: m
    })
  );
  return !_ || _.length === 0 ? S ? k() : /* @__PURE__ */ a(
    "div",
    {
      className: u({
        [Oe[`${Pe}__placeholder`]]: !0,
        [Oe[`${Pe}__placeholder--disabled`]]: r
      }),
      children: o
    }
  ) : /* @__PURE__ */ h(
    "div",
    {
      className: u(Oe[Pe], {
        [Oe[`${Pe}--single`]]: l === "single"
      }),
      children: [
        /* @__PURE__ */ a("div", { className: Oe[`${Pe}__item-container`], children: l === "single" ? $(_[0]) : _.map((C) => /* @__PURE__ */ a(
          q_,
          B(v({
            className: u(
              Oe[`${Pe}__tag`],
              Oe[`${Pe}__tag--${n}`]
            ),
            disabled: r,
            onRemove: (I) => {
              I.stopPropagation(), d(C.key);
            }
          }, C.selectedTagOptions), {
            children: $(C)
          }),
          C.key
        )) }),
        S && k()
      ]
    }
  );
}, ec = 10, H_ = ({
  disabled: e,
  items: t,
  placement: r,
  minListHeight: o,
  maxListHeight: _,
  floatingStrategy: l,
  useDismissHookProps: i,
  useClickHookProps: n,
  isOpen: d,
  onVisibilityChange: s,
  searchPhrase: c
}) => {
  const p = ar(), [m, f] = b.useState(!1), [g, y] = b.useState(null), [x, S] = b.useState(_), E = b.useRef([]), $ = b.useRef(null);
  b.useEffect(() => {
    $.current = null, y(null);
  }, [c]);
  const { refs: w, floatingStyles: N, context: k, isPositioned: C } = rr({
    nodeId: p,
    open: d,
    strategy: l,
    onOpenChange: s,
    whileElementsMounted: _r,
    placement: r,
    middleware: [
      or(4),
      Ur({ padding: 10 }),
      xo(),
      C_({
        apply({ availableHeight: L, rects: O, elements: q }) {
          zl.flushSync(() => {
            S(
              Math.max(
                Math.min(_, Number(L)),
                o
              )
            );
          }), Object.assign(q.floating.style, {
            width: `${O.reference.width}px`
          });
        },
        padding: ec
      })
    ]
  }), I = lr(k, v({
    enabled: !e,
    keyboardHandlers: !1,
    toggle: !1
  }, n)), T = nr(k, { role: "listbox" }), M = ir(k, i), A = ql(k, {
    enabled: t.length > 0 && !e,
    listRef: E,
    activeIndex: g,
    onNavigate: y,
    virtual: !0,
    virtualItemRef: $,
    disabledIndices: xn(
      t,
      (L) => !!L.disabled || !!L.groupHeader
    )
  }), { getReferenceProps: D, getFloatingProps: G, getItemProps: P } = cr(
    [I, M, T, A]
  );
  return !d && m && f(!1), {
    getReferenceProps: D,
    getFloatingProps: G,
    getItemProps: P,
    setReference: w.setReference,
    floatingStyles: N,
    isPositioned: C,
    context: k,
    nodeId: p,
    setFloating: w.setFloating,
    activeIndex: g,
    listElementsRef: E,
    virtualItemRef: $,
    maxHeight: x,
    pointer: m,
    setPointer: f
  };
}, z_ = ({
  selected: e,
  options: t,
  type: r,
  selectAllOptionText: o,
  onSelect: _,
  setOpen: l,
  clearSearchAfterSelection: i,
  inputRef: n
}) => {
  const [d, s] = b.useState(
    () => (e == null ? void 0 : e.map(Qo)) || []
  ), c = e !== void 0, p = c ? (e == null ? void 0 : e.map(Qo)) || [] : d, [m, f] = b.useState(""), g = (w) => f(w), y = (w) => {
    r === "single" ? $(w) : (s(p.filter((N) => N !== w)), _((e == null ? void 0 : e.filter(({ key: N }) => N !== w)) || null));
  }, x = () => {
    !c && s([]), _(null), f(""), l(!1);
  }, S = () => {
    g(""), n.current && (n.current.value = "");
  }, E = b.useMemo(() => {
    const w = r === "multi" && o;
    let N = t;
    return m && (N = N.filter((k) => {
      var M;
      if (k.groupHeader)
        return !0;
      const C = m.toLowerCase(), I = k.name.toLowerCase(), T = (M = k.secondaryText) == null ? void 0 : M.toLowerCase();
      return I.includes(C) || (T == null ? void 0 : T.includes(C));
    }).filter(
      (k, C, I) => {
        var T;
        return !(k.groupHeader && ((T = I[C + 1]) != null && T.groupHeader || C === I.length - 1));
      }
    )), w && N.length > 1 && (N = [
      {
        key: ya,
        name: o
      },
      ...N
    ]), N;
  }, [m, t, r, o]), $ = (w) => {
    const N = t.find((k) => k.key === w);
    (!N || N.disabled) && w !== ya || (r === "single" ? (s(() => (N && _([N]), [w])), l(!1), i && S()) : w === ya ? p.length === $o(t).length ? s(() => (_(null), [])) : s(() => {
      const k = $o(t);
      return _(k), k.map(({ key: C }) => C);
    }) : (c ? p.includes(w) ? (_(
      (e == null ? void 0 : e.filter(({ key: k }) => k !== w)) || null
    ), s((k) => k.filter((C) => C !== w))) : (_([...e || [], N]), s((k) => [...k, w])) : s((k) => {
      const C = En(k, w);
      return _(t.filter(({ key: I }) => C.includes(I))), C;
    }), i && S()));
  };
  return {
    selectedKeys: p,
    items: E,
    searchPhrase: m,
    handleSelect: $,
    handleOnFilter: g,
    handleItemRemove: y,
    handleClear: x
  };
}, tc = {
  "picker-wrapper": "lc-Picker-module__picker-wrapper___uaLHq"
}, yu = (O) => {
  var q = O, {
    id: e,
    className: t,
    listClassName: r,
    minListHeight: o = G_,
    maxListHeight: _ = U_,
    disabled: l,
    error: i,
    options: n,
    selected: d,
    size: s = "medium",
    placeholder: c = "Select option",
    isRequired: p,
    noSearchResultText: m = "No results found",
    selectAllOptionText: f,
    type: g = "single",
    searchDisabled: y = !1,
    hideClearButton: x,
    isVisible: S,
    onOpen: E,
    onClose: $,
    openedOnInit: w = !1,
    clearSearchAfterSelection: N = !0,
    onSelect: k,
    placement: C,
    floatingStrategy: I,
    root: T,
    useDismissHookProps: M,
    useClickHookProps: A,
    virtuosoProps: D,
    inputProps: G,
    noDataFallbackText: P = "No data"
  } = q, L = U(q, [
    "id",
    "className",
    "listClassName",
    "minListHeight",
    "maxListHeight",
    "disabled",
    "error",
    "options",
    "selected",
    "size",
    "placeholder",
    "isRequired",
    "noSearchResultText",
    "selectAllOptionText",
    "type",
    "searchDisabled",
    "hideClearButton",
    "isVisible",
    "onOpen",
    "onClose",
    "openedOnInit",
    "clearSearchAfterSelection",
    "onSelect",
    "placement",
    "floatingStrategy",
    "root",
    "useDismissHookProps",
    "useClickHookProps",
    "virtuosoProps",
    "inputProps",
    "noDataFallbackText"
  ]);
  const [Y, te] = b.useState(w), [ye, ge] = b.useState(!1), K = S !== void 0, Z = K ? S : Y, st = b.useRef(null), { readOnly: kt } = At(), Jt = kt || (G == null ? void 0 : G.readOnly), Dt = (he, Po) => {
    he ? !Z && (E == null || E(Po)) : Z && ($ == null || $(Po)), !K && te(he);
  }, {
    selectedKeys: Ot,
    items: H,
    searchPhrase: re,
    handleSelect: de,
    handleOnFilter: Ie,
    handleItemRemove: oe,
    handleClear: ca
  } = z_({
    selected: d,
    options: n,
    type: g,
    selectAllOptionText: f,
    onSelect: k,
    setOpen: Dt,
    clearSearchAfterSelection: N,
    inputRef: st
  }), {
    context: ue,
    nodeId: qe,
    getReferenceProps: Pt,
    setReference: sa,
    getFloatingProps: da,
    getItemProps: Vr,
    setFloating: Wr,
    floatingStyles: Kr,
    listElementsRef: Yr,
    virtualItemRef: Xr,
    activeIndex: Zr,
    maxHeight: jr,
    setPointer: ua,
    isPositioned: Jr
  } = H_({
    openedOnInit: w,
    disabled: l,
    items: H,
    placement: C,
    minListHeight: o,
    maxListHeight: _,
    floatingStrategy: I,
    useClickHookProps: A,
    useDismissHookProps: M,
    isOpen: Z,
    onVisibilityChange: Dt,
    searchPhrase: re
  });
  return Jt ? /* @__PURE__ */ a(
    Na,
    {
      value: d == null ? void 0 : d.map((he) => he.groupHeader ? null : he.name).filter(Boolean).join(", "),
      noDataFallbackText: P
    }
  ) : /* @__PURE__ */ h("div", { id: e, className: u(tc["picker-wrapper"], t), children: [
    /* @__PURE__ */ a(
      Kn,
      {
        getReferenceProps: Pt,
        setReference: sa,
        testId: L["data-testid"],
        isItemSelected: Ot.length > 0,
        isOpen: Z,
        onClear: ca,
        hideClearButton: x,
        isDisabled: l,
        isError: i,
        isRequired: p,
        isMultiSelect: g === "multi",
        size: s,
        setTriggerFocus: ge,
        onToggle: () => Dt(!Z),
        children: /* @__PURE__ */ a(
          Qn,
          {
            isOpen: Z,
            isSearchDisabled: y,
            isDisabled: l,
            placeholder: c,
            selectedItems: d,
            type: g,
            size: s,
            clearSearchAfterSelection: N,
            inputRef: st,
            onItemRemove: oe,
            onSelect: de,
            onFilter: Ie,
            onClear: ca,
            searchPhrase: re,
            virtualItemRef: Xr,
            isTriggerFocused: ye,
            inputProps: G
          }
        )
      }
    ),
    /* @__PURE__ */ a($a, { id: qe, children: Z && /* @__PURE__ */ a(Ca, { root: T, children: /* @__PURE__ */ a(
      L_,
      {
        pickerType: g,
        options: H,
        listClassName: r,
        context: ue,
        setFloating: Wr,
        floatingStyles: Kr,
        maxHeight: jr,
        activeIndex: Zr,
        selectedKeys: Ot,
        listElementsRef: Yr,
        searchDisabled: y,
        isPositioned: Jr,
        onItemRemove: oe,
        setPointer: ua,
        onSelect: de,
        getFloatingProps: da,
        getItemProps: Vr,
        emptyStateText: m,
        virtuosoProps: D
      }
    ) }) })
  ] });
}, ac = (e) => e !== void 0 && typeof e[0] == "string", rc = (e) => e.map((t) => ({ name: t, key: t })), oc = (e) => e.map((_) => {
  var l = _, { customElement: t, name: r } = l, o = U(l, ["customElement", "name"]);
  return v(v({
    name: r,
    key: r
  }, t && {
    customElement: {
      listItemBody: t,
      selectedItemBody: /* @__PURE__ */ a(Q, {})
    }
  }), o);
}), _c = (e, t, r, o) => {
  const _ = e.length === 1 && e[0].name === o, l = t ? e.slice(0, 1) : e;
  return r && _ ? [] : l;
}, Cu = b.forwardRef(
  (g, f) => {
    var y = g, {
      disabled: e,
      minListHeight: t = G_,
      maxListHeight: r = U_,
      autocompleteOpenOnInit: o = !1,
      placement: _,
      options: l,
      readOnly: i,
      floatingStrategy: n,
      single: d,
      alwaysShowAllOptions: s,
      hideIfExactMatch: c = !0,
      noDataFallbackText: p = "No data"
    } = y, m = U(y, [
      "disabled",
      "minListHeight",
      "maxListHeight",
      "autocompleteOpenOnInit",
      "placement",
      "options",
      "readOnly",
      "floatingStrategy",
      "single",
      "alwaysShowAllOptions",
      "hideIfExactMatch",
      "noDataFallbackText"
    ]);
    const x = b.useRef(null), { readOnly: S } = At(), E = S || i;
    b.useImperativeHandle(f, () => x.current, []);
    const [$, w] = b.useState(""), k = m.value !== void 0 ? m.value : $, [C, I] = b.useState(
      o
    ), T = (ue) => {
      I(ue);
    }, M = (ue) => {
      q(ue);
    }, A = (ue) => {
      var qe, Pt;
      (qe = m.onChange) == null || qe.call(m, ue), w(ue.target.value), s || M(ue.target.value), (Pt = x.current) == null || Pt.focus();
    }, D = (ue) => {
      var Pt, sa, da;
      const qe = ue.key === "Enter";
      (Pt = de.current) != null && Pt.id && qe && (G([{ key: (sa = de.current) == null ? void 0 : sa.id }]), ue.preventDefault()), qe || T(!0), (da = m.onKeyDown) == null || da.call(m, ue);
    }, G = (ue) => {
      if (ue) {
        const qe = ue[0].key;
        A({
          target: { value: qe }
        }), setTimeout(() => {
          T(!1);
        }, 0);
      }
    }, P = b.useMemo(() => l ? ac(l) ? rc(l) : oc(l) : [], [l]), { items: L, searchPhrase: O, handleOnFilter: q, handleSelect: Y, selectedKeys: te } = z_({
      selected: [],
      options: P,
      type: "single",
      onSelect: G,
      setOpen: I,
      clearSearchAfterSelection: !0,
      inputRef: x
    }), ye = _c(
      L,
      d || !1,
      c || !1,
      (k == null ? void 0 : k.toString()) || ""
    ), {
      nodeId: ge,
      context: K,
      setFloating: Z,
      getReferenceProps: st,
      getItemProps: kt,
      getFloatingProps: Jt,
      floatingStyles: Dt,
      maxHeight: Ot,
      setPointer: H,
      setReference: re,
      virtualItemRef: de,
      listElementsRef: Ie,
      activeIndex: oe,
      isPositioned: ca
    } = H_({
      openedOnInit: o,
      disabled: e || i,
      items: L,
      searchPhrase: s ? "" : O,
      isOpen: C,
      onVisibilityChange: T,
      minListHeight: t,
      maxListHeight: r,
      placement: _,
      floatingStrategy: n
    });
    return E ? /* @__PURE__ */ a(
      Na,
      {
        value: k == null ? void 0 : k.toString(),
        noDataFallbackText: p
      }
    ) : /* @__PURE__ */ h("div", B(v({ ref: re }, st()), { children: [
      /* @__PURE__ */ a(
        $n,
        B(v({}, m), {
          ref: x,
          onChange: A,
          onKeyDown: D,
          value: k,
          disabled: e,
          readOnly: i,
          type: "text"
        })
      ),
      /* @__PURE__ */ a($a, { id: ge, children: C && /* @__PURE__ */ a(Ca, { children: /* @__PURE__ */ a(
        L_,
        {
          context: K,
          options: ye,
          setFloating: Z,
          getFloatingProps: Jt,
          floatingStyles: Dt,
          maxHeight: Ot,
          listElementsRef: Ie,
          activeIndex: oe,
          selectedKeys: te,
          setPointer: H,
          hideWhenEmpty: !0,
          getItemProps: kt,
          onSelect: Y,
          isPositioned: ca,
          searchDisabled: !1,
          onItemRemove: tr
        }
      ) }) })
    ] }));
  }
), lc = "lc-SegmentedControl-module__btn___pG309", vr = {
  "segmented-control": "lc-SegmentedControl-module__segmented-control___v3EXg",
  btn: lc,
  "btn--active": "lc-SegmentedControl-module__btn--active___n93GT",
  "btn--compact": "lc-SegmentedControl-module__btn--compact___grlBl",
  "btn--medium": "lc-SegmentedControl-module__btn--medium___YGzgQ",
  "btn--large": "lc-SegmentedControl-module__btn--large___DCJ-p"
}, ic = "segmented-control", wu = ({
  size: e = "medium",
  buttons: t,
  className: r,
  initialId: o,
  currentId: _,
  fullWidth: l = !1,
  onButtonClick: i = tr
}) => {
  const n = u(vr[ic], r), [d, s] = b.useState(() => o), c = typeof _ == "string";
  b.useEffect(() => {
    c && s(_);
  }, [_]);
  const p = (f, g) => {
    c || s(f), i(f, g);
  }, m = t.map(({ id: f, label: g, loading: y, disabled: x, icon: S }) => {
    const E = f === d, $ = E ? vr["btn--active"] : "";
    return /* @__PURE__ */ a(
      W,
      {
        fullWidth: l,
        loading: E ? !1 : y,
        disabled: x,
        "aria-pressed": E,
        kind: "secondary",
        icon: S,
        className: u(vr.btn, vr[`btn--${e}`], $),
        onClick: (N) => {
          p(f, N);
        },
        children: g
      },
      f
    );
  });
  return /* @__PURE__ */ a("div", { role: "group", className: n, children: m });
}, nc = "lc-Card-module__card___LzN-3", cc = "lc-Card-module__card__header___SRONR", sc = "lc-Card-module__card__header__image___93pD4", dc = "lc-Card-module__card__header__heading___jK55U", uc = "lc-Card-module__card__header__heading__title___5090w", mc = "lc-Card-module__card__header__heading__description___iVYoq", pc = "lc-Card-module__card__content___9G1YM", gc = "lc-Card-module__card__actions___gp-xf", hc = "lc-Card-module__card__actions__line___C6TI0", fc = "lc-Card-module__card__actions__buttons___XJlFJ", We = {
  card: nc,
  card__header: cc,
  card__header__image: sc,
  card__header__heading: dc,
  card__header__heading__title: uc,
  card__header__heading__description: mc,
  "card__header__no-image": "lc-Card-module__card__header__no-image___2gPx6",
  card__content: pc,
  "card__expanded-content": "lc-Card-module__card__expanded-content___WBjEn",
  card__actions: gc,
  card__actions__line: hc,
  card__actions__buttons: fc,
  "card__actions__buttons-expander": "lc-Card-module__card__actions__buttons-expander___I--MQ"
}, Qa = "card", Fr = `${Qa}__header`, to = `${Fr}__heading`, kr = `${Qa}__actions`, bc = `${Fr}__no-image`, $u = (s) => {
  var c = s, {
    alt: e,
    buttonsOptions: t = [],
    children: r,
    className: o,
    description: _,
    expandableContent: l,
    src: i,
    title: n
  } = c, d = U(c, [
    "alt",
    "buttonsOptions",
    "children",
    "className",
    "description",
    "expandableContent",
    "src",
    "title"
  ]);
  const [p, m] = b.useState(!1), f = p ? Rr : na, g = p ? "Hide" : "Show more", y = (t == null ? void 0 : t.length) > 0, x = !!l, S = y || x, E = n, $ = i, w = $ ? "" : We[bc];
  return /* @__PURE__ */ h("div", B(v({ className: u(We[Qa], o) }, d), { children: [
    E && /* @__PURE__ */ h("div", { className: u(We[Fr], w), children: [
      $ && /* @__PURE__ */ a(
        "img",
        {
          alt: e,
          className: We[`${Fr}__image`],
          src: i
        }
      ),
      /* @__PURE__ */ h("div", { className: We[to], children: [
        /* @__PURE__ */ a(pe, { size: "xs", className: We[`${to}__title`], children: n }),
        _ && /* @__PURE__ */ a(
          F,
          {
            size: "sm",
            className: We[`${to}__description`],
            children: _
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a(F, { as: "div", size: "md", className: We[`${Qa}__content`], children: r }),
    p && /* @__PURE__ */ a(
      F,
      {
        as: "div",
        size: "md",
        className: We[`${Qa}__expanded-content`],
        children: l
      }
    ),
    S && /* @__PURE__ */ h("div", { className: We[kr], children: [
      /* @__PURE__ */ a("div", { className: We[`${kr}__line`] }),
      /* @__PURE__ */ h("div", { className: We[`${kr}__buttons`], children: [
        y && t.map(
          ({ kind: N, onClick: k, children: C }, I) => /* @__PURE__ */ a(
            W,
            {
              size: "compact",
              kind: N,
              onClick: k,
              children: C
            },
            I
          )
        ),
        x && /* @__PURE__ */ a(
          W,
          {
            className: We[`${kr}__buttons-expander`],
            kind: "link",
            iconPosition: "right",
            icon: /* @__PURE__ */ a(R, { source: f }),
            onClick: () => m(!p),
            children: g
          }
        )
      ] })
    ] })
  ] }));
}, ao = {
  "date-picker-custom-navigation": "lc-DatePickerCustomNavigation-module__date-picker-custom-navigation___B7uEJ"
}, ro = "date-picker-custom-navigation", vc = ({ currentMonth: e, setMonth: t, startMonth: r, endMonth: o, numberOfMonths: _ }) => {
  const l = r && Ja(e, r), i = o && Ja(e, o), n = () => {
    const p = new Date(e);
    p.setMonth(e.getMonth() - 1), t(p);
  }, d = () => {
    const p = new Date(e);
    p.setMonth(e.getMonth() + 1), t(p);
  }, s = () => {
    if (!r) {
      const f = ra(e, 12);
      return t(f);
    }
    const p = Math.abs(Ro(e, r)), m = ra(
      e,
      !Number.isNaN(p) && p > 12 ? 12 : p
    );
    return t(m);
  }, c = () => {
    if (!o) {
      const f = Go(e, 12);
      return t(f);
    }
    const p = Math.abs(Ro(o, e)), m = Go(
      e,
      !Number.isNaN(p) && p > 12 ? 12 : p
    );
    return _ === 2 && Ja(m, o) ? t(ra(m, 1)) : t(m);
  };
  return /* @__PURE__ */ h("div", { className: ao[ro], children: [
    /* @__PURE__ */ h("div", { className: ao[`${ro}__nav-wrapper`], children: [
      /* @__PURE__ */ a(
        W,
        {
          "data-testid": "date-picker-prev-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ a(R, { source: dl }),
          onClick: s,
          disabled: l
        }
      ),
      /* @__PURE__ */ a(
        W,
        {
          "data-testid": "date-picker-prev-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ a(R, { source: ul }),
          onClick: n,
          disabled: l
        }
      )
    ] }),
    /* @__PURE__ */ h("div", { className: ao[`${ro}__nav-wrapper`], children: [
      /* @__PURE__ */ a(
        W,
        {
          "data-testid": "date-picker-next-month-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ a(R, { source: Mr }),
          onClick: d,
          disabled: i
        }
      ),
      /* @__PURE__ */ a(
        W,
        {
          "data-testid": "date-picker-next-year-button",
          kind: "plain",
          size: "xcompact",
          icon: /* @__PURE__ */ a(R, { source: ml }),
          onClick: c,
          disabled: i
        }
      )
    ] })
  ] });
}, V_ = (e, t) => {
  const { from: r, to: o } = t;
  return !(o && !yo(e, o) && Co(e, o) || r && !yo(e, r) && !Co(e, r));
}, W_ = (e, t, r) => t ? e && !Ja(e, t) || r && Ja(t, r) ? ra(t, 1) : t : ra(r || /* @__PURE__ */ new Date(), 1), Za = (e, t) => {
  const r = t == null ? void 0 : t.find((o) => o.id === e);
  return r || void 0;
}, t_ = (e, t) => !!(!e || e && t), kc = (e) => {
  const t = {};
  if (!e.initialSelectedItemKey)
    return t;
  const r = Za(
    e.initialSelectedItemKey,
    e.options
  );
  return r ? (t.selectedItem = e.initialSelectedItemKey, r.isManual && (e.initialFromDate && (t.from = e.initialFromDate), e.initialToDate && (t.to = e.initialToDate, t.temporaryTo = e.initialToDate)), t) : {};
}, Ge = {
  "date-picker": "lc-DatePicker-module__date-picker___MOZFY",
  "date-picker__wrapper": "lc-DatePicker-module__date-picker__wrapper___aOFS3",
  "date-picker__weekday": "lc-DatePicker-module__date-picker__weekday___bdNjp",
  "date-picker__day": "lc-DatePicker-module__date-picker__day___L1YZn",
  "date-picker__day-button": "lc-DatePicker-module__date-picker__day-button___vy3Hd",
  "date-picker__today": "lc-DatePicker-module__date-picker__today___w404B",
  "date-picker__selected": "lc-DatePicker-module__date-picker__selected___FEDMB",
  "date-picker__month-caption": "lc-DatePicker-module__date-picker__month-caption___lMrSe",
  "date-picker__range-start": "lc-DatePicker-module__date-picker__range-start___-VnVk",
  "date-picker__range-middle": "lc-DatePicker-module__date-picker__range-middle___Xvj7k",
  "date-picker__range-end": "lc-DatePicker-module__date-picker__range-end___ux1xQ",
  "date-picker__disabled": "lc-DatePicker-module__date-picker__disabled___A8sSm"
}, Ke = "date-picker", yc = (d) => {
  var s = d, {
    month: e,
    weekStartsOn: t = 1,
    fromMonth: r,
    startMonth: o,
    toMonth: _,
    endMonth: l,
    onMonthChange: i
  } = s, n = U(s, [
    "month",
    "weekStartsOn",
    "fromMonth",
    "startMonth",
    "toMonth",
    "endMonth",
    "onMonthChange"
  ]);
  const [c, p] = b.useState(e || /* @__PURE__ */ new Date());
  b.useEffect(() => {
    e && e !== c && p(e);
  }, [e, c]), b.useEffect(() => {
    _ && e !== c && (V_(c, { from: r, to: _ }) || p(_));
  }, [e, c, _, r]);
  const m = b.useCallback(
    (f) => {
      if (i) {
        i(f);
        return;
      }
      p(f);
    },
    [e, i]
  );
  return /* @__PURE__ */ a("div", { className: Ge[`${Ke}`], children: /* @__PURE__ */ a(
    Yl,
    v({
      classNames: {
        weekday: u(
          Ge[`${Ke}__wrapper`],
          Ge[`${Ke}__weekday`]
        ),
        day: u(Ge[`${Ke}__wrapper`], Ge[`${Ke}__day`]),
        day_button: u(Ge[`${Ke}__day-button`]),
        today: u(Ge[`${Ke}__today`]),
        selected: u(Ge[`${Ke}__selected`]),
        month_caption: u(Ge[`${Ke}__month-caption`]),
        range_start: u(Ge[`${Ke}__range-start`]),
        range_middle: u(Ge[`${Ke}__range-middle`]),
        range_end: u(Ge[`${Ke}__range-end`]),
        disabled: u(Ge[`${Ke}__disabled`])
      },
      onMonthChange: m,
      month: c,
      components: {
        CaptionLabel: ({ children: f }) => /* @__PURE__ */ a(F, { as: "span", bold: !0, children: f }),
        Nav: () => /* @__PURE__ */ a(
          vc,
          {
            currentMonth: c,
            setMonth: m,
            startMonth: o || r,
            endMonth: l || _
          }
        )
      },
      startMonth: o || r,
      endMonth: l || _,
      weekStartsOn: t
    }, n)
  ) });
};
var V = /* @__PURE__ */ ((e) => (e.NEW_SELECTED_ITEM = "NEW_SELECTED_ITEM", e.NEW_TEMPORARY_FROM_VALUE = "NEW_TEMPORARY_FROM_VALUE", e.NEW_TEMPORARY_TO_VALUE = "NEW_TEMPORARY_TO_VALUE", e.CLEAR = "CLEAR", e.SET_FROM = "SET_FROM", e.SET_TO = "SET_TO", e.SELECT_FIRST_DAY = "SELECT_FIRST_DAY", e.SELECT_SECOND_DAY_AS_FROM = "SELECT_SECOND_DAY_AS_FROM", e.SELECT_SECOND_DAY_AS_TO = "SELECT_SECOND_DAY_AS_TO", e.CURRENT_MONTH_CHANGE = "CURRENT_MONTH_CHANGE", e.SET_CUSTOM_TEMP_RANGE = "SET_CUSTOM_TEMP_RANGE", e))(V || {});
const Cc = (e) => {
  const t = W_(
    e.initialFromDate,
    e.initialToDate,
    e.toMonth
  ), o = v(v({}, {
    selectedItem: null,
    from: void 0,
    to: void 0,
    temporaryTo: void 0,
    currentMonth: t,
    customTempFrom: void 0,
    customTempTo: void 0
  }), kc(e));
  function _(l, i) {
    switch (i.type) {
      case V.NEW_SELECTED_ITEM:
        return {
          selectedItem: i.payload.selectedItem,
          from: void 0,
          to: void 0,
          temporaryTo: void 0,
          currentMonth: t
        };
      case V.NEW_TEMPORARY_FROM_VALUE:
        return B(v({}, l), {
          temporaryFrom: i.payload.date
        });
      case V.NEW_TEMPORARY_TO_VALUE:
        return B(v({}, l), {
          temporaryTo: i.payload.date
        });
      case V.SELECT_FIRST_DAY:
        return B(v({}, l), {
          from: i.payload.date,
          to: void 0,
          temporaryFrom: void 0,
          temporaryTo: void 0,
          customTempFrom: void 0,
          customTempTo: void 0
        });
      case V.SELECT_SECOND_DAY_AS_FROM:
        return B(v({}, l), {
          from: i.payload.date,
          to: l.from,
          temporaryTo: l.from
        });
      case V.SELECT_SECOND_DAY_AS_TO:
        return B(v({}, l), {
          to: i.payload.date,
          temporaryTo: i.payload.date
        });
      case V.CURRENT_MONTH_CHANGE:
        return B(v({}, l), {
          currentMonth: i.payload.date
        });
      case V.SET_FROM:
        return B(v({}, l), {
          from: i.payload.date
        });
      case V.SET_TO:
        return B(v({}, l), {
          to: i.payload.date
        });
      case V.SET_CUSTOM_TEMP_RANGE:
        return B(v({}, l), {
          customTempFrom: i.payload.customTempFrom,
          customTempTo: i.payload.customTempTo
        });
      default:
        return l;
    }
  }
  return ll(_, o);
}, K_ = ({
  options: e,
  initialSelectedItemKey: t,
  initialFromDate: r,
  initialToDate: o,
  customTempFromDate: _,
  customTempToDate: l,
  toMonth: i,
  today: n,
  onChange: d,
  onRangeSelect: s,
  onSelect: c,
  onCustomTempDateRangeChange: p,
  children: m
}) => {
  const f = Kt(
    t || null
  ), [g, y] = Cc({
    initialFromDate: r,
    initialToDate: o,
    toMonth: i,
    options: e,
    initialSelectedItemKey: t,
    customTempFromDate: _,
    customTempToDate: l,
    children: m,
    onChange: d,
    onRangeSelect: s
  });
  z(() => {
    y({
      type: V.SET_CUSTOM_TEMP_RANGE,
      payload: {
        customTempFrom: _,
        customTempTo: l
      }
    });
  }, [_, l]), z(() => {
    y({
      type: V.SET_FROM,
      payload: { date: r }
    });
  }, [r]), z(() => {
    y({
      type: V.SET_TO,
      payload: { date: o }
    });
  }, [o]), z(() => {
    const k = W_(
      r,
      o,
      i
    );
    y({
      type: V.CURRENT_MONTH_CHANGE,
      payload: { date: k }
    });
  }, [i, r, o]), z(() => {
    const { from: k, selectedItem: C, to: I } = g;
    if (!(k && I))
      return;
    const T = Za(C, e);
    T && (d == null || d(B(v({}, T), {
      value: {
        from: k,
        to: I
      }
    })));
  }, [g.from, g.to, g.selectedItem, e, d]), z(() => {
    const { from: k, to: C } = g;
    !(k && C) || !s || s == null || s({
      from: k,
      to: C
    });
  }, [g.from, g.to, s]), z(() => {
    const { selectedItem: k } = g;
    if (k === f.current || !e)
      return;
    if (!k) {
      d == null || d(null);
      return;
    }
    if (!Za(k, e))
      return;
    const I = e.reduce(
      (T, M) => B(v({}, T), { [M.id]: M }),
      {}
    );
    d == null || d(I[k]);
  }, [d, g.selectedItem, e]), z(() => {
    p == null || p({
      from: g.temporaryFrom,
      to: g.temporaryTo
    });
  }, [g.temporaryFrom, g.temporaryTo]);
  const x = vt(() => {
    const { from: k, to: C } = g;
    k && C && c && c({
      from: k,
      to: C
    });
  }, [c]), S = vt(
    (k) => {
      const { from: C, to: I } = g, T = i ? w_(i, k) >= 0 : !0;
      C && !t_(C, I) && T && (Xl(k, C) ? (y({
        type: V.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: k }
      }), y({
        type: V.NEW_TEMPORARY_TO_VALUE,
        payload: { date: C }
      })) : (y({
        type: V.NEW_TEMPORARY_TO_VALUE,
        payload: { date: k }
      }), y({
        type: V.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: C }
      })));
    },
    [i, g.from, g.to]
  ), E = vt(
    (k) => {
      const { from: C, to: I } = g;
      V_(k, { to: i }) && (t_(C, I) ? (y({
        type: V.SELECT_FIRST_DAY,
        payload: { date: k }
      }), y({
        type: V.NEW_TEMPORARY_FROM_VALUE,
        payload: { date: k }
      }), y({
        type: V.NEW_TEMPORARY_TO_VALUE,
        payload: { date: k }
      })) : C && yo(k, C) || C && Co(k, C) ? y({
        type: V.SELECT_SECOND_DAY_AS_TO,
        payload: { date: k }
      }) : y({
        type: V.SELECT_SECOND_DAY_AS_FROM,
        payload: { date: k }
      }));
    },
    [i, g.from, g.to]
  ), $ = vt(
    (k) => {
      if (k === null) {
        y({
          type: V.NEW_SELECTED_ITEM,
          payload: { selectedItem: null }
        });
        return;
      }
      Za(k, e) && y({
        type: V.NEW_SELECTED_ITEM,
        payload: { selectedItem: k }
      });
    },
    [e]
  ), w = vt((k) => {
    y({
      type: V.CURRENT_MONTH_CHANGE,
      payload: { date: k }
    });
  }, []);
  return m((() => {
    const {
      currentMonth: k,
      from: C,
      selectedItem: I,
      temporaryFrom: T,
      temporaryTo: M,
      to: A,
      customTempFrom: D,
      customTempTo: G
    } = g, P = ka(() => Za(I, e), [e, I]), L = ka(() => ({ from: T || C, to: M }), [C, T, M]), O = ka(() => {
      if (!(!D || !G))
        return { from: D, to: G };
    }, [D, G]), q = ka(() => i ? { after: i } : void 0, [i]);
    return {
      select: {
        onItemSelect: $,
        selected: I || ""
      },
      inputs: {
        fromDate: C,
        toDate: A
      },
      datepicker: {
        mode: "range",
        month: k,
        numberOfMonths: 2,
        onDayClick: E,
        selected: O || L,
        endMonth: i,
        disabled: q,
        today: n,
        onDayMouseEnter: S,
        onMonthChange: w,
        onSelect: x
      },
      selectedOption: P
    };
  })());
};
K_.defaultProps = {
  options: [
    {
      id: "default",
      label: "Default option",
      isManual: !0,
      value: {
        from: void 0,
        to: void 0
      }
    }
  ]
};
const Nu = (e) => {
  const l = e, { className: t, children: r } = l, o = U(l, ["className", "children"]), _ = u(
    t,
    Ge["date-picker--range__calendars-wrapper"]
  );
  return /* @__PURE__ */ a("div", B(v({}, o), { className: _, children: r }));
}, j = {
  "details-card": "lc-DetailsCard-module__details-card___v-Avc",
  "details-card__button--fading": "lc-DetailsCard-module__details-card__button--fading___LlMMo",
  "details-card--with-divider": "lc-DetailsCard-module__details-card--with-divider___AhDnH",
  "details-card__label-wrapper": "lc-DetailsCard-module__details-card__label-wrapper___r70F3",
  "details-card__label-wrapper--hide": "lc-DetailsCard-module__details-card__label-wrapper--hide___Nz6ap",
  "details-card__label-wrapper--fading": "lc-DetailsCard-module__details-card__label-wrapper--fading___gPYF3",
  "details-card__label": "lc-DetailsCard-module__details-card__label___4cvW8",
  "details-card__label--with-margin": "lc-DetailsCard-module__details-card__label--with-margin___3bSuV",
  "details-card__label__left-node": "lc-DetailsCard-module__details-card__label__left-node___Vpq-P",
  "details-card__label__right-node": "lc-DetailsCard-module__details-card__label__right-node___640HC",
  "details-card__label__content": "lc-DetailsCard-module__details-card__label__content___iMTpo",
  "details-card__button": "lc-DetailsCard-module__details-card__button___x6Yex",
  "details-card__button--closed": "lc-DetailsCard-module__details-card__button--closed___4sjdi",
  "details-card__button__icon": "lc-DetailsCard-module__details-card__button__icon___clN8y",
  "details-card__button__icon--open": "lc-DetailsCard-module__details-card__button__icon--open___IU-Rk",
  "details-card__content-wrapper": "lc-DetailsCard-module__details-card__content-wrapper___6U9cE",
  "details-card__content-wrapper--open": "lc-DetailsCard-module__details-card__content-wrapper--open___n-ZsY",
  "details-card__content": "lc-DetailsCard-module__details-card__content___aJux3",
  "details-card__content--spacing": "lc-DetailsCard-module__details-card__content--spacing___F17pU",
  "details-card__content--full-space": "lc-DetailsCard-module__details-card__content--full-space___8CLFw"
}, J = "details-card", wc = ["input", "button", "select", "textarea", "a"], Su = ({
  children: e,
  className: t,
  leftNode: r,
  rightNode: o,
  label: _,
  withDivider: l,
  fullSpaceContent: i,
  openOnInit: n = !1,
  hideLabelOnOpen: d,
  onClick: s
}) => {
  const [c, p] = b.useState(n), [m, f] = b.useState(0), g = b.useRef(null), y = u(
    j[J],
    l && j[`${J}--with-divider`],
    t
  ), x = d && c, S = typeof _ == "string", E = (w) => {
    p((N) => !N), w.currentTarget.blur(), s == null || s(w);
  }, $ = (w) => {
    const k = w.target.tagName.toLowerCase();
    wc.includes(k) || (p((C) => !C), s == null || s(w));
  };
  return b.useEffect(() => {
    const w = !!window.IntersectionObserver;
    if (g.current && w) {
      const N = new ResizeObserver(() => {
        g.current && m !== g.current.offsetHeight && f(g.current.offsetHeight);
      });
      return N.observe(g.current), () => N.disconnect();
    }
  }, [g]), /* @__PURE__ */ h("div", { className: y, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: u(
          j[`${J}__label-wrapper`],
          d && j[`${J}__label-wrapper--fading`],
          x && j[`${J}__label-wrapper--hide`],
          c && j[`${J}__label-wrapper--open`]
        ),
        "aria-expanded": c,
        "aria-hidden": x,
        "data-testid": "details-card-label",
        onClick: $,
        children: /* @__PURE__ */ h(
          "div",
          {
            className: u(
              j[`${J}__label`],
              d && j[`${J}__label--with-margin`]
            ),
            children: [
              r && /* @__PURE__ */ a("div", { className: j[`${J}__label__left-node`], children: r }),
              S ? /* @__PURE__ */ a(
                pe,
                {
                  size: "xs",
                  className: j[`${J}__label__content`],
                  children: _
                }
              ) : /* @__PURE__ */ a("div", { className: j[`${J}__label__content`], children: _ }),
              o && /* @__PURE__ */ a("div", { className: j[`${J}__label__right-node`], children: o })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ a(
      W,
      {
        kind: c && d ? "float" : "text",
        icon: /* @__PURE__ */ a(
          R,
          {
            source: Mr,
            className: u(
              j[`${J}__button__icon`],
              c && j[`${J}__button__icon--open`]
            )
          }
        ),
        className: u(
          j[`${J}__button`],
          !c && j[`${J}__button--closed`],
          c && j[`${J}__button--open`],
          d && j[`${J}__button--fading`]
        ),
        onClick: E,
        "aria-expanded": c
      }
    ),
    /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a(
      "div",
      {
        className: u(
          j[`${J}__content-wrapper`],
          c && j[`${J}__content-wrapper--open`]
        ),
        style: {
          maxHeight: c ? m : 0
        },
        children: /* @__PURE__ */ a(
          "div",
          {
            ref: g,
            className: u(
              j[`${J}__content`],
              i && j[`${J}__content--full-space`],
              d && j[`${J}__content--spacing`]
            ),
            children: e
          }
        )
      }
    ) })
  ] });
}, oo = {
  "details-card-info": "lc-DetailsCardInfo-module__details-card-info___22mOK",
  "details-card-info__label": "lc-DetailsCardInfo-module__details-card-info__label___LXTXh",
  "details-card-info__content": "lc-DetailsCardInfo-module__details-card-info__content___03cfr"
}, _o = "details-card-info", xu = ({ children: e, label: t }) => /* @__PURE__ */ h("div", { className: oo[_o], children: [
  /* @__PURE__ */ a("div", { className: oo[`${_o}__label`], children: t }),
  /* @__PURE__ */ a("div", { className: oo[`${_o}__content`], children: e })
] }), St = {
  "empty-state": "lc-EmptyState-module__empty-state___vtzjl",
  "empty-state--centered": "lc-EmptyState-module__empty-state--centered___NW4Cb",
  "empty-state--inline": "lc-EmptyState-module__empty-state--inline___GJs59",
  "empty-state--full": "lc-EmptyState-module__empty-state--full___SrQt1",
  "empty-state__image": "lc-EmptyState-module__empty-state__image___-Sl-v",
  "empty-state__icon--full": "lc-EmptyState-module__empty-state__icon--full___vYFVG",
  "empty-state__description": "lc-EmptyState-module__empty-state__description___cMfKv",
  "empty-state__content-inline": "lc-EmptyState-module__empty-state__content-inline___gCYVX",
  "empty-state__title": "lc-EmptyState-module__empty-state__title___JSD4P",
  "empty-state__actions": "lc-EmptyState-module__empty-state__actions___gnEFS",
  "empty-state__actions--inline": "lc-EmptyState-module__empty-state__actions--inline___OuON7"
}, xt = "empty-state", Eu = ({
  type: e = "full",
  image: t,
  icon: r,
  title: o,
  description: _,
  actions: l,
  centered: i = !1
}) => /* @__PURE__ */ h(
  "div",
  {
    className: u(
      St[xt],
      St[`${xt}--${e}`],
      i && St[`${xt}--centered`]
    ),
    children: [
      t && /* @__PURE__ */ a(
        "img",
        {
          className: St[`${xt}__image`],
          src: t,
          alt: o
        }
      ),
      e === "inline" ? /* @__PURE__ */ h("div", { className: St[`${xt}__content-inline`], children: [
        r && /* @__PURE__ */ a(Vo, { "data-testid": "icon", children: r }),
        /* @__PURE__ */ a(F, { noMargin: !0, children: o })
      ] }) : /* @__PURE__ */ h(Q, { children: [
        r && /* @__PURE__ */ a(
          Vo,
          {
            className: St[`${xt}__icon--${e}`],
            "data-testid": "icon",
            children: r
          }
        ),
        /* @__PURE__ */ a(pe, { className: St[`${xt}__title`], children: o })
      ] }),
      e === "full" && _ && /* @__PURE__ */ a(F, { noMargin: !0, className: St[`${xt}__description`], children: _ }),
      l && /* @__PURE__ */ a(
        "div",
        {
          className: u(
            St[`${xt}__actions`],
            St[`${xt}__actions--${e}`]
          ),
          children: l
        }
      )
    ]
  }
), a_ = {
  "field-error": "lc-FieldError-module__field-error___-rtI3",
  "field-error__icon": "lc-FieldError-module__field-error__icon___4KpOc"
}, r_ = "field-error", Ao = (o) => {
  var _ = o, {
    children: e,
    className: t = ""
  } = _, r = U(_, [
    "children",
    "className"
  ]);
  const l = u(a_[r_], t);
  return /* @__PURE__ */ h(F, B(v({ as: "span", size: "sm" }, r), { className: l, children: [
    /* @__PURE__ */ a(
      R,
      {
        source: k_,
        className: a_[`${r_}__icon`],
        size: "small"
      }
    ),
    e
  ] }));
}, lo = {
  "field-group": "lc-FieldGroup-module__field-group___--i2x",
  "field-group--inline": "lc-FieldGroup-module__field-group--inline___iSg4S",
  "field-group--stretched": "lc-FieldGroup-module__field-group--stretched___4Evlw"
}, io = "field-group", Tu = (n) => {
  var d = n, {
    className: e = "",
    children: t,
    description: r,
    error: o,
    inline: _,
    stretch: l
  } = d, i = U(d, [
    "className",
    "children",
    "description",
    "error",
    "inline",
    "stretch"
  ]);
  const s = u(lo[io], e, {
    [lo[`${io}--inline`]]: _,
    [lo[`${io}--stretched`]]: l
  });
  return /* @__PURE__ */ h("div", B(v({}, i), { className: s, children: [
    t,
    o && /* @__PURE__ */ a(Ao, { children: o }),
    r && /* @__PURE__ */ a(Hr, { children: r })
  ] }));
}, $c = "lc-Form-module__form___ddwfw", Nc = "lc-Form-module__form__header___mr4AX", Sc = "lc-Form-module__form__footer___NJUBH", xc = "lc-Form-module__form__label___2hAXA", Ec = "lc-Form-module__form__helper___r1lJG", Oa = {
  form: $c,
  form__header: Nc,
  form__footer: Sc,
  form__label: xc,
  form__helper: Ec
}, Pa = "form", Bu = (i) => {
  var n = i, {
    className: e,
    children: t,
    labelText: r,
    helperText: o,
    formFooter: _
  } = n, l = U(n, [
    "className",
    "children",
    "labelText",
    "helperText",
    "formFooter"
  ]);
  return /* @__PURE__ */ h("form", B(v({ className: u(Oa[Pa], e) }, l), { children: [
    (r || o) && /* @__PURE__ */ h("div", { className: Oa[`${Pa}__header`], children: [
      r && /* @__PURE__ */ a(pe, { size: "sm", className: Oa[`${Pa}__label`], children: r }),
      o && /* @__PURE__ */ a(F, { as: "p", size: "sm", className: Oa[`${Pa}__helper`], children: o })
    ] }),
    t,
    _ && /* @__PURE__ */ a("div", { className: Oa[`${Pa}__footer`], children: _ })
  ] }));
}, _e = {
  "form-field": "lc-FormField-module__form-field___kx7Vx",
  "form-field--inline": "lc-FormField-module__form-field--inline___1xuhX",
  "form-field__wrapper--inline": "lc-FormField-module__form-field__wrapper--inline___MPvG-",
  "form-field__label": "lc-FormField-module__form-field__label___xZ4Qz",
  "form-field__label--inline": "lc-FormField-module__form-field__label--inline___x9AUt",
  "form-field__label--no-text": "lc-FormField-module__form-field__label--no-text___h2VqV",
  "form-field__label-wrapper": "lc-FormField-module__form-field__label-wrapper___O1XAl",
  "form-field__label-wrapper--inline": "lc-FormField-module__form-field__label-wrapper--inline___5hqdR",
  "form-field__label-adornment": "lc-FormField-module__form-field__label-adornment___4uieF",
  "form-field__label-adornment--inline": "lc-FormField-module__form-field__label-adornment--inline___Uj4Y6",
  "form-field__label-left-node": "lc-FormField-module__form-field__label-left-node___XWg6l",
  "form-field__label-left-node--read-only": "lc-FormField-module__form-field__label-left-node--read-only___WnnjA",
  "form-field__label-right-node": "lc-FormField-module__form-field__label-right-node___dzUl6",
  "form-field__label-right-node--inline": "lc-FormField-module__form-field__label-right-node--inline___zfQ8H",
  "form-field__row-break": "lc-FormField-module__form-field__row-break___ibOb7",
  "form-field__content": "lc-FormField-module__form-field__content___7Cnwe",
  "form-field__content__description": "lc-FormField-module__form-field__content__description___qdMlU"
}, le = "form-field", Tc = ({
  inline: e,
  error: t,
  description: r,
  labelText: o,
  labelAdornment: _,
  className: l,
  labelFor: i,
  children: n,
  labelRightNode: d,
  boldLabel: s = !1,
  readOnly: c = !1
}) => {
  const p = b.useRef(null), [m, f] = b.useState("auto"), { isEmpty: g } = At(), y = u(
    _e[le],
    {
      [_e[`${le}--inline`]]: e
    },
    l
  );
  return b.useEffect(() => {
    const x = p;
    return e && x.current ? f(`${x.current.clientHeight}px`) : f("auto");
  }), /* @__PURE__ */ h("div", { className: y, children: [
    d && e && /* @__PURE__ */ h(b.Fragment, { children: [
      /* @__PURE__ */ a(
        F,
        {
          as: "div",
          size: "sm",
          className: u(
            _e[`${le}__label-right-node`],
            _e[`${le}__label-right-node--inline`]
          ),
          children: d
        }
      ),
      /* @__PURE__ */ a("div", { className: _e[`${le}__row-break`] })
    ] }),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(
          _e[`${le}__wrapper`],
          e && _e[`${le}__wrapper--inline`]
        ),
        children: [
          (o || d) && /* @__PURE__ */ h(
            "div",
            {
              className: u(
                _e[`${le}__label`],
                e && _e[`${le}__label--inline`],
                !o && _e[`${le}__label--no-text`]
              ),
              children: [
                o && /* @__PURE__ */ h(
                  "div",
                  {
                    className: u(
                      _e[`${le}__label-wrapper`],
                      e && _e[`${le}__label-wrapper--inline`]
                    ),
                    style: {
                      height: m
                    },
                    children: [
                      /* @__PURE__ */ a(
                        "label",
                        {
                          className: u(
                            _e[`${le}__label-left-node`],
                            c && _e[`${le}__label-left-node--read-only`]
                          ),
                          htmlFor: i,
                          children: /* @__PURE__ */ a(
                            F,
                            {
                              as: "span",
                              size: "sm",
                              bold: !c && s,
                              customColor: g ? "var(--content-basic-secondary)" : void 0,
                              children: o
                            }
                          )
                        }
                      ),
                      _ && /* @__PURE__ */ a(
                        F,
                        {
                          as: "div",
                          size: "sm",
                          className: u(
                            _e[`${le}__label-adornment`],
                            e && _e[`${le}__label-adornment--inline`]
                          ),
                          children: _
                        }
                      )
                    ]
                  }
                ),
                d && !e && /* @__PURE__ */ a(
                  F,
                  {
                    as: "div",
                    size: "sm",
                    className: u(_e[`${le}__label-right-node`]),
                    children: d
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ h("div", { className: u(_e[`${le}__content`]), children: [
            /* @__PURE__ */ a("div", { ref: p, children: n }),
            t && /* @__PURE__ */ a(Ao, { children: t }),
            !t && r && /* @__PURE__ */ a(
              Hr,
              {
                className: u(_e[`${le}__content__description`]),
                children: r
              }
            )
          ] })
        ]
      }
    )
  ] });
}, Iu = (r) => {
  var o = r, {
    readOnly: e
  } = o, t = U(o, [
    "readOnly"
  ]);
  return /* @__PURE__ */ a(Cn, { readOnly: e, children: /* @__PURE__ */ a(Tc, v({ readOnly: e }, t)) });
}, yr = {
  "form-group": "lc-FormGroup-module__form-group___uAHnp",
  "form-group__header": "lc-FormGroup-module__form-group__header___U4FrR",
  "form-group__label": "lc-FormGroup-module__form-group__label___9AcBX",
  "form-group__helper": "lc-FormGroup-module__form-group__helper___2XQcm"
}, Cr = "form-group", Au = (l) => {
  var i = l, {
    className: e = "",
    children: t,
    labelText: r,
    helperText: o
  } = i, _ = U(i, [
    "className",
    "children",
    "labelText",
    "helperText"
  ]);
  const n = u(yr[Cr], e);
  return /* @__PURE__ */ h(
    "div",
    B(v(B(v({}, _), {
      role: "group"
    }), r && { "aria-label": r }), {
      className: n,
      children: [
        (r || o) && /* @__PURE__ */ h("div", { className: yr[`${Cr}__header`], children: [
          r && /* @__PURE__ */ a(
            pe,
            {
              as: "div",
              size: "sm",
              className: yr[`${Cr}__label`],
              children: r
            }
          ),
          o && /* @__PURE__ */ a(F, { as: "div", size: "sm", className: yr[`${Cr}__helper`], children: o })
        ] }),
        t
      ]
    })
  );
}, Bc = "lc-AnimatedButton-module__icon___x-2D0", Ic = "lc-AnimatedButton-module__text___JEZ-a", Ac = "lc-AnimatedButton-module__expanded___oXA4t", wr = {
  "animated-button": "lc-AnimatedButton-module__animated-button___d1ume",
  icon: Bc,
  text: Ic,
  expanded: Ac
}, Dc = ({
  icon: e,
  text: t,
  onClick: r,
  className: o,
  isExpanded: _
}) => {
  const [l, i] = ce(!1), n = _ !== void 0, d = n ? _ : l, s = () => {
    i(!0);
  }, c = () => {
    i(!1);
  };
  return z(() => {
    n && !_ && i(!1);
  }, [n, _]), /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      className: u(
        wr["animated-button"],
        { [wr.expanded]: d },
        o
      ),
      onClick: r,
      onMouseEnter: s,
      onMouseLeave: c,
      children: [
        /* @__PURE__ */ a("span", { className: wr.icon, children: e }),
        /* @__PURE__ */ a("span", { className: wr.text, children: t })
      ]
    }
  );
}, o_ = {
  available: 1,
  unavailable: 2,
  unknown: 3
}, Oc = (e) => [...e].sort((t, r) => o_[t.status] - o_[r.status]), Ye = {
  "invite-agents": "lc-InviteAgents-module__invite-agents___XHov-",
  "invite-agents--empty": "lc-InviteAgents-module__invite-agents--empty___-uyZv",
  "invite-agents--only-unavailable": "lc-InviteAgents-module__invite-agents--only-unavailable___rwGmo",
  "invite-agents__not-accepting": "lc-InviteAgents-module__invite-agents__not-accepting___GF-hX",
  "invite-agents__tooltip": "lc-InviteAgents-module__invite-agents__tooltip___8CJxu",
  "invite-agents__tooltip-trigger": "lc-InviteAgents-module__invite-agents__tooltip-trigger___I77qz",
  "invite-agents__not-accepting-status-dot": "lc-InviteAgents-module__invite-agents__not-accepting-status-dot___BnVII",
  "invite-agents__avatar-container": "lc-InviteAgents-module__invite-agents__avatar-container___r56c3",
  "invite-agents__avatar": "lc-InviteAgents-module__invite-agents__avatar___Qs6yT",
  "invite-agents__available-agents-number": "lc-InviteAgents-module__invite-agents__available-agents-number___WpNqr",
  "invite-agents__accepting-agents": "lc-InviteAgents-module__invite-agents__accepting-agents___KNMQw",
  "invite-agents__accepting-agents-row": "lc-InviteAgents-module__invite-agents__accepting-agents-row___bTb9i"
}, Xe = "invite-agents", Pc = 50, Fc = (s) => {
  var c = s, {
    agents: e,
    onSetUpChatbotClick: t,
    onAddTeammateClick: r,
    className: o,
    animatedInviteButton: _ = !1,
    tooltipArrowOffset: l = 13,
    onAvailableAgentsClick: i,
    showBotsInTooltip: n = !0
  } = c, d = U(c, [
    "agents",
    "onSetUpChatbotClick",
    "onAddTeammateClick",
    "className",
    "animatedInviteButton",
    "tooltipArrowOffset",
    "onAvailableAgentsClick",
    "showBotsInTooltip"
  ]);
  const [p, m] = ce(!1), [f, g] = ce(!1), {
    availableAgentsNumber: y,
    visibleAgents: x,
    hasOnlyUnavailableAgents: S,
    onlyAgentsNumber: E,
    onlyBotsNumber: $
  } = ka(() => {
    const I = e.filter(
      (L) => L.status === "available"
    ), T = Oc(I), M = I.length, A = T.length > 4 ? T.slice(0, 3) : T, D = e.length > 0 && M === 0, G = I.filter(
      (L) => !L.isBot
    ).length, P = M - G;
    return {
      availableAgentsNumber: M,
      visibleAgents: A,
      hasOnlyUnavailableAgents: D,
      onlyAgentsNumber: G,
      onlyBotsNumber: P
    };
  }, [e]), w = () => {
    t(), m(!1), g(!1);
  }, N = () => {
    r(), m(!1), g(!1);
  }, k = () => {
    i(), m(!1), g(!1);
  }, C = [
    {
      key: "chatbot",
      onClick: w,
      element: /* @__PURE__ */ a(Ar, { leftNode: /* @__PURE__ */ a(R, { source: fl }), children: "Set up ChatBot" })
    },
    {
      key: "teammate",
      element: /* @__PURE__ */ a(Ar, { leftNode: /* @__PURE__ */ a(R, { source: bl }), children: "Invite teammate" }),
      onClick: N
    }
  ];
  return /* @__PURE__ */ h(
    "div",
    B(v({}, d), {
      className: u(
        jt.Dark,
        Ye[Xe],
        {
          [Ye[`${Xe}--empty`]]: e.length === 0,
          [Ye[`${Xe}--only-unavailable`]]: S
        },
        o
      ),
      children: [
        e.length > 0 && /* @__PURE__ */ a(
          ia,
          {
            isVisible: f && !p,
            offsetMainAxis: l,
            floatingStrategy: "fixed",
            hoverOnDelay: Pc,
            onOpen: () => g(!0),
            onClose: () => g(!1),
            className: u(jt.Dark, Ye[`${Xe}__tooltip`]),
            triggerRenderer: S ? /* @__PURE__ */ h(
              "div",
              {
                className: Ye[`${Xe}__not-accepting`],
                onClick: k,
                children: [
                  /* @__PURE__ */ a(
                    "div",
                    {
                      className: u(
                        Ye[`${Xe}__not-accepting-status-dot`]
                      )
                    }
                  ),
                  /* @__PURE__ */ a(F, { noMargin: !0, bold: !0, size: "sm", children: "No active agents" })
                ]
              }
            ) : /* @__PURE__ */ h(
              "div",
              {
                className: Ye[`${Xe}__tooltip-trigger`],
                onClick: k,
                children: [
                  /* @__PURE__ */ a("div", { className: Ye[`${Xe}__avatar-container`], children: x.map((I, T) => /* @__PURE__ */ a(
                    Io,
                    {
                      text: I.name,
                      className: Ye[`${Xe}__avatar`],
                      type: I.avatar ? "image" : "text",
                      size: "xsmall",
                      status: I.status,
                      src: I.avatar,
                      style: { zIndex: e.length - T }
                    },
                    I.email
                  )) }),
                  y > 0 && /* @__PURE__ */ a(
                    F,
                    {
                      className: Ye[`${Xe}__available-agents-number`],
                      children: y
                    }
                  )
                ]
              }
            ),
            children: S ? /* @__PURE__ */ a(
              Li,
              {
                header: "No one's available to assist customers",
                text: "Offer 24/7 support with ChatBot.",
                primaryButton: {
                  handleClick: w,
                  label: "Set up ChatBot"
                }
              }
            ) : /* @__PURE__ */ h(
              F,
              {
                as: "div",
                noMargin: !0,
                size: "md",
                className: Ye[`${Xe}__accepting-agents`],
                children: [
                  /* @__PURE__ */ a(F, { bold: !0, noMargin: !0, children: "Accepting chats:" }),
                  /* @__PURE__ */ h(
                    F,
                    {
                      noMargin: !0,
                      className: Ye[`${Xe}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ a(R, { source: pl }),
                        Pr(
                          E,
                          "1 agent",
                          `${E} agents`
                        )
                      ]
                    }
                  ),
                  n && /* @__PURE__ */ h(
                    F,
                    {
                      noMargin: !0,
                      className: Ye[`${Xe}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ a(R, { source: gl }),
                        Pr($, "1 bot", `${$} bots`)
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ a(
          I_,
          {
            floatingStrategy: "fixed",
            visible: p,
            onOpen: () => m(!0),
            onClose: () => m(!1),
            options: C,
            triggerRenderer: /* @__PURE__ */ a(
              Dc,
              {
                icon: /* @__PURE__ */ a(R, { source: hl }),
                text: "Invite",
                onClick: () => m((I) => !I),
                isExpanded: _ ? p || void 0 : !0
              }
            )
          }
        )
      ]
    })
  );
}, Du = il(Fc), Mc = "lc-Link-module__link___35Vo1", __ = {
  link: Mc,
  "link--bold": "lc-Link-module__link--bold___9Uq3Z"
}, l_ = "link", Ou = (o) => {
  var _ = o, {
    bold: e = !1,
    className: t = ""
  } = _, r = U(_, [
    "bold",
    "className"
  ]);
  return /* @__PURE__ */ a(
    "a",
    v({
      className: u(
        __[l_],
        e && __[`${l_}--bold`],
        t
      )
    }, r)
  );
}, Rc = "lc-Modal-module__modal__body___K3X3J", Gc = "lc-Modal-module__modal__header___22qVU", Uc = "lc-Modal-module__modal__heading___TQl-G", Lc = "lc-Modal-module__modal__footer___-z-ze", Be = {
  "modal-base": "lc-Modal-module__modal-base___W3hsn",
  "fade-in": "lc-Modal-module__fade-in___uf1sy",
  "modal-base--full-space": "lc-Modal-module__modal-base--full-space___I5mqs",
  "modal-base__overlay": "lc-Modal-module__modal-base__overlay___BXG-c",
  "modal-base__overlay--visible": "lc-Modal-module__modal-base__overlay--visible___SkPQ3",
  "modal-base__overlay--labelled": "lc-Modal-module__modal-base__overlay--labelled___XJo16",
  "modal-base__close": "lc-Modal-module__modal-base__close___a2xPW",
  "modal-base__close--label-type": "lc-Modal-module__modal-base__close--label-type___IWIlG",
  modal__body: Rc,
  modal__header: Gc,
  "modal__header--without-heading": "lc-Modal-module__modal__header--without-heading___-zvH5",
  "modal__label-header": "lc-Modal-module__modal__label-header___LL-pz",
  modal__heading: Uc,
  "modal__label-heading": "lc-Modal-module__modal__label-heading___OZoP1",
  modal__footer: Lc
}, Fa = "modal-base", qc = (d) => {
  var s = d, {
    children: e,
    className: t = "",
    onClose: r,
    closeOnEscPress: o = !0,
    closeOnOverlayPress: _ = !0,
    fullSpaceContent: l,
    isLabelled: i
  } = s, n = U(s, [
    "children",
    "className",
    "onClose",
    "closeOnEscPress",
    "closeOnOverlayPress",
    "fullSpaceContent",
    "isLabelled"
  ]);
  const c = u(
    Be[Fa],
    t,
    l && Be[`${Fa}--full-space`]
  );
  return b.useEffect(() => {
    if (!o)
      return;
    const m = (f) => {
      f.key === se.esc && r();
    };
    return document.addEventListener("keyup", m, !0), () => document.removeEventListener("keyup", m, !0);
  }, [o]), /* @__PURE__ */ a(
    Hl,
    {
      "data-testid": "lc-modal-overlay",
      onMouseDown: (m) => {
        _ && m.target === m.currentTarget && r();
      },
      className: u(
        Be[`${Fa}__overlay`],
        Be[`${Fa}__overlay--visible`],
        i && Be[`${Fa}__overlay--labelled`]
      ),
      children: /* @__PURE__ */ a(
        "div",
        B(v({
          role: "dialog",
          "aria-modal": !0,
          className: c
        }, n), {
          children: e
        })
      )
    }
  );
}, i_ = ({
  labelType: e,
  customColor: t,
  onClick: r
}) => /* @__PURE__ */ a(
  W,
  {
    type: "button",
    kind: "plain",
    "aria-label": "Close modal",
    title: "Close modal",
    className: u(
      Be["modal-base__close"],
      e && Be["modal-base__close--label-type"]
    ),
    onClick: r,
    icon: /* @__PURE__ */ a(R, { source: ct, size: "medium", customColor: t })
  }
), Xt = "modal", Pu = (s) => {
  var c = s, {
    children: e,
    className: t = "",
    heading: r,
    labelHeading: o,
    fullSpaceContent: _,
    footer: l,
    onClose: i,
    contentClassName: n
  } = c, d = U(c, [
    "children",
    "className",
    "heading",
    "labelHeading",
    "fullSpaceContent",
    "footer",
    "onClose",
    "contentClassName"
  ]);
  const p = u(Be[Xt], t), m = typeof e == "string", f = (g) => {
    g.preventDefault(), g.stopPropagation(), i();
  };
  return /* @__PURE__ */ h(
    qc,
    B(v({
      className: p,
      fullSpaceContent: _,
      onClose: i,
      isLabelled: !!o
    }, d), {
      children: [
        o && /* @__PURE__ */ h("div", { className: Be[`${Xt}__label-header`], children: [
          /* @__PURE__ */ a(
            pe,
            {
              size: "sm",
              as: "div",
              className: Be[`${Xt}__label-heading`],
              children: o
            }
          ),
          /* @__PURE__ */ a(
            i_,
            {
              labelType: !!o,
              customColor: "var(--color-white)",
              onClick: f
            }
          )
        ] }),
        !o && /* @__PURE__ */ h(
          "div",
          {
            className: u(Be[`${Xt}__header`], {
              [Be[`${Xt}__header--without-heading`]]: !r
            }),
            children: [
              r && /* @__PURE__ */ a(
                pe,
                {
                  size: "sm",
                  as: "div",
                  className: Be[`${Xt}__heading`],
                  children: r
                }
              ),
              /* @__PURE__ */ a(i_, { onClick: f })
            ]
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            "data-testid": "modal-body",
            className: u(Be[`${Xt}__body`], n),
            children: m ? /* @__PURE__ */ a(F, { as: "div", children: e }) : e
          }
        ),
        l && /* @__PURE__ */ a("div", { className: Be[`${Xt}__footer`], children: l })
      ]
    })
  );
}, Fu = ({
  children: e,
  className: t = "",
  parentElementName: r = "body",
  zIndex: o
}) => {
  const _ = Kt(document.createElement("div"));
  return z(() => {
    const l = _.current, i = document.querySelector(r);
    return i && i.appendChild(l), () => {
      i && i.removeChild(l);
    };
  }, [r]), z(() => {
    const l = _.current;
    t && (l.className = t), o && (l.style.zIndex = `${o}`);
  }, [t, o]), Wl(/* @__PURE__ */ a(Q, { children: e }), _.current);
}, Ma = {
  "modal-header": "lc-ModalHeader-module__modal-header___YwkiN",
  "modal-header__heading-left-node": "lc-ModalHeader-module__modal-header__heading-left-node___SZBRX",
  "modal-header__heading-body": "lc-ModalHeader-module__modal-header__heading-body___aBgMz",
  "modal-header__heading-description": "lc-ModalHeader-module__modal-header__heading-description___dpbWK"
}, Ra = "modal-header", Mu = ({ title: e, iconProps: t, avatarProps: r, children: o, className: _ = "" }) => {
  const l = u(Ma[Ra], _);
  return /* @__PURE__ */ h("div", { className: l, children: [
    t && /* @__PURE__ */ a(
      R,
      v({
        className: Ma[`${Ra}__heading-left-node`]
      }, t)
    ),
    r && /* @__PURE__ */ a(
      Io,
      v({
        className: Ma[`${Ra}__heading-left-node`]
      }, r)
    ),
    /* @__PURE__ */ h("div", { className: Ma[`${Ra}__heading-body`], children: [
      /* @__PURE__ */ a(pe, { as: "div", size: "sm", children: e }),
      o && /* @__PURE__ */ a(
        F,
        {
          as: "div",
          className: Ma[`${Ra}__heading-description`],
          children: o
        }
      )
    ] })
  ] });
}, Ga = {
  "action-modal-content": "lc-ActionModalContent-module__action-modal-content___LGNxr",
  "action-modal-content__icon": "lc-ActionModalContent-module__action-modal-content__icon___JYTP2",
  "action-modal-content__heading": "lc-ActionModalContent-module__action-modal-content__heading___gGgOD",
  "action-modal-content__content": "lc-ActionModalContent-module__action-modal-content__content___K4e5r",
  "action-modal-content__actions": "lc-ActionModalContent-module__action-modal-content__actions___bgnDV"
}, Ua = "action-modal-content", Ru = ({
  children: e,
  className: t,
  icon: r,
  heading: o,
  actions: _,
  headerClassName: l,
  contentClassName: i
}) => {
  const n = u(Ga[Ua], t);
  return /* @__PURE__ */ h("div", { className: n, children: [
    r && /* @__PURE__ */ a("div", { className: Ga[`${Ua}__icon`], children: r }),
    o && /* @__PURE__ */ a(
      pe,
      {
        className: u(Ga[`${Ua}__heading`], l),
        children: o
      }
    ),
    /* @__PURE__ */ a(
      F,
      {
        as: "div",
        className: u(Ga[`${Ua}__content`], i),
        children: e
      }
    ),
    _ && /* @__PURE__ */ a("div", { className: Ga[`${Ua}__actions`], children: _ })
  ] });
}, ha = {
  "numeric-input": "lc-NumericInput-module__numeric-input___qYvYK",
  "numeric-input__increment": "lc-NumericInput-module__numeric-input__increment___7AdPN",
  "numeric-input__decrement": "lc-NumericInput-module__numeric-input__decrement___18Raa",
  "numeric-input--disabled": "lc-NumericInput-module__numeric-input--disabled___s2O8w",
  "numeric-input--no-controls": "lc-NumericInput-module__numeric-input--no-controls___nO8zN",
  "numeric-input--error": "lc-NumericInput-module__numeric-input--error___y9v6f"
}, fa = "numeric-input", Gu = (p) => {
  var m = p, {
    className: e,
    error: t,
    value: r,
    max: o,
    min: _,
    disabled: l,
    noControls: i,
    style: n,
    onChange: d,
    noDataFallbackText: s = "No data"
  } = m, c = U(m, [
    "className",
    "error",
    "value",
    "max",
    "min",
    "disabled",
    "noControls",
    "style",
    "onChange",
    "noDataFallbackText"
  ]);
  const f = b.useRef(null), { readOnly: g } = At(), y = g || c.readOnly, x = u(
    ha[fa],
    {
      [ha[`${fa}--error`]]: t,
      [ha[`${fa}--no-controls`]]: i,
      [ha[`${fa}--disabled`]]: l
    },
    e
  ), S = (T) => d(String(T)), E = (T) => o !== void 0 && T > o ? o : _ !== void 0 && T < _ ? _ : T, $ = (T) => {
    const M = parseInt(r, 10) + T;
    return S(E(M));
  }, w = (T) => {
    T.key === se.arrowDown && (T.preventDefault(), $(-1)), T.key === se.arrowUp && (T.preventDefault(), $(1));
  }, N = (T, M) => M !== void 0 && parseInt(T, 10) === M, k = (T) => {
    T.preventDefault(), T.stopPropagation();
    const M = T.currentTarget.value.replace(
      /((?!([-]|([-]?\d+))).)/,
      ""
    );
    if (M === "" || M === "-")
      return S(M);
    const A = parseInt(M, 10);
    return S(E(A));
  }, C = () => {
    var T;
    return (T = f.current) == null || T.focus(), $(1);
  }, I = () => {
    var T;
    return (T = f.current) == null || T.focus(), $(-1);
  };
  return y ? /* @__PURE__ */ a(
    Na,
    {
      value: r == null ? void 0 : r.toString(),
      noDataFallbackText: s
    }
  ) : /* @__PURE__ */ h("div", { className: x, style: n, children: [
    /* @__PURE__ */ a(
      "input",
      B(v({
        type: "text",
        ref: f
      }, c), {
        value: r,
        disabled: l,
        onChange: k,
        onKeyDown: w,
        min: _,
        max: o
      })
    ),
    !i && /* @__PURE__ */ h(Q, { children: [
      /* @__PURE__ */ a(
        "button",
        {
          tabIndex: -1,
          disabled: l || N(r, o),
          onClick: C,
          "aria-label": "Increment value",
          className: ha[`${fa}__increment`],
          type: "button",
          children: /* @__PURE__ */ a(
            R,
            {
              source: Rr,
              disabled: l || N(r, o),
              kind: "primary"
            }
          )
        }
      ),
      /* @__PURE__ */ a(
        "button",
        {
          tabIndex: -1,
          disabled: l || N(r, _),
          "aria-label": "Decrement value",
          className: ha[`${fa}__decrement`],
          onClick: I,
          type: "button",
          children: /* @__PURE__ */ a(
            R,
            {
              source: na,
              kind: "primary",
              disabled: l || N(r, _)
            }
          )
        }
      )
    ] })
  ] });
}, Se = {
  "checklist-item": "lc-CheckListItem-module__checklist-item___iuIlB",
  "checklist-item--active": "lc-CheckListItem-module__checklist-item--active___aoLek",
  "checklist-item__check-mark": "lc-CheckListItem-module__checklist-item__check-mark___stkGB",
  "checklist-item__check-mark--checked": "lc-CheckListItem-module__checklist-item__check-mark--checked___qcaKG",
  "checklist-item__content": "lc-CheckListItem-module__checklist-item__content___dUQrj",
  "checklist-item__content--open": "lc-CheckListItem-module__checklist-item__content--open___Gb8Bj",
  "checklist-item__content__label": "lc-CheckListItem-module__checklist-item__content__label___IECjY",
  "checklist-item__content__label--open": "lc-CheckListItem-module__checklist-item__content__label--open___bXXcm",
  "checklist-item__content__label--checked": "lc-CheckListItem-module__checklist-item__content__label--checked___v-CRg",
  "checklist-item__content__hint": "lc-CheckListItem-module__checklist-item__content__hint___zyxAI",
  "checklist-item__content__inner": "lc-CheckListItem-module__checklist-item__content__inner___T9e7f",
  "checklist-item__content__inner--open": "lc-CheckListItem-module__checklist-item__content__inner--open___hVtIm",
  "checklist-item__content__inner__description": "lc-CheckListItem-module__checklist-item__content__inner__description___oQx09",
  "checklist-item__content__inner__cta": "lc-CheckListItem-module__checklist-item__content__inner__cta___pPrxs",
  "checklist-item__chevron": "lc-CheckListItem-module__checklist-item__chevron___S9Cp1"
}, xe = "checklist-item", Hc = 7, zc = ({
  id: e,
  isActive: t,
  isChecked: r,
  title: o,
  titleHint: _,
  description: l,
  customContent: i,
  onClick: n,
  cta: d
}) => {
  const s = b.useRef(null), c = b.useRef(null), [p, m] = b.useState(0), f = b.useRef(p);
  return b.useEffect(() => {
    t && s.current && s.current.focus();
  }, [t]), b.useEffect(() => {
    const g = !!window.ResizeObserver;
    if (c.current && g) {
      const y = new ResizeObserver((x) => {
        const S = x[0];
        if (!S) return;
        const E = S.contentRect.height + Hc;
        f.current !== E && (m(E), f.current = E);
      });
      return y.observe(c.current), () => y.disconnect();
    }
  }, [c]), /* @__PURE__ */ h(
    "div",
    {
      className: u(Se[xe], {
        [Se[`${xe}--active`]]: t
      }),
      children: [
        /* @__PURE__ */ a(
          "span",
          {
            className: u(Se[`${xe}__check-mark`], {
              [Se[`${xe}__check-mark--checked`]]: r
            }),
            children: r && /* @__PURE__ */ a(R, { size: "small", source: wa })
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            ref: s,
            "data-testid": `checklist-item-${e}`,
            "aria-expanded": t,
            tabIndex: 0,
            onFocus: t ? void 0 : () => n(e),
            onClick: t ? void 0 : () => n(e),
            className: u(Se[`${xe}__content`], {
              [Se[`${xe}__content--open`]]: t
            }),
            children: [
              /* @__PURE__ */ h("div", { children: [
                /* @__PURE__ */ h(
                  pe,
                  {
                    size: "xs",
                    className: u(Se[`${xe}__content__label`], {
                      [Se[`${xe}__content__label--open`]]: t,
                      [Se[`${xe}__content__label--checked`]]: r
                    }),
                    children: [
                      o,
                      " ",
                      _ && /* @__PURE__ */ h(
                        F,
                        {
                          noMargin: !0,
                          size: "lg",
                          className: Se[`${xe}__content__hint`],
                          children: [
                            " ",
                            _
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ a(
                  "div",
                  {
                    className: u(Se[`${xe}__content__inner`], {
                      [Se[`${xe}__content__inner--open`]]: t
                    }),
                    style: { maxHeight: t ? p : 0 },
                    children: /* @__PURE__ */ h("div", { ref: c, children: [
                      l && /* @__PURE__ */ a(
                        F,
                        {
                          size: "lg",
                          className: Se[`${xe}__content__inner__description`],
                          children: l
                        }
                      ),
                      i && /* @__PURE__ */ a(
                        "div",
                        {
                          className: Se[`${xe}__content__inner__description`],
                          children: i
                        }
                      ),
                      /* @__PURE__ */ a("div", { className: Se[`${xe}__content__inner__cta`], children: d })
                    ] })
                  }
                )
              ] }),
              !t && /* @__PURE__ */ a("div", { className: Se[`${xe}__chevron`], children: /* @__PURE__ */ a(R, { source: Mr }) })
            ]
          }
        )
      ]
    }
  );
}, ie = {
  "onboarding-checklist": "lc-OnboardingChecklist-module__onboarding-checklist___98RSw",
  "onboarding-checklist--complete": "lc-OnboardingChecklist-module__onboarding-checklist--complete___Cmld9",
  "onboarding-checklist__complete": "lc-OnboardingChecklist-module__onboarding-checklist__complete___ihqN7",
  "onboarding-checklist__complete__icon": "lc-OnboardingChecklist-module__onboarding-checklist__complete__icon___LDJ-I",
  "onboarding-checklist__complete__label": "lc-OnboardingChecklist-module__onboarding-checklist__complete__label___-wqtx",
  "onboarding-checklist__complete__title": "lc-OnboardingChecklist-module__onboarding-checklist__complete__title___MvGM7",
  "onboarding-checklist__column": "lc-OnboardingChecklist-module__onboarding-checklist__column___juqpr",
  "onboarding-checklist__column--right": "lc-OnboardingChecklist-module__onboarding-checklist__column--right___9lOFL",
  "onboarding-checklist__column--right--completed": "lc-OnboardingChecklist-module__onboarding-checklist__column--right--completed___nHt44",
  "onboarding-checklist__header": "lc-OnboardingChecklist-module__onboarding-checklist__header___RB1O7",
  "onboarding-checklist__header__label": "lc-OnboardingChecklist-module__onboarding-checklist__header__label___O2yRJ",
  "onboarding-checklist__header__title": "lc-OnboardingChecklist-module__onboarding-checklist__header__title___H36qW",
  "onboarding-checklist__checklist": "lc-OnboardingChecklist-module__onboarding-checklist__checklist___0vKse",
  "onboarding-checklist__placeholder": "lc-OnboardingChecklist-module__onboarding-checklist__placeholder___JYc-z",
  "onboarding-checklist__button": "lc-OnboardingChecklist-module__onboarding-checklist__button___ZmZ2j",
  "onboarding-checklist__button__icon": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon___ta8M6",
  "onboarding-checklist__button__icon--open": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon--open___Jnrn8"
}, ne = "onboarding-checklist", Uu = ({
  activeItemId: e,
  completedItemsIds: t,
  title: r,
  greetingText: o,
  items: _,
  onActiveChange: l,
  placeholderClassName: i,
  isCompleted: n = !1,
  completionMessageData: d,
  className: s
}) => {
  var $;
  const [c, p] = b.useState(n), [m, f] = b.useState(!n), [g, y] = b.useState(void 0), x = b.useRef(null), S = d.height || 96, E = () => {
    f((w) => !w);
  };
  return b.useEffect(() => {
    const w = d.delay || 1500, N = x.current;
    if (n && N) {
      const k = N.offsetHeight;
      y(k);
      const C = setTimeout(() => {
        p(!0), f(!1);
      }, w);
      return () => {
        clearTimeout(C);
      };
    }
  }, [n]), /* @__PURE__ */ h(
    "div",
    {
      ref: x,
      className: u(
        ie[ne],
        {
          [ie[`${ne}--complete`]]: c && !m
        },
        s
      ),
      style: {
        height: !c || m ? g : S
      },
      children: [
        m && /* @__PURE__ */ h(Q, { children: [
          /* @__PURE__ */ h("div", { className: ie[`${ne}__column`], children: [
            /* @__PURE__ */ h("div", { className: ie[`${ne}__header`], children: [
              o && /* @__PURE__ */ a(
                F,
                {
                  size: "lg",
                  semiBold: !0,
                  className: ie[`${ne}__header__label`],
                  children: o
                }
              ),
              /* @__PURE__ */ a(
                pe,
                {
                  size: "lg",
                  className: ie[`${ne}__header__title`],
                  children: r
                }
              )
            ] }),
            /* @__PURE__ */ a("div", { className: ie[`${ne}__checklist`], children: _.map((w, N) => /* @__PURE__ */ a(
              zc,
              {
                id: w.id,
                description: w.description,
                customContent: w.customContent,
                title: w.title,
                titleHint: w.titleHint,
                isActive: w.id === e,
                isChecked: t.includes(w.id),
                onClick: l,
                cta: w.cta
              },
              N
            )) })
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: u(
                ie[`${ne}__column`],
                ie[`${ne}__column--right`],
                {
                  [ie[`${ne}__column--right--completed`]]: n
                },
                i
              ),
              children: [
                !n && /* @__PURE__ */ a("div", { className: ie[`${ne}__placeholder`], children: ($ = _.find((w) => w.id === e)) == null ? void 0 : $.placeholder }),
                n && /* @__PURE__ */ a("div", { className: ie[`${ne}__placeholder`], children: d.placeholder })
              ]
            }
          )
        ] }),
        !m && /* @__PURE__ */ a(Q, { children: /* @__PURE__ */ h("div", { className: ie[`${ne}__complete`], children: [
          /* @__PURE__ */ a("div", { children: /* @__PURE__ */ a(
            R,
            {
              size: "large",
              className: ie[`${ne}__complete__icon`],
              source: So
            }
          ) }),
          /* @__PURE__ */ h("div", { children: [
            (d == null ? void 0 : d.greetingText) && /* @__PURE__ */ a(
              F,
              {
                size: "lg",
                className: ie[`${ne}__complete__label`],
                children: d.greetingText
              }
            ),
            /* @__PURE__ */ a(
              pe,
              {
                size: "sm",
                className: ie[`${ne}__complete__title`],
                children: d.title
              }
            )
          ] })
        ] }) }),
        c && /* @__PURE__ */ a(
          W,
          {
            kind: m ? "float" : "text",
            icon: /* @__PURE__ */ a(
              R,
              {
                source: na,
                className: u(
                  ie[`${ne}__button__icon`],
                  m && ie[`${ne}__button__icon--open`]
                )
              }
            ),
            className: ie[`${ne}__button`],
            onClick: E,
            "aria-expanded": m
          }
        )
      ]
    }
  );
}, Vc = "lc-OverflowTooltipText-module__tooltipContent___M9T9h", Wc = "lc-OverflowTooltipText-module__text___JcdMZ", n_ = {
  tooltipContent: Vc,
  text: Wc
}, Lu = ({ text: e }) => {
  const t = Kt(null), r = ii(t), { isHovered: o, handleMouseOut: _, handleMouseOver: l } = li(r), i = /* @__PURE__ */ a(
    "div",
    {
      onMouseEnter: l,
      onMouseLeave: _,
      ref: t,
      className: n_.text,
      children: e
    }
  );
  return /* @__PURE__ */ a(
    ia,
    {
      kind: "invert",
      isVisible: r && o,
      triggerRenderer: i,
      children: /* @__PURE__ */ a("div", { className: n_.tooltipContent, children: e })
    }
  );
}, Kc = "lc-Popover-module__popover___rvS3X", Yc = {
  popover: Kc
}, Xc = ({
  triggerRenderer: e,
  onClose: t,
  onOpen: r,
  children: o,
  className: _,
  triggerClassName: l,
  placement: i,
  flipOptions: n,
  offsetSize: d = 4,
  isVisible: s,
  openedOnInit: c,
  closeOnEsc: p = !0,
  useDismissHookProps: m,
  useClickHookProps: f,
  floatingStrategy: g,
  transitionOptions: y
}) => {
  const [x, S] = b.useState(c), E = Gr(), $ = ar(), w = s !== void 0, N = w ? s : x, k = typeof o == "string", C = typeof e == "function", I = (K, Z) => {
    K ? r == null || r(Z) : t == null || t(Z), !w && S(K);
  }, { refs: T, context: M, floatingStyles: A } = rr({
    nodeId: $,
    open: N,
    onOpenChange: I,
    middleware: [or(d), Ur(n), xo()],
    placement: i,
    strategy: g,
    whileElementsMounted: _r
  }), D = lr(M, f), G = ir(M, v({
    escapeKey: p
  }, m)), P = nr(M), { getReferenceProps: L, getFloatingProps: O } = cr([
    D,
    G,
    P
  ]), q = {
    initial: ({ side: K }) => v({
      opacity: 0
    }, K === "bottom" && {
      marginTop: -10
    } || K === "top" && {
      marginTop: 10
    } || K === "left" && {
      marginLeft: 10
    } || K === "right" && {
      marginLeft: -10
    })
  }, { isMounted: Y, styles: te } = Lr(
    M,
    y || q
  ), ye = u(Yc.popover, _), ge = /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ a(
      "div",
      B(v({
        "data-testid": "popover-trigger-button",
        ref: T.setReference
      }, L()), {
        className: l,
        children: C ? e() : e
      })
    ),
    /* @__PURE__ */ a($a, { id: $, children: Y && /* @__PURE__ */ a(ko, { context: M, modal: !1, children: /* @__PURE__ */ a(
      "div",
      B(v({
        className: ye,
        ref: T.setFloating,
        style: v(v({}, A), te)
      }, O()), {
        children: k ? /* @__PURE__ */ a(F, { as: "div", children: o }) : o
      })
    ) }) })
  ] });
  return E === null ? /* @__PURE__ */ a(qr, { children: ge }) : ge;
}, tt = {
  "outer-border": "lc-ProductTile-module__outer-border___tsyqh",
  "product-tile-wrapper": "lc-ProductTile-module__product-tile-wrapper___iKDxM",
  "product-tile-wrapper__animated": "lc-ProductTile-module__product-tile-wrapper__animated___xwIAa",
  "product-tile": "lc-ProductTile-module__product-tile___SAnnV",
  "product-tile__second-layer": "lc-ProductTile-module__product-tile__second-layer___YFtzE",
  "product-tile__third-layer": "lc-ProductTile-module__product-tile__third-layer___W0nsL",
  "product-tile__main-product": "lc-ProductTile-module__product-tile__main-product___Imdix",
  "product-tile__badge": "lc-ProductTile-module__product-tile__badge___EwFjs",
  "product-tile__badge--bordered": "lc-ProductTile-module__product-tile__badge--bordered___H08Ep",
  "product-tile__icon": "lc-ProductTile-module__product-tile__icon___IQqzd",
  "product-tile__icon--large": "lc-ProductTile-module__product-tile__icon--large___Ta9v0",
  "product-tile__icon--expired": "lc-ProductTile-module__product-tile__icon--expired___5PbNr"
}, Lt = "product-tile", Y_ = ({
  icon: e,
  iconColor: t,
  expired: r,
  backgroundColors: o,
  borderColor: _,
  notificationCount: l,
  withBorder: i = !1,
  isMainProduct: n = !1
}) => /* @__PURE__ */ a("div", { className: u({ [tt["outer-border"]]: i }), children: /* @__PURE__ */ h(
  "div",
  {
    tabIndex: n ? 0 : -1,
    className: u(tt["product-tile-wrapper"], {
      [tt["product-tile-wrapper__animated"]]: n
    }),
    children: [
      n && /* @__PURE__ */ h(Q, { children: [
        /* @__PURE__ */ a(
          "div",
          {
            className: tt[`${Lt}__third-layer`],
            style: { background: o.third }
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            className: tt[`${Lt}__second-layer`],
            style: { background: o.second }
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          className: u(tt[Lt], {
            [tt[`${Lt}__main-product`]]: n
          }),
          style: {
            background: r ? "var(--surface-moderate-default)" : o.main,
            border: _ ? `1px solid ${_}` : ""
          },
          children: [
            l && !r ? /* @__PURE__ */ a(
              Dr,
              {
                size: "compact",
                count: l,
                className: u(tt[`${Lt}__badge`], {
                  [tt[`${Lt}__badge--bordered`]]: n
                })
              }
            ) : null,
            /* @__PURE__ */ a(
              R,
              {
                source: e,
                className: u(tt[`${Lt}__icon`], {
                  [tt[`${Lt}__icon--large`]]: n,
                  [tt[`${Lt}__icon--expired`]]: r
                }),
                customColor: t
              }
            )
          ]
        }
      )
    ]
  }
) }), mt = {
  "product-row": "lc-ProductRow-module__product-row___eDpb-",
  "product-row--expired": "lc-ProductRow-module__product-row--expired___-ttqU",
  "product-row__divider": "lc-ProductRow-module__product-row__divider___Fe--b",
  "product-row__heading": "lc-ProductRow-module__product-row__heading___xjZuH",
  "product-row__shortcut": "lc-ProductRow-module__product-row__shortcut___g3-0w",
  "product-row__name": "lc-ProductRow-module__product-row__name___qAIq-",
  "product-row__tooltip-icon": "lc-ProductRow-module__product-row__tooltip-icon___XO-IY",
  "product-row__trial-tooltip": "lc-ProductRow-module__product-row__trial-tooltip___naThN",
  "product-row__tooltip-dark-shadow": "lc-ProductRow-module__product-row__tooltip-dark-shadow___U8Tqp"
}, pt = "product-row", Zc = ({
  product: {
    id: e,
    icon: t,
    iconColor: r,
    backgroundColors: o,
    borderColor: _,
    notificationCount: l,
    name: i,
    url: n,
    withDivider: d,
    shortcutKey: s,
    expired: c,
    trialDaysLeft: p,
    nameAdornment: m
  },
  onClick: f,
  isActive: g = !1,
  isDarkMode: y
}) => /* @__PURE__ */ h(Q, { children: [
  d && /* @__PURE__ */ a("div", { className: mt[`${pt}__divider`] }),
  /* @__PURE__ */ h(
    "a",
    {
      href: n,
      target: "_blank",
      "aria-label": `Go to ${i} product`,
      onClick: (x) => f(x, e),
      className: u(mt[pt], {
        [mt[`${pt}--expired`]]: c
      }),
      children: [
        /* @__PURE__ */ h("div", { className: mt[`${pt}__heading`], children: [
          /* @__PURE__ */ a(
            Y_,
            {
              icon: t,
              iconColor: r,
              expired: c,
              backgroundColors: o,
              borderColor: _,
              notificationCount: l,
              withBorder: g
            }
          ),
          /* @__PURE__ */ h(F, { as: "div", bold: !0, className: mt[`${pt}__name`], children: [
            i,
            c && /* @__PURE__ */ a(
              ia,
              {
                className: u({
                  [mt[`${pt}__tooltip-dark-shadow`]]: y
                }),
                triggerRenderer: /* @__PURE__ */ a(
                  R,
                  {
                    source: Ir,
                    className: mt[`${pt}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: "Your licence is expired."
              }
            ),
            typeof p != "undefined" && /* @__PURE__ */ h(
              ia,
              {
                className: u(mt[`${pt}__trial-tooltip`], {
                  [mt[`${pt}__tooltip-dark-shadow`]]: y
                }),
                triggerRenderer: /* @__PURE__ */ a(
                  R,
                  {
                    source: Ir,
                    className: mt[`${pt}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: [
                  p,
                  " ",
                  Pr(p, "day", "days"),
                  " left in your trial. Time to upgrade."
                ]
              }
            ),
            m
          ] })
        ] }),
        s && /* @__PURE__ */ h(F, { size: "sm", className: mt[`${pt}__shortcut`], children: [
          "⌘",
          s
        ] })
      ]
    }
  )
] }), La = {
  "product-switcher": "lc-ProductSwitcher-module__product-switcher___Dqwcp",
  "product-switcher__content": "lc-ProductSwitcher-module__product-switcher__content___-P5yw",
  "product-switcher__footer": "lc-ProductSwitcher-module__product-switcher__footer___YRPN9",
  "product-switcher__footer-link": "lc-ProductSwitcher-module__product-switcher__footer-link___X0VOn",
  "product-switcher__tooltip": "lc-ProductSwitcher-module__product-switcher__tooltip___kcVyp"
}, qa = "product-switcher", qu = ({
  productOptions: e,
  mainProductId: t,
  openedOnInit: r = !1,
  isVisible: o,
  isDarkMode: _ = !0,
  onOpen: l,
  onClose: i,
  onSelect: n,
  textURL: d = "https://www.text.com"
}) => {
  const [s, c] = b.useState(r), [p, m] = ce(
    !1
  ), f = Gr(), g = ar(), y = o !== void 0, x = y ? o : s, S = (O, q) => {
    O ? l == null || l(q) : i == null || i(q), !y && c(O);
  }, { refs: E, context: $, floatingStyles: w } = rr({
    nodeId: g,
    strategy: "fixed",
    placement: "right-start",
    open: x,
    onOpenChange: (O, q) => {
      m(!1), S(O, q);
    },
    middleware: [or({ mainAxis: 5 })],
    whileElementsMounted: _r
  }), N = lr($), k = nr($), C = ir($), { isMounted: I, styles: T } = Lr($, {
    duration: 200,
    common: {
      transformOrigin: "left top"
    },
    initial: {
      opacity: 0,
      transform: "scale(0.84) translateX(-22px)"
    }
  }), { getReferenceProps: M, getFloatingProps: A } = cr([
    N,
    C,
    k
  ]), D = e.find(
    (O) => O.id === t
  );
  if (!D)
    return null;
  const G = (O, q) => {
    q === t && O.preventDefault(), c(!1), n == null || n(q);
  }, P = e.reduce(
    (O, q) => O + (q.notificationCount || 0),
    0
  ), L = /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ a("div", B(v({ ref: E.setReference }, M()), { children: /* @__PURE__ */ a(
      ia,
      {
        isVisible: p,
        onOpen: () => m(!0),
        onClose: () => m(!1),
        offsetCrossAxis: 2,
        arrowOffsetY: 2,
        offsetMainAxis: 10,
        hoverOnDelay: 400,
        className: u(La[`${qa}__tooltip`]),
        placement: "right",
        floatingStrategy: "fixed",
        kind: "invert",
        triggerRenderer: /* @__PURE__ */ a(
          Y_,
          {
            isMainProduct: !0,
            icon: D.icon,
            iconColor: D.iconColor,
            backgroundColors: D.backgroundColors,
            notificationCount: P
          }
        ),
        closeOnTriggerBlur: !0,
        children: "Switch product"
      }
    ) })),
    /* @__PURE__ */ a($a, { id: g, children: /* @__PURE__ */ a(
      "div",
      B(v({
        ref: E.setFloating,
        style: w
      }, A()), {
        children: I && /* @__PURE__ */ h(
          "div",
          {
            className: u(
              _ ? "lc-dark-theme" : "lc-light-theme",
              La[qa]
            ),
            style: T,
            children: [
              /* @__PURE__ */ a("div", { className: La[`${qa}__content`], children: e.map((O) => /* @__PURE__ */ a(
                Zc,
                {
                  isDarkMode: _,
                  isActive: O.id === t,
                  product: O,
                  onClick: G
                },
                O.id
              )) }),
              /* @__PURE__ */ a("div", { className: La[`${qa}__footer`], children: /* @__PURE__ */ h(
                "a",
                {
                  href: d,
                  target: "_blank",
                  className: La[`${qa}__footer-link`],
                  onClick: () => S(!1),
                  children: [
                    /* @__PURE__ */ a(F, { noMargin: !0, children: "powered by" }),
                    /* @__PURE__ */ a(
                      R,
                      {
                        size: "xlarge",
                        source: vl,
                        customColor: "var(--content-basic-primary)"
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      })
    ) })
  ] });
  return f === null ? /* @__PURE__ */ a(qr, { children: L }) : L;
}, jc = 'data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cg clip-path="url(%23clip0_24854_8994)"%3E%3Crect width="40" height="40" fill="%230066FF"/%3E%3Cg filter="url(%23filter0_f_24854_8994)"%3E%3Cpath d="M32.6382 31.0816C41.9891 31.0816 49.5694 23.5012 49.5694 14.1504C49.5694 4.79953 41.9891 -2.78082 32.6382 -2.78082C23.2874 -2.78082 15.707 4.79953 15.707 14.1504C15.707 23.5012 23.2874 31.0816 32.6382 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter1_f_24854_8994)"%3E%3Cpath d="M10.417 50.1292C19.7679 50.1292 27.3482 42.5488 27.3482 33.198C27.3482 23.8471 19.7679 16.2668 10.417 16.2668C1.0662 16.2668 -6.51416 23.8471 -6.51416 33.198C-6.51416 42.5488 1.0662 50.1292 10.417 50.1292Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter2_f_24854_8994)"%3E%3Cpath d="M9.35788 16.2667C15.2022 16.2667 19.9399 11.529 19.9399 5.68472C19.9399 -0.159555 15.2022 -4.89728 9.35788 -4.89728C3.5136 -4.89728 -1.22412 -0.159555 -1.22412 5.68472C-1.22412 11.529 3.5136 16.2667 9.35788 16.2667Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter3_f_24854_8994)"%3E%3Cpath d="M7.24274 18.3831C13.6714 18.3831 18.8829 13.1716 18.8829 6.74292C18.8829 0.314217 13.6714 -4.89728 7.24274 -4.89728C0.814034 -4.89728 -4.39746 0.314217 -4.39746 6.74292C-4.39746 13.1716 0.814034 18.3831 7.24274 18.3831Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter4_f_24854_8994)"%3E%3Cpath d="M8.29938 21.5577C14.7281 21.5577 19.9396 16.3462 19.9396 9.91748C19.9396 3.48878 14.7281 -1.72272 8.29938 -1.72272C1.87068 -1.72272 -3.34082 3.48878 -3.34082 9.91748C-3.34082 16.3462 1.87068 21.5577 8.29938 21.5577Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter5_f_24854_8994)"%3E%3Cpath d="M33.6973 45.8964C40.126 45.8964 45.3375 40.6849 45.3375 34.2562C45.3375 27.8275 40.126 22.616 33.6973 22.616C27.2686 22.616 22.0571 27.8275 22.0571 34.2562C22.0571 40.6849 27.2686 45.8964 33.6973 45.8964Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter6_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter7_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter8_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter9_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter10_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter11_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter12_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter13_f_24854_8994)"%3E%3Cpath d="M9.35898 38.489C12.8655 38.489 15.7082 35.6463 15.7082 32.1398C15.7082 28.6332 12.8655 25.7906 9.35898 25.7906C5.8524 25.7906 3.00977 28.6332 3.00977 32.1398C3.00977 35.6463 5.8524 38.489 9.35898 38.489Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter14_f_24854_8994)"%3E%3Cpath d="M38.9871 31.0816C46.5846 31.0816 52.7437 24.9225 52.7437 17.325C52.7437 9.7274 46.5846 3.56836 38.9871 3.56836C31.3895 3.56836 25.2305 9.7274 25.2305 17.325C25.2305 24.9225 31.3895 31.0816 38.9871 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter15_f_24854_8994)"%3E%3Cpath d="M38.9879 25.7905C45.4166 25.7905 50.6281 20.579 50.6281 14.1503C50.6281 7.72157 45.4166 2.51007 38.9879 2.51007C32.5592 2.51007 27.3477 7.72157 27.3477 14.1503C27.3477 20.579 32.5592 25.7905 38.9879 25.7905Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter16_f_24854_8994)"%3E%3Cpath d="M9.35868 21.5578C14.0341 21.5578 17.8243 17.7676 17.8243 13.0922C17.8243 8.41674 14.0341 4.62656 9.35868 4.62656C4.68325 4.62656 0.893066 8.41674 0.893066 13.0922C0.893066 17.7676 4.68325 21.5578 9.35868 21.5578Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter17_f_24854_8994)"%3E%3Cpath d="M31.5797 18.3831C35.0862 18.3831 37.9289 15.5404 37.9289 12.0339C37.9289 8.5273 35.0862 5.68466 31.5797 5.68466C28.0731 5.68466 25.2305 8.5273 25.2305 12.0339C25.2305 15.5404 28.0731 18.3831 31.5797 18.3831Z" fill="%23FF2E00"/%3E%3C/g%3E%3Cg filter="url(%23filter18_f_24854_8994)"%3E%3Cpath d="M12.5312 14.1503C18.3755 14.1503 23.1132 9.41257 23.1132 3.5683C23.1132 -2.27598 18.3755 -7.0137 12.5312 -7.0137C6.68694 -7.0137 1.94922 -2.27598 1.94922 3.5683C1.94922 9.41257 6.68694 14.1503 12.5312 14.1503Z" fill="%233851FF"/%3E%3C/g%3E%3Cg filter="url(%23filter19_f_24854_8994)"%3E%3Cpath d="M28.4057 13.0921C34.25 13.0921 38.9877 8.35441 38.9877 2.51013C38.9877 -3.33415 34.25 -8.07187 28.4057 -8.07187C22.5615 -8.07187 17.8237 -3.33415 17.8237 2.51013C17.8237 8.35441 22.5615 13.0921 28.4057 13.0921Z" fill="%23F3354D"/%3E%3C/g%3E%3Cg filter="url(%23filter20_f_24854_8994)"%3E%3Cpath d="M33.6958 48.0128C39.54 48.0128 44.2778 43.275 44.2778 37.4308C44.2778 31.5865 39.54 26.8488 33.6958 26.8488C27.8515 26.8488 23.1138 31.5865 23.1138 37.4308C23.1138 43.275 27.8515 48.0128 33.6958 48.0128Z" fill="%23FFD101"/%3E%3C/g%3E%3Cg filter="url(%23filter21_f_24854_8994)"%3E%3Cpath d="M8.30173 43.78C14.146 43.78 18.8837 39.0422 18.8837 33.198C18.8837 27.3537 14.146 22.616 8.30173 22.616C2.45745 22.616 -2.28027 27.3537 -2.28027 33.198C-2.28027 39.0422 2.45745 43.78 8.30173 43.78Z" fill="%237FCF35"/%3E%3C/g%3E%3Cg filter="url(%23filter22_f_24854_8994)"%3E%3Cpath d="M6.18454 34.2562C12.0288 34.2562 16.7665 29.5184 16.7665 23.6742C16.7665 17.8299 12.0288 13.0922 6.18454 13.0922C0.340261 13.0922 -4.39746 17.8299 -4.39746 23.6742C-4.39746 29.5184 0.340261 34.2562 6.18454 34.2562Z" fill="%231D7DD0"/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id="filter0_f_24854_8994" x="-8.29297" y="-26.7808" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter1_f_24854_8994" x="-30.5142" y="-7.73322" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter2_f_24854_8994" x="-25.2241" y="-28.8973" width="69.1641" height="69.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter3_f_24854_8994" x="-28.3975" y="-28.8973" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter4_f_24854_8994" x="-27.3408" y="-25.7227" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter5_f_24854_8994" x="-1.94287" y="-1.38403" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter6_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter7_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter8_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter9_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter10_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter11_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter12_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter13_f_24854_8994" x="-20.9902" y="1.79056" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter14_f_24854_8994" x="1.23047" y="-20.4316" width="75.5132" height="75.5132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter15_f_24854_8994" x="3.34766" y="-21.4899" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter16_f_24854_8994" x="-23.1069" y="-19.3734" width="64.9312" height="64.9312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter17_f_24854_8994" x="1.23047" y="-18.3153" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter18_f_24854_8994" x="-9.05078" y="-18.0137" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter19_f_24854_8994" x="6.82373" y="-19.0719" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter20_f_24854_8994" x="12.1138" y="15.8488" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter21_f_24854_8994" x="-13.2803" y="11.616" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter22_f_24854_8994" x="-15.3975" y="2.09216" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3CclipPath id="clip0_24854_8994"%3E%3Crect width="40" height="40" fill="white"/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A', Jc = [
  {
    id: "livechat",
    name: "LiveChat",
    icon: kl,
    backgroundColors: {
      main: "var(--products-livechat)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "chatbot",
    name: "ChatBot",
    icon: yl,
    backgroundColors: {
      main: "var(--products-chatbot)",
      second: "var(--products-livechat)",
      third: "var(--products-helpdesk)"
    },
    url: ""
  },
  {
    id: "helpdesk",
    name: "HelpDesk",
    icon: Cl,
    backgroundColors: {
      main: "var(--products-helpdesk)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: "",
    expired: !0
  },
  {
    id: "knowledgebase",
    name: "KnowledgeBase",
    icon: wl,
    backgroundColors: {
      main: "var(--products-knowledgebase)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: "",
    trialDaysLeft: 2
  },
  {
    id: "openwidget",
    name: "OpenWidget",
    icon: $l,
    backgroundColors: {
      main: `url('${jc}')`,
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "teamchat",
    name: "TeamChat",
    icon: Nl,
    backgroundColors: {
      main: "var(--products-hello)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "accounts",
    name: "Text Accounts",
    icon: Sl,
    backgroundColors: {
      main: "var(--surface-locked-white)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    iconColor: "var(--content-locked-black)",
    withDivider: !0,
    url: "",
    borderColor: "var(--border-basic-secondary)"
  }
], Qc = [
  {
    clientId: "58737b5829e65621a45d598aa6f2ed8e",
    redirectUri: "https://my.labs.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "ee078090-b721-4e2b-9cf2-65e95904634c",
    redirectUri: "https://app.labs.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "9638698004690917c9b787a2e16fc007",
    redirectUri: "https://app.staging.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "40f0baca4e364c84c2d89bf3403caa31",
    redirectUri: "https://app.labs.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "de5fce27f8c77fa41e9fa621beeed111",
    redirectUri: "https://app.staging.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6193fd6d9771645e2dc6a4614c677314",
    redirectUri: "https://teamchat.labs.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "0ab5cf9b99447db22109ff70003d4507",
    redirectUri: "https://accounts.labs.livechat.com/panel",
    product: "Accounts"
  }
], es = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.staging.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.staging.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6c493637185258c1a937e68886906831",
    redirectUri: "https//teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.staging.livechat.com/panel",
    product: "Accounts"
  }
], X_ = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "1ebfa721f575b1346b9c76bb8f86583c",
    redirectUri: "https://teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.livechat.com/panel",
    product: "Accounts"
  }
], ts = [
  "livechat",
  "chatbot",
  "helpdesk",
  "accounts"
], Do = {
  livechat: "LiveChat",
  helpdesk: "HelpDesk",
  accounts: "Accounts",
  knowledgebase: "KnowledgeBase",
  chatbot: "ChatBot",
  openwidget: "OpenWidget",
  teamchat: "TeamChat"
}, as = (e, t, r, o, _) => {
  let l = "";
  _ && _ !== "prod" ? l += `https://accounts.${_}.livechat.com` : l += "https://accounts.livechat.com";
  const i = ls(_, o), n = `${l}?client_id=${e}&redirect_uri=${encodeURIComponent(
    t
  )}&response_type=token&organization_id=${r}`;
  return i ? `${n}&utm_source=${i}&utm_medium=referral&utm_campaign=productswitcher` : n;
}, rs = (e) => {
  const t = new Date(e), r = /* @__PURE__ */ new Date();
  return Zl(t) ? 0 : w_(t, r);
}, os = (e, t) => ts.includes(e) || t.some(
  (r) => r.product === Do[e]
), _s = (e, t, r, o, _, l) => {
  var n, d, s, c, p;
  const i = t.find(
    (m) => m.product === Do[e.id]
  );
  if (!i)
    throw new Error(`Product data for ${e.id} not found`);
  return B(v({}, e), {
    trialDaysLeft: r[e.id] && ((n = r[e.id]) == null ? void 0 : n.status) === "trial" && ((d = r[e.id]) != null && d.next_charge_at) ? rs((c = (s = r[e.id]) == null ? void 0 : s.next_charge_at) != null ? c : "") : void 0,
    expired: ((p = r[e.id]) == null ? void 0 : p.status) === "expired",
    url: as(
      i.clientId,
      i.redirectUri,
      o,
      _,
      l
    )
  });
}, Z_ = (e) => {
  switch (e) {
    case "prod":
      return X_;
    case "staging":
      return es;
    case "labs":
      return Qc;
    default:
      return [];
  }
}, ls = (e, t) => {
  const o = Z_(e).find(
    (_) => _.product === Do[t]
  );
  return o == null ? void 0 : o.redirectUri.replace("https://", "");
}, Hu = ({
  env: e = "prod",
  installedProducts: t,
  subscriptions: r,
  organizationId: o,
  mainProductId: _
}) => {
  if (!t || !r || !o)
    throw new Error("Missing required parameters");
  const l = e ? Z_(e) : X_;
  return {
    products: Jc.reduce(
      (i, n) => (os(n.id, t) && i.push(
        _s(
          n,
          l,
          r,
          o,
          _,
          e
        )
      ), i),
      []
    )
  };
}, is = (e) => Math.min(Math.max(e, 0), 100);
function j_(e, t = 0) {
  return e === "error" ? 0 : is(parseInt(t.toString(), 10));
}
const Ha = {
  "progress-circle": "lc-ProgressCircle-module__progress-circle___H4Abd",
  "progress-circle--small": "lc-ProgressCircle-module__progress-circle--small___BH3y7",
  "progress-circle--medium": "lc-ProgressCircle-module__progress-circle--medium___0GWFs",
  "progress-circle--large": "lc-ProgressCircle-module__progress-circle--large___AxNYV",
  "progress-circle__bg-line--normal": "lc-ProgressCircle-module__progress-circle__bg-line--normal___LYe5F",
  "progress-circle__bg-line--success": "lc-ProgressCircle-module__progress-circle__bg-line--success___51Jk6",
  "progress-circle__bg-line--error": "lc-ProgressCircle-module__progress-circle__bg-line--error___uIy7L",
  "progress-circle__indicator--normal": "lc-ProgressCircle-module__progress-circle__indicator--normal___LVjBb",
  "progress-circle__indicator--success": "lc-ProgressCircle-module__progress-circle__indicator--success___JnXe0",
  "progress-circle__indicator--error": "lc-ProgressCircle-module__progress-circle__indicator--error___HejoU"
}, ns = {
  small: 2,
  medium: 3,
  large: 4
}, cs = {
  small: 15,
  medium: 36,
  large: 56
}, za = "progress-circle", ss = b.forwardRef(
  (i, l) => {
    var n = i, {
      status: e = "normal",
      progressValue: t,
      className: r,
      size: o = "medium"
    } = n, _ = U(n, [
      "status",
      "progressValue",
      "className",
      "size"
    ]);
    const d = j_(e, t), s = ns[o], c = cs[o], p = u(
      Ha[za],
      {
        [Ha[`${za}--${o}`]]: o,
        [Ha[`${za}--${e}`]]: e
      },
      r
    ), m = 2 * Math.PI * ((c - s) / 2), f = {
      strokeDasharray: m.toFixed(3),
      strokeDashoffset: `${((100 - d) / 100 * m).toFixed(3)}px`
    }, g = `${c / 2} ${c / 2} ${c} ${c}`;
    return /* @__PURE__ */ a(
      "div",
      B(v({
        className: p,
        ref: l,
        role: "progressbar"
      }, _), {
        children: /* @__PURE__ */ h("svg", { viewBox: g, children: [
          /* @__PURE__ */ a(
            "circle",
            {
              className: Ha[`${za}__bg-line--${e}`],
              cx: c,
              cy: c,
              r: (c - s) / 2,
              fill: "none",
              strokeWidth: s
            }
          ),
          /* @__PURE__ */ a(
            "circle",
            {
              className: Ha[`${za}__indicator--${e}`],
              style: f,
              cx: c,
              cy: c,
              r: (c - s) / 2,
              fill: "none",
              strokeWidth: s
            }
          )
        ] })
      })
    );
  }
), $r = {
  "progress-bar": "lc-ProgressBar-module__progress-bar___ERC2D",
  "progress-bar--small": "lc-ProgressBar-module__progress-bar--small___PPhCr",
  "progress-bar--medium": "lc-ProgressBar-module__progress-bar--medium___GgSEb",
  "progress-bar--large": "lc-ProgressBar-module__progress-bar--large___Seq-t",
  "progress-bar--error": "lc-ProgressBar-module__progress-bar--error___2AR1I",
  "progress-bar--success": "lc-ProgressBar-module__progress-bar--success___-fKPU",
  "progress-bar--normal": "lc-ProgressBar-module__progress-bar--normal___WboRI",
  "progress-bar__indicator--success": "lc-ProgressBar-module__progress-bar__indicator--success___MHAlN",
  "progress-bar__indicator--normal": "lc-ProgressBar-module__progress-bar__indicator--normal___sjEAI"
}, Nr = "progress-bar", ds = b.forwardRef(
  (i, l) => {
    var n = i, {
      status: e = "normal",
      percent: t,
      size: r = "medium",
      className: o = ""
    } = n, _ = U(n, [
      "status",
      "percent",
      "size",
      "className"
    ]);
    const d = j_(e, t), s = u(
      $r[Nr],
      {
        [$r[`${Nr}--${r}`]]: r,
        [$r[`${Nr}--${e}`]]: e
      },
      o
    );
    return /* @__PURE__ */ a(
      "div",
      B(v({}, _), {
        className: s,
        ref: l,
        role: "progressbar",
        children: /* @__PURE__ */ a(
          "div",
          {
            "data-testid": "progress-bar-indicator",
            className: $r[`${Nr}__indicator--${e}`],
            style: { width: `${d}%` }
          }
        )
      })
    );
  }
), Et = {
  "main-wrapper": "lc-PromoBannerV2-module__main-wrapper___6Ka0j",
  "promo-banner-v2": "lc-PromoBannerV2-module__promo-banner-v2___vkVos",
  "promo-banner-v2__content": "lc-PromoBannerV2-module__promo-banner-v2__content___16-yG",
  "promo-banner-v2__content__cta": "lc-PromoBannerV2-module__promo-banner-v2__content__cta___59Ml7",
  "promo-banner-v2__content__cta__secondary": "lc-PromoBannerV2-module__promo-banner-v2__content__cta__secondary___ka6nD",
  "promo-banner-v2__additional-content": "lc-PromoBannerV2-module__promo-banner-v2__additional-content___QsE3z",
  "promo-banner-v2__close": "lc-PromoBannerV2-module__promo-banner-v2__close___HA3Hr",
  "promo-banner-v2__close__btn": "lc-PromoBannerV2-module__promo-banner-v2__close__btn___23Qui",
  "promo-banner-v2--dark": "lc-PromoBannerV2-module__promo-banner-v2--dark___pmXpS",
  "promo-banner-v2--vertical": "lc-PromoBannerV2-module__promo-banner-v2--vertical___hXlPD"
}, qt = "promo-banner-v2", zu = ({
  children: e,
  className: t,
  additionalContent: r,
  primaryButton: o,
  secondaryButton: _,
  vertical: l,
  contentClassName: i,
  additionalContentClassName: n,
  onClose: d,
  kind: s = "default"
}) => {
  const c = u(
    Et["main-wrapper"],
    Et[`${qt}--${s}`],
    s === "dark" && jt.Dark,
    t
  );
  return /* @__PURE__ */ a("div", { role: "banner", className: c, children: /* @__PURE__ */ h(
    "div",
    {
      className: u(
        Et[qt],
        l && Et[`${qt}--vertical`]
      ),
      children: [
        /* @__PURE__ */ h(
          "div",
          {
            "data-testId": "content",
            className: u(Et[`${qt}__content`], i),
            children: [
              e,
              (o || _) && /* @__PURE__ */ h("div", { className: Et[`${qt}__content__cta`], children: [
                o && /* @__PURE__ */ a(
                  W,
                  B(v({}, o), {
                    kind: (o == null ? void 0 : o.kind) || "high-contrast",
                    onClick: o.handleClick,
                    children: o.label
                  })
                ),
                _ && /* @__PURE__ */ a(
                  W,
                  B(v({}, _), {
                    kind: (_ == null ? void 0 : _.kind) || "text",
                    onClick: _.handleClick,
                    className: u(
                      Et[`${qt}__content__cta__secondary`],
                      _.className
                    ),
                    children: _.label
                  })
                )
              ] })
            ]
          }
        ),
        r && /* @__PURE__ */ a(
          "div",
          {
            "data-testId": "additional-content",
            className: u(
              Et[`${qt}__additional-content`],
              n
            ),
            children: r
          }
        ),
        d && /* @__PURE__ */ a("div", { className: Et[`${qt}__close`], children: /* @__PURE__ */ a(
          W,
          {
            className: Et[`${qt}__close__btn`],
            onClick: d,
            icon: /* @__PURE__ */ a(R, { source: ct, kind: "primary" }),
            kind: "plain",
            size: "compact",
            "aria-label": "Close banner"
          }
        ) })
      ]
    }
  ) });
}, Tt = {
  "radio-button": "lc-RadioButton-module__radio-button___PtGXj",
  "radio-button__circle": "lc-RadioButton-module__radio-button__circle___-RXEf",
  "radio-button__label": "lc-RadioButton-module__radio-button__label___WGhio",
  "radio-button__inner-circle": "lc-RadioButton-module__radio-button__inner-circle___T5nYz",
  "radio-button__text": "lc-RadioButton-module__radio-button__text___8q8cs",
  "radio-button__input": "lc-RadioButton-module__radio-button__input___nd4MZ",
  "radio-button__helper": "lc-RadioButton-module__radio-button__helper___X4Ihv",
  "radio-button--read-only": "lc-RadioButton-module__radio-button--read-only___pSy5f",
  "radio-button--selected": "lc-RadioButton-module__radio-button--selected___00LlN",
  "radio-button--disabled": "lc-RadioButton-module__radio-button--disabled___StpOi"
}, Bt = "radio-button", us = b.forwardRef(
  (n, i) => {
    var d = n, { children: e, className: t = "", description: r, checked: o, disabled: _ } = d, l = U(d, ["children", "className", "description", "checked", "disabled"]);
    const { readOnly: s } = At(), c = s || l.readOnly, p = u(Tt[Bt], t, {
      [Tt[`${Bt}--selected`]]: o,
      [Tt[`${Bt}--disabled`]]: _,
      [Tt[`${Bt}--read-only`]]: c
    });
    return /* @__PURE__ */ h("div", { className: p, children: [
      /* @__PURE__ */ h("label", { className: Tt[`${Bt}__label`], children: [
        /* @__PURE__ */ h("div", { className: Tt[`${Bt}__circle`], children: [
          /* @__PURE__ */ a("span", { className: Tt[`${Bt}__inner-circle`] }),
          /* @__PURE__ */ a(
            "input",
            B(v({}, l), {
              className: Tt[`${Bt}__input`],
              ref: i,
              type: "radio",
              checked: o,
              disabled: _
            })
          )
        ] }),
        e && /* @__PURE__ */ a(F, { as: "div", size: "md", className: Tt[`${Bt}__text`], children: e })
      ] }),
      r && /* @__PURE__ */ a(Hr, { className: Tt[`${Bt}__helper`], children: r })
    ] });
  }
), c_ = {
  "range-date-picker-v2-label": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label___jHKH2",
  "range-date-picker-v2-label--selected": "lc-RangeDatePickerV2Label-module__range-date-picker-v2-label--selected___I-O8x"
}, s_ = "range-date-picker-v2-label", ms = ({
  tempDate: e,
  date: t,
  selectedOptionName: r
}) => {
  const o = () => e != null && e.from ? `${dr(e.from, "dd-MM-yy")}` : t != null && t.from ? `${dr(t.from, "dd-MM-yy")}` : "Start date", _ = () => e != null && e.to ? `${dr(e.to, "dd-MM-yy")}` : t != null && t.to ? `${dr(t.to, "dd-MM-yy")}` : "End date";
  return /* @__PURE__ */ h(
    F,
    {
      className: u(c_[`${s_}`], {
        [c_[`${s_}--selected`]]: (t == null ? void 0 : t.from) && (t == null ? void 0 : t.to)
      }),
      children: [
        o(),
        " - ",
        _(),
        " ",
        r && `(${r})`
      ]
    }
  );
}, at = $_(), Sr = [
  {
    id: "today",
    label: "Today",
    value: { from: at, to: at }
  },
  {
    id: "yesterday",
    label: "Yesterday",
    value: { from: ur(at, 1), to: ur(at, 1) }
  },
  {
    id: "last7days",
    label: "Last 7 days",
    value: { from: ur(at, 6), to: at }
  },
  {
    id: "last30days",
    label: "Last 30 days",
    value: { from: ur(at, 29), to: at }
  },
  {
    id: "lastMonth",
    label: "Last month",
    value: {
      from: Uo(ra(at, 1)),
      to: jl(ra(at, 1))
    }
  },
  {
    id: "currentMonth",
    label: "Current month",
    value: { from: Uo(at), to: at }
  }
], ps = (e, t) => t != null && t.from && (t != null && t.to) && (e != null && e.from) && (e != null && e.to) ? t.from.getTime() === e.from.getTime() && t.to.getTime() === e.to.getTime() : !1, Fe = {
  "range-date-picker__popover": "lc-RangeDatePickerV2-module__range-date-picker__popover___0Q1sv",
  "range-date-picker__trigger": "lc-RangeDatePickerV2-module__range-date-picker__trigger___QX-yx",
  "range-date-picker__trigger__right-node--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node--active___HYCcu",
  "range-date-picker__trigger__right-node__icon": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__icon___fHaPd",
  "range-date-picker__trigger__right-node__button": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node__button___XqDl3",
  "range-date-picker__trigger__right-node": "lc-RangeDatePickerV2-module__range-date-picker__trigger__right-node___amiev",
  "range-date-picker__trigger--active": "lc-RangeDatePickerV2-module__range-date-picker__trigger--active___JX1bA",
  "range-date-picker__date-picker": "lc-RangeDatePickerV2-module__range-date-picker__date-picker___dzDlt",
  "range-date-picker__date-picker__list": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list___tlSQ8",
  "range-date-picker__date-picker__list__item": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item___uH4Y9",
  "range-date-picker__date-picker__list__item--selected": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item--selected___-0-d6",
  "range-date-picker__date-picker__list__item__icon": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__list__item__icon___5A--A",
  "range-date-picker__date-picker__callendar": "lc-RangeDatePickerV2-module__range-date-picker__date-picker__callendar___3dPDs"
}, Me = "range-date-picker", gs = $_(), hs = 680, Vu = (i) => {
  var n = i, {
    initiallyOpen: e = !1,
    initialSelectedOptionId: t,
    onRangeSelect: r,
    triggerClassName: o,
    rangeDatePickerClassName: _
  } = n, l = U(n, [
    "initiallyOpen",
    "initialSelectedOptionId",
    "onRangeSelect",
    "triggerClassName",
    "rangeDatePickerClassName"
  ]);
  const { initialFromDate: d, initialToDate: s } = l, c = d || s ? {
    from: d,
    to: s
  } : void 0, [p, m] = ce(c), [f, g] = ce(!1), [y, x] = ce(), [S, E] = ce(e), [$, w] = ce(), N = Kt(-1), k = Kt(null);
  window.onresize = () => window.innerWidth <= hs ? g(!0) : g(!1);
  const C = (P) => N.current + P, I = (P) => {
    var q, Y;
    N.current = C(P);
    const L = (q = k.current) == null ? void 0 : q.children, O = L && ((Y = L[N.current]) == null ? void 0 : Y.children[0]);
    return O == null ? void 0 : O.focus();
  }, T = (P) => {
    P.key === se.arrowUp && N.current > 0 && (P.preventDefault(), I(-1)), P.key === se.arrowDown && N.current + 1 < Sr.length && (P.preventDefault(), I(1));
  }, M = (P, L) => {
    m(P || void 0), r(P, L), x(void 0), w(void 0);
  }, A = () => {
    x(void 0), E(!1);
  }, D = vt(
    ({ from: P, to: L }, O) => {
      M({ from: P, to: L }, O), A(), w(O);
    },
    [M, A]
  ), G = vt(
    (P) => {
      !P || ps(P, p) || (M(P), A());
    },
    [p]
  );
  return z(() => {
    if (S)
      return document.addEventListener("keydown", T), () => document.removeEventListener("keydown", T);
    N.current = -1;
  }, [S, T]), z(() => {
    if (t && !p) {
      const P = Sr.find(({ id: L }) => L === t);
      P && D(P.value, P.id);
    }
  }, [t, p, D]), /* @__PURE__ */ a("div", { className: Fe[Me], children: /* @__PURE__ */ a(
    Xc,
    {
      isVisible: S,
      onOpen: () => E(!0),
      onClose: A,
      className: Fe[`${Me}__popover`],
      placement: "bottom-start",
      triggerRenderer: () => {
        var P;
        return /* @__PURE__ */ h(
          "div",
          {
            tabIndex: 0,
            role: "button",
            "data-testid": "range-date-picker-trigger",
            "aria-label": "Select date range",
            className: u(
              Fe[`${Me}__trigger`],
              {
                [Fe[`${Me}__trigger--active`]]: S
              },
              o
            ),
            onKeyDown: (L) => {
              (L.key === se.enter || L.key === se.spacebar) && I(1);
            },
            children: [
              /* @__PURE__ */ a(
                ms,
                {
                  tempDate: y,
                  date: p,
                  selectedOptionName: (P = Sr.find(({ id: L }) => L === $)) == null ? void 0 : P.label
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  className: u(
                    Fe[`${Me}__trigger__right-node`],
                    p && Fe[`${Me}__trigger__right-node--active`]
                  ),
                  children: [
                    /* @__PURE__ */ a(
                      R,
                      {
                        source: xl,
                        className: Fe[`${Me}__trigger__right-node__icon`]
                      }
                    ),
                    p && /* @__PURE__ */ a(
                      W,
                      {
                        size: "xcompact",
                        kind: "plain",
                        icon: /* @__PURE__ */ a(R, { size: "xsmall", source: ct }),
                        className: Fe[`${Me}__trigger__right-node__button`],
                        onClick: () => M(null)
                      }
                    )
                  ]
                }
              )
            ]
          }
        );
      },
      children: /* @__PURE__ */ h(
        "div",
        {
          "data-testid": "range-date-picker",
          id: "date-range-popup",
          className: u(
            Fe[`${Me}__date-picker`],
            _
          ),
          children: [
            /* @__PURE__ */ a(
              "ul",
              {
                role: "menu",
                ref: k,
                className: Fe[`${Me}__date-picker__list`],
                children: Sr.map((P) => /* @__PURE__ */ a("li", { role: "none", children: /* @__PURE__ */ h(
                  "button",
                  {
                    "aria-selected": $ === P.id,
                    role: "menuitem",
                    className: u(
                      Fe[`${Me}__date-picker__list__item`],
                      {
                        [Fe[`${Me}__date-picker__list__item--selected`]]: $ === P.id
                      }
                    ),
                    onClick: () => D(P.value, P.id),
                    onMouseEnter: () => x(P.value),
                    onMouseLeave: () => x(void 0),
                    children: [
                      /* @__PURE__ */ a(F, { as: "span", children: P.label }),
                      $ === P.id && /* @__PURE__ */ a(
                        "div",
                        {
                          className: Fe[`${Me}__date-picker__list__item__icon`],
                          children: /* @__PURE__ */ a(R, { source: wa, kind: "action-primary" })
                        }
                      )
                    ]
                  }
                ) }, P.id))
              }
            ),
            /* @__PURE__ */ a("div", { className: Fe[`${Me}__date-picker__callendar`], children: /* @__PURE__ */ a(
              K_,
              B(v({
                onRangeSelect: G,
                customTempFromDate: (y == null ? void 0 : y.from) || (p == null ? void 0 : p.from),
                customTempToDate: (y == null ? void 0 : y.to) || (p == null ? void 0 : p.to),
                onCustomTempDateRangeChange: x,
                initialToDate: (p == null ? void 0 : p.to) || gs
              }, l), {
                children: ({ datepicker: P }) => /* @__PURE__ */ a(yc, B(v({}, P), { numberOfMonths: f ? 1 : 2 }))
              })
            ) })
          ]
        }
      )
    }
  ) });
}, Re = {
  "search-input": "lc-SearchInput-module__search-input___3J4w9",
  "search-input--compact": "lc-SearchInput-module__search-input--compact___4hBLm",
  "search-input--medium": "lc-SearchInput-module__search-input--medium___c3OEc",
  "search-input--large": "lc-SearchInput-module__search-input--large___RcwfK",
  "search-input--focused": "lc-SearchInput-module__search-input--focused___XvA05",
  "search-input--disabled": "lc-SearchInput-module__search-input--disabled___m1suy",
  "search-input--collapsable": "lc-SearchInput-module__search-input--collapsable___LgOIB",
  "search-input--collapsable--compact": "lc-SearchInput-module__search-input--collapsable--compact___QgiH-",
  "search-input--collapsable--medium": "lc-SearchInput-module__search-input--collapsable--medium___KVwWI",
  "search-input--collapsable--large": "lc-SearchInput-module__search-input--collapsable--large___ks2s-",
  "search-input__search-icon": "lc-SearchInput-module__search-input__search-icon___KYne6",
  "search-input--collapsable--open": "lc-SearchInput-module__search-input--collapsable--open___a3kOq",
  "search-input__search-icon--compact": "lc-SearchInput-module__search-input__search-icon--compact___3imck",
  "search-input__search-icon--medium": "lc-SearchInput-module__search-input__search-icon--medium___exSsN",
  "search-input__search-icon--large": "lc-SearchInput-module__search-input__search-icon--large___qFfxH",
  "search-input__clear-icon": "lc-SearchInput-module__search-input__clear-icon___PgKgA",
  "search-input__loader": "lc-SearchInput-module__search-input__loader___9veIC",
  "search-input__input-wrapper": "lc-SearchInput-module__search-input__input-wrapper___9NT39",
  "search-input__input-wrapper--compact": "lc-SearchInput-module__search-input__input-wrapper--compact___d-GJ7",
  "search-input__input-wrapper--medium": "lc-SearchInput-module__search-input__input-wrapper--medium___VN8Dh",
  "search-input__input-wrapper--large": "lc-SearchInput-module__search-input__input-wrapper--large___ZwZ0o",
  "search-input__input-wrapper--crop": "lc-SearchInput-module__search-input__input-wrapper--crop___JA7J1"
}, _t = "search-input", no = `${_t}__input-wrapper`, fs = b.forwardRef(
  (p, c) => {
    var m = p, {
      isCollapsable: e,
      isDisabled: t,
      isLoading: r,
      placeholder: o = "Search ...",
      size: _ = "medium",
      value: l,
      className: i,
      cropOnBlur: n = !0,
      onChange: d
    } = m, s = U(m, [
      "isCollapsable",
      "isDisabled",
      "isLoading",
      "placeholder",
      "size",
      "value",
      "className",
      "cropOnBlur",
      "onChange"
    ]);
    const f = b.useRef(null);
    b.useImperativeHandle(c, () => f.current, [c]);
    const [g, y] = b.useState(!0), [x, S] = b.useState(!1), E = !!l && !t && !r, $ = e && !g && "true", w = u(
      i,
      Re[_t],
      Re[`${_t}--${_}`],
      x && Re[`${_t}--focused`],
      t && Re[`${_t}--disabled`],
      e && Re[`${_t}--collapsable`],
      e && Re[`${_t}--collapsable--${_}`],
      !g && Re[`${_t}--collapsable--open`]
    );
    b.useEffect(() => {
      e && l && y(!1);
    }, [e, l]);
    const N = (A) => {
      const D = A.currentTarget.value;
      d(D);
    }, k = () => {
      d("");
    }, C = () => {
      f.current && f.current.focus();
    }, I = () => {
      e && y(!1), S(!0);
    }, T = () => {
      e && !l && y(!0), S(!1);
    }, M = (A) => {
      A.key === se.enter && (A.preventDefault(), d(l));
    };
    return /* @__PURE__ */ h(
      "div",
      {
        "aria-expanded": $,
        role: "search",
        className: w,
        onClick: C,
        children: [
          /* @__PURE__ */ a(
            R,
            {
              className: u(
                Re[`${_t}__search-icon`],
                Re[`${_t}__search-icon--${_}`]
              ),
              source: El,
              disabled: t,
              kind: "primary"
            }
          ),
          /* @__PURE__ */ a(
            F,
            {
              as: "div",
              className: u(
                Re[no],
                Re[`${no}--${_}`],
                n && Re[`${no}--crop`]
              ),
              children: /* @__PURE__ */ a(
                "input",
                v({
                  role: "searchbox",
                  ref: f,
                  type: "text",
                  value: l,
                  placeholder: o,
                  onChange: N,
                  onBlur: T,
                  onFocus: I,
                  onKeyDown: M,
                  disabled: t
                }, s)
              )
            }
          ),
          E && /* @__PURE__ */ a(
            W,
            {
              "aria-label": "Clear search",
              title: "Clear search",
              className: Re[`${_t}__clear-icon`],
              onClick: k,
              icon: /* @__PURE__ */ a(R, { source: ct, kind: "primary" }),
              kind: "text",
              size: "compact"
            }
          ),
          r && /* @__PURE__ */ a("div", { className: Re[`${_t}__loader`], children: /* @__PURE__ */ a(Bo, { size: "small" }) })
        ]
      }
    );
  }
);
fs.displayName = "SearchInput";
const Va = {
  "selectable-card": "lc-SelectableCard-module__selectable-card___b2hXr",
  "selectable-card--thumbnail": "lc-SelectableCard-module__selectable-card--thumbnail___lS1aG",
  "selectable-card__select-indicator": "lc-SelectableCard-module__selectable-card__select-indicator___JalkO",
  "selectable-card--gallery": "lc-SelectableCard-module__selectable-card--gallery___0sJB1",
  "selectable-card--interactive": "lc-SelectableCard-module__selectable-card--interactive___r8N-q",
  "selectable-card--selected": "lc-SelectableCard-module__selectable-card--selected___StMaB",
  "selectable-card__select-indicator__checkbox": "lc-SelectableCard-module__selectable-card__select-indicator__checkbox___qoZSh"
}, Wa = "selectable-card", Oo = (d) => {
  var s = d, {
    children: e,
    className: t,
    kind: r = "interactive",
    selectionType: o,
    isSelected: _ = !1,
    onClick: l,
    style: i
  } = s, n = U(s, [
    "children",
    "className",
    "kind",
    "selectionType",
    "isSelected",
    "onClick",
    "style"
  ]);
  const c = u(
    Va[Wa],
    Va[`${Wa}--${r}`],
    {
      [Va[`${Wa}--selected`]]: _
    },
    t
  ), { handleInteractiveClick: p } = _i({ onClick: l });
  return /* @__PURE__ */ h(
    "div",
    B(v({
      "aria-selected": _,
      "aria-label": typeof e == "string" ? e : void 0,
      role: "button",
      tabIndex: 0,
      className: c,
      onClick: p,
      onKeyDown: (f) => {
        f.currentTarget === document.activeElement && (f.key === "Enter" || f.key === " " || f.key === "Spacebar" || f.key === "Space") && (f.preventDefault(), l == null || l());
      },
      style: i
    }, n), {
      children: [
        /* @__PURE__ */ a("div", { className: Va[`${Wa}__select-indicator`], children: o === "radio" ? /* @__PURE__ */ a(us, { tabIndex: -1, onClick: l, checked: _ }) : /* @__PURE__ */ a(
          zr,
          {
            tabIndex: -1,
            onClick: l,
            className: Va[`${Wa}__select-indicator__checkbox`],
            checked: _
          }
        ) }),
        e
      ]
    })
  );
}, Ka = {
  "thumbnail-selectable-card": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card___G2B0C",
  "thumbnail-selectable-card__icon": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__icon___GRN1c",
  "thumbnail-selectable-card__content": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content___-O6lf",
  "thumbnail-selectable-card__content__description": "lc-ThumbnailSelectableCard-module__thumbnail-selectable-card__content__description___b7-vQ"
}, Ya = "thumbnail-selectable-card", Wu = (i) => {
  var n = i, {
    label: e,
    description: t,
    icon: r,
    customElement: o,
    contentClassName: _
  } = n, l = U(n, [
    "label",
    "description",
    "icon",
    "customElement",
    "contentClassName"
  ]);
  return /* @__PURE__ */ a(Oo, B(v({}, l), { kind: "thumbnail", children: /* @__PURE__ */ h(
    "div",
    {
      role: "presentation",
      className: u(Ka[Ya], _),
      children: [
        !o && /* @__PURE__ */ h(Q, { children: [
          r && /* @__PURE__ */ a("div", { className: Ka[`${Ya}__icon`], children: r }),
          /* @__PURE__ */ h("div", { className: Ka[`${Ya}__content`], children: [
            /* @__PURE__ */ a(F, { as: "span", className: Ka[`${Ya}__content__label`], children: e }),
            /* @__PURE__ */ a(
              F,
              {
                size: "sm",
                as: "span",
                className: Ka[`${Ya}__content__description`],
                children: t
              }
            )
          ] })
        ] }),
        o
      ]
    }
  ) }));
}, co = {
  "gallery-selectable-card": "lc-GallerySelectableCard-module__gallery-selectable-card___z-d6f",
  "gallery-selectable-card--with-label": "lc-GallerySelectableCard-module__gallery-selectable-card--with-label___cXRfx",
  "gallery-selectable-card__label": "lc-GallerySelectableCard-module__gallery-selectable-card__label___XTehc"
}, so = "gallery-selectable-card", Ku = (i) => {
  var n = i, {
    label: e,
    icon: t,
    customElement: r,
    contentClassName: o,
    className: _
  } = n, l = U(n, [
    "label",
    "icon",
    "customElement",
    "contentClassName",
    "className"
  ]);
  return /* @__PURE__ */ a(
    Oo,
    B(v({}, l), {
      className: u(_, {
        [co[`${so}--with-label`]]: e
      }),
      kind: "gallery",
      children: /* @__PURE__ */ h(
        "div",
        {
          role: "presentation",
          className: u(co[so], o),
          children: [
            t && !r && t,
            r,
            e && /* @__PURE__ */ a(F, { as: "span", className: co[`${so}__label`], children: e })
          ]
        }
      )
    })
  );
}, bs = {
  "gallery-selectable-card": "lc-InteractiveSelectableCard-module__gallery-selectable-card___FkMyM",
  "gallery-selectable-card__label": "lc-InteractiveSelectableCard-module__gallery-selectable-card__label___2fKRM"
}, vs = "interactive-selectable-card", Yu = (o) => {
  var _ = o, {
    children: e,
    contentClassName: t
  } = _, r = U(_, [
    "children",
    "contentClassName"
  ]);
  return /* @__PURE__ */ a(Oo, B(v({}, r), { kind: "interactive", children: /* @__PURE__ */ a(
    "div",
    {
      role: "presentation",
      className: u(bs[vs], t),
      children: e
    }
  ) }));
}, J_ = {
  "grid-wrapper": "lc-InteractiveGrid-module__grid-wrapper___FnLIP",
  "grid-row": "lc-InteractiveGrid-module__grid-row___YsMbS",
  "grid-col": "lc-InteractiveGrid-module__grid-col___jDoA6"
}, ks = "grid-wrapper", Xu = ({
  children: e,
  className: t
}) => /* @__PURE__ */ a("div", { className: `${J_[ks]} ${t || ""}`, children: e }), Q_ = ({ children: e, className: t, baseClass: r, role: o = "presentation" }) => /* @__PURE__ */ a("div", { role: o, className: `${J_[r]} ${t || ""}`, children: e }), Zu = (e) => /* @__PURE__ */ a(Q_, B(v({}, e), { baseClass: "grid-row" })), ju = (e) => /* @__PURE__ */ a(Q_, B(v({}, e), { baseClass: "grid-col" })), ys = "lc-Skeleton-module__loading___fc1WK", oa = {
  "skeleton-wrapper": "lc-Skeleton-module__skeleton-wrapper___5N-1n",
  "skeleton-wrapper--vertical": "lc-Skeleton-module__skeleton-wrapper--vertical___0sU7e",
  "skeleton-avatar": "lc-Skeleton-module__skeleton-avatar___7-CDQ",
  "skeleton-avatar--square": "lc-Skeleton-module__skeleton-avatar--square___NlK0K",
  "skeleton-avatar--animated": "lc-Skeleton-module__skeleton-avatar--animated___iFXkb",
  loading: ys,
  "skeleton-text": "lc-Skeleton-module__skeleton-text___WnwUw",
  "skeleton-text--animated": "lc-Skeleton-module__skeleton-text--animated___Bnr3Z"
}, d_ = "skeleton-wrapper", Ju = (_) => {
  var l = _, { children: e, vertical: t, animated: r } = l, o = U(l, ["children", "vertical", "animated"]);
  const i = b.Children.map(e, (n) => b.isValidElement(n) ? b.cloneElement(n, {
    animated: r
  }) : n);
  return /* @__PURE__ */ a(
    "div",
    B(v({
      className: u(oa[`${d_}`], {
        [oa[`${d_}--vertical`]]: t
      })
    }, o), {
      children: i
    })
  );
}, uo = "skeleton-avatar", Qu = ({
  square: e = !1,
  size: t = 16,
  animated: r
}) => /* @__PURE__ */ a(
  "div",
  {
    className: u(oa[`${uo}`], {
      [oa[`${uo}--square`]]: e,
      [oa[`${uo}--animated`]]: r
    }),
    style: {
      width: t,
      height: t
    }
  }
), u_ = "skeleton-text", em = ({
  height: e = 13,
  width: t,
  animated: r
}) => /* @__PURE__ */ a(
  "div",
  {
    className: u(oa[`${u_}`], {
      [oa[`${u_}--animated`]]: r
    }),
    style: {
      height: e,
      width: t
    }
  }
), mo = {
  "status-badge": "lc-StatusBadge-module__status-badge___lygXF",
  "status-badge--3XS": "lc-StatusBadge-module__status-badge--3XS___A-lDu",
  "status-badge--2XS": "lc-StatusBadge-module__status-badge--2XS___7u4kB",
  "status-badge--XS": "lc-StatusBadge-module__status-badge--XS___M5fdN",
  "status-badge--SM": "lc-StatusBadge-module__status-badge--SM___How9K",
  "status-badge--MD": "lc-StatusBadge-module__status-badge--MD___tlaxX",
  "status-badge--LG": "lc-StatusBadge-module__status-badge--LG___2-7IC",
  "status-badge--XL": "lc-StatusBadge-module__status-badge--XL___m-MzF",
  "status-badge--2XL": "lc-StatusBadge-module__status-badge--2XL___lSyzS",
  "status-badge--3XL": "lc-StatusBadge-module__status-badge--3XL___LpjBZ",
  "status-badge--offline": "lc-StatusBadge-module__status-badge--offline___90IJN",
  "status-badge--accept": "lc-StatusBadge-module__status-badge--accept___UvRWg",
  "status-badge--not-accept": "lc-StatusBadge-module__status-badge--not-accept___bhNkL"
}, po = "status-badge", tm = (_) => {
  var l = _, {
    className: e,
    kind: t = "offline",
    size: r = "MD"
  } = l, o = U(l, [
    "className",
    "kind",
    "size"
  ]);
  const i = u(
    mo[po],
    mo[`${po}--${t}`],
    mo[`${po}--${r}`],
    e
  );
  return /* @__PURE__ */ a("span", v({ className: i }, o));
}, Cs = "lc-Switch-module__switch__input___-bYMW", ws = "lc-Switch-module__switch__container___dYb8a", $s = "lc-Switch-module__switch__track___3lNXx", Ns = "lc-Switch-module__switch__slider___NmDHK", Ss = "lc-Switch-module__switch__loader___Pbo1Q", xs = "lc-Switch-module__switch__icon___tCZTq", fe = {
  switch: "lc-Switch-module__switch___PKzsW",
  "switch__track--enabled": "lc-Switch-module__switch__track--enabled___Dwbmx",
  "switch__track--on": "lc-Switch-module__switch__track--on___7vdEj",
  "switch__track--off": "lc-Switch-module__switch__track--off___IAZA0",
  "switch--large": "lc-Switch-module__switch--large___dMF98",
  "switch--compact": "lc-Switch-module__switch--compact___T4bhh",
  "switch--medium": "lc-Switch-module__switch--medium___uruMu",
  "switch--focused": "lc-Switch-module__switch--focused___XADLL",
  switch__input: Cs,
  "switch__input--disabled": "lc-Switch-module__switch__input--disabled___c1vVD",
  switch__container: ws,
  switch__track: $s,
  "switch__container--focused": "lc-Switch-module__switch__container--focused___120ao",
  "switch__track--disabled": "lc-Switch-module__switch__track--disabled___pz3md",
  switch__slider: Ns,
  "switch__slider--large": "lc-Switch-module__switch__slider--large___0-Vky",
  "switch__slider--large--on": "lc-Switch-module__switch__slider--large--on___HXudz",
  "switch__slider--large--off": "lc-Switch-module__switch__slider--large--off___zPuP6",
  "switch__slider--compact": "lc-Switch-module__switch__slider--compact___GD-ov",
  "switch__slider--compact--on": "lc-Switch-module__switch__slider--compact--on___VhXTF",
  "switch__slider--compact--off": "lc-Switch-module__switch__slider--compact--off___a0WyG",
  "switch__slider--medium": "lc-Switch-module__switch__slider--medium___j3xMd",
  "switch__slider--medium--on": "lc-Switch-module__switch__slider--medium--on___WNNGh",
  "switch__slider--medium--off": "lc-Switch-module__switch__slider--medium--off___pkbCl",
  "switch__slider--disabled": "lc-Switch-module__switch__slider--disabled___6rrSU",
  switch__loader: Ss,
  "switch__loader--compact": "lc-Switch-module__switch__loader--compact___jKLak",
  "switch__loader--medium": "lc-Switch-module__switch__loader--medium___XpfaO",
  "switch__loader--large": "lc-Switch-module__switch__loader--large___NDgeg",
  switch__icon: xs
}, me = "switch", am = (p) => {
  var m = p, {
    className: e = "",
    defaultOn: t = !1,
    disabled: r = !1,
    name: o = me,
    on: _,
    onChange: l,
    size: i = "large",
    state: n = "regular",
    innerRef: d,
    ariaLabel: s
  } = m, c = U(m, [
    "className",
    "defaultOn",
    "disabled",
    "name",
    "on",
    "onChange",
    "size",
    "state",
    "innerRef",
    "ariaLabel"
  ]);
  const f = _ !== void 0, [g, y] = b.useState(
    () => f ? _ : t
  ), [x, S] = b.useState(!1), E = f ? _ : g, $ = n === "loading", w = n === "locked", N = i === "large" ? "small" : "xsmall", k = E ? "on" : "off", C = r || $ || w, I = C ? "disabled" : "enabled", T = u(
    fe[me],
    fe[`${me}--${i}`],
    {
      [fe[`${me}--focused`]]: x
    },
    e
  ), M = (A) => {
    l == null || l(A, !E), f || (A.stopPropagation(), y((D) => !D));
  };
  return /* @__PURE__ */ h("span", { className: T, children: [
    /* @__PURE__ */ a(
      "input",
      B(v({
        type: "checkbox",
        className: u(
          fe[`${me}__input`],
          fe[`${me}__input--${I}`]
        ),
        onChange: M,
        checked: E,
        name: o,
        ref: d,
        disabled: C,
        "aria-label": s
      }, c), {
        onFocus: () => S(!0),
        onBlur: () => S(!1)
      })
    ),
    /* @__PURE__ */ h(
      "span",
      {
        className: u(fe[`${me}__container`], {
          [fe[`${me}__container--focused`]]: x
        }),
        children: [
          /* @__PURE__ */ a(
            "span",
            {
              className: u(
                fe[`${me}__track`],
                fe[`${me}__track--${k}`],
                fe[`${me}__track--${I}`]
              )
            }
          ),
          /* @__PURE__ */ h(
            "span",
            {
              className: u(
                fe[`${me}__slider`],
                fe[`${me}__slider--${I}`],
                fe[`${me}__slider--${i}`],
                fe[`${me}__slider--${i}--${k}`]
              ),
              children: [
                $ && /* @__PURE__ */ a(
                  Bo,
                  {
                    "data-testid": "switch-loader",
                    className: u(
                      fe[`${me}__loader`],
                      fe[`${me}__loader--${i}`]
                    )
                  }
                ),
                w && /* @__PURE__ */ a(
                  R,
                  {
                    className: fe[`${me}__icon`],
                    "data-testid": "lock-icon",
                    size: N,
                    source: Tl,
                    kind: "primary"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, Es = "lc-Tab-module__tab___ShyYn", Ts = "lc-Tab-module__tab__count___7QKoz", Bs = "lc-Tab-module__tab__icon___eCD-d", Is = "lc-Tab-module__tab__badge___nwfVJ", Qt = {
  tab: Es,
  tab__count: Ts,
  "tab--compact": "lc-Tab-module__tab--compact___yetP5",
  "tab--medium": "lc-Tab-module__tab--medium___KhPsI",
  "tab--large": "lc-Tab-module__tab--large___3GE8k",
  tab__icon: Bs,
  tab__badge: Is,
  "tab--selected": "lc-Tab-module__tab--selected___vsPhT",
  "tab--disabled": "lc-Tab-module__tab--disabled___JPMHC"
}, ea = "tab", rm = (d) => {
  var s = d, {
    children: e,
    className: t,
    count: r,
    isSelected: o,
    asBadge: _,
    size: l = "medium",
    icon: i
  } = s, n = U(s, [
    "children",
    "className",
    "count",
    "isSelected",
    "asBadge",
    "size",
    "icon"
  ]);
  const { disabled: c } = n, p = r !== void 0 && !_, m = r !== void 0 && _;
  return /* @__PURE__ */ h(
    F,
    B(v({}, n), {
      as: n.href ? "a" : "button",
      "aria-selected": o,
      size: "md",
      bold: o,
      className: u(
        t,
        Qt[ea],
        Qt[`${ea}--${l}`],
        o && Qt[`${ea}--selected`],
        c && Qt[`${ea}--disabled`]
      ),
      children: [
        i && /* @__PURE__ */ a("div", { "data-testId": "icon", className: Qt[`${ea}__icon`], children: i }),
        e,
        p && /* @__PURE__ */ h(F, { as: "span", size: "md", className: Qt[`${ea}__count`], children: [
          "(",
          r,
          ")"
        ] }),
        m && /* @__PURE__ */ a(
          Dr,
          {
            "data-testid": "tab-badge",
            count: r,
            size: "compact",
            className: Qt[`${ea}__badge`]
          }
        )
      ]
    })
  );
}, As = "lc-TabsWrapper-module__tabs___rJby-", Ds = "lc-TabsWrapper-module__tabs__list___ylJuP", el = {
  tabs: As,
  tabs__list: Ds
}, tl = "tabs", om = ({ className: e, children: t }) => /* @__PURE__ */ a("div", { className: u(el[tl], e), children: t }), _m = ({ className: e, children: t }) => /* @__PURE__ */ a("div", { role: "tablist", className: u(el[`${tl}__list`], e), children: t }), Os = ({
  data: e,
  getRowId: t,
  selectedRows: r,
  onSelectionChange: o
}) => {
  const _ = vt(
    (n) => !!(r != null && r.has(n)),
    [r]
  ), l = vt(
    (n) => {
      const d = new Set(r || []);
      d.has(n) ? d.delete(n) : d.add(n), o == null || o(d);
    },
    [r, o]
  ), i = vt(() => {
    const n = new Set(e.map(t)), s = (r == null ? void 0 : r.size) === e.length ? /* @__PURE__ */ new Set() : n;
    o == null || o(s);
  }, [e, t, r, o]);
  return {
    isSelected: _,
    toggleRowSelection: l,
    toggleSelectAll: i,
    selectedCount: r == null ? void 0 : r.size
  };
}, Ps = "lc-TableRow-module__row___NrIRP", Fs = "lc-TableRow-module__table__header___eVCSg", Ms = "lc-TableRow-module__row__selected___8IvPR", go = {
  row: Ps,
  table__header: Fs,
  "row__select-cell": "lc-TableRow-module__row__select-cell___SecNT",
  row__selected: Ms
}, ho = "row", Rs = ({
  row: e,
  columns: t,
  columnWidths: r,
  selectable: o,
  isSelected: _,
  toggleRowSelection: l,
  rowId: i
}) => /* @__PURE__ */ h(
  "tr",
  {
    className: u(
      go[ho],
      _(i) ? go[`${ho}__selected`] : void 0
    ),
    children: [
      o && /* @__PURE__ */ a(
        "td",
        {
          role: "cell",
          "aria-selected": _(i),
          className: go[`${ho}__select-cell`],
          children: /* @__PURE__ */ a(
            zr,
            {
              checked: _(i),
              onChange: () => l(i)
            }
          )
        }
      ),
      t.map((n, d) => /* @__PURE__ */ a(
        "td",
        {
          style: {
            width: r[d] ? `${r[d]}px` : "auto"
          },
          role: "cell",
          "data-column": String(n.key),
          children: /* @__PURE__ */ a(F, { size: "md", noMargin: !0, children: e[n.key] })
        },
        String(n.key)
      ))
    ]
  }
), Gs = ({
  data: e,
  columns: t,
  getRowId: r,
  columnWidths: o,
  selectable: _,
  isSelected: l,
  toggleRowSelection: i
}) => /* @__PURE__ */ a("tbody", { role: "rowgroup", children: e.map((n) => {
  const d = r(n);
  return /* @__PURE__ */ a(
    Rs,
    {
      row: n,
      columns: t,
      columnWidths: o,
      selectable: _,
      isSelected: l,
      toggleRowSelection: i,
      rowId: r(n)
    },
    d
  );
}) });
var Le = /* @__PURE__ */ ((e) => (e.Ascending = "asc", e.Descending = "desc", e.None = "none", e))(Le || {});
const Us = "lc-TableHeader-module__header___JDLIB", Ls = "lc-TableHeader-module__header__cell___aYvzx", qs = "lc-TableHeader-module__header__hiddenIcon___NNtMw", Hs = "lc-TableHeader-module__header__resizer___h-Al0", zs = "lc-TableHeader-module__header__content___LRMNn", ta = {
  header: Us,
  header__cell: Ls,
  "header__cell--hoverDisabled": "lc-TableHeader-module__header__cell--hoverDisabled___PaQRH",
  header__hiddenIcon: qs,
  header__resizer: Hs,
  header__content: zs,
  "header__select-cell": "lc-TableHeader-module__header__select-cell___H9qHi",
  "header--selectable": "lc-TableHeader-module__header--selectable___yPgDs"
}, _a = "header", Vs = `${_a}__cell`, Ws = `${_a}__resizer`, Ks = `${_a}__content`, Ys = `${_a}__hiddenIcon`;
function Xs(e, t, r, o) {
  return e.key === t && e.direction !== Le.None && r ? /* @__PURE__ */ a(
    R,
    {
      source: e.direction === Le.Ascending ? Bl : Il,
      kind: "primary"
    }
  ) : o && r ? /* @__PURE__ */ a(R, { source: Al, kind: "subtle" }) : /* @__PURE__ */ a(R, { source: Dl, className: ta[Ys] });
}
const Zs = ({
  columns: e,
  sortConfig: t,
  handleSort: r,
  resizable: o,
  handleMouseDown: _,
  columnRefs: l,
  selectable: i,
  hoveredColumnIndex: n,
  setHoveredColumnIndex: d,
  selectedCount: s,
  dataLength: c,
  toggleSelectAll: p
}) => /* @__PURE__ */ a("thead", { children: /* @__PURE__ */ h(
  "tr",
  {
    className: u(ta[_a], {
      [ta[`${_a}--selectable`]]: i && !!s
    }),
    children: [
      i && /* @__PURE__ */ a(
        "th",
        {
          className: ta[`${_a}__select-cell`],
          onClick: p,
          children: /* @__PURE__ */ a(
            zr,
            {
              checked: s === c,
              indeterminate: s !== void 0 && s > 0 && s < (c || 0)
            }
          )
        }
      ),
      e.map((m, f) => {
        var g;
        return /* @__PURE__ */ a(
          "th",
          {
            ref: (y) => {
              l.current && (l.current[f] = y);
            },
            className: u({
              [ta[`${Vs}--hoverDisabled`]]: !m.sortable
            }),
            onMouseEnter: () => d(f),
            onMouseLeave: () => d(null),
            role: "columnheader",
            children: /* @__PURE__ */ h(
              "span",
              {
                onClick: () => {
                  m.sortable && r(m.key);
                },
                className: ta[Ks],
                children: [
                  /* @__PURE__ */ a(F, { size: "sm", bold: !0, noMargin: !0, children: m.header }),
                  Xs(
                    t,
                    m.key,
                    (g = m.sortable) != null ? g : !1,
                    n === f
                  ),
                  o && /* @__PURE__ */ a(
                    "span",
                    {
                      className: ta[Ws],
                      onMouseDown: (y) => _(f, y),
                      role: "button",
                      "aria-label": "resize"
                    }
                  )
                ]
              }
            )
          },
          String(m.key)
        );
      })
    ]
  }
) }), js = "lc-Table-module__table___-ZPCW", Js = "lc-Table-module__table__cell___8rtqj", Qs = "lc-Table-module__table__selected___f9beX", ed = "lc-Table-module__table__selected__divider___VlK4B", td = "lc-Table-module__table__selected__checkbox___4yJlB", ad = "lc-Table-module__table__selected__content___9LKcS", It = {
  table: js,
  "table--small": "lc-Table-module__table--small___DuQa-",
  "table--medium": "lc-Table-module__table--medium___pe9rZ",
  "table--large": "lc-Table-module__table--large___8PMkf",
  "table--pinned_header": "lc-Table-module__table--pinned_header___5SrTn",
  "table--pinned_header--selectable": "lc-Table-module__table--pinned_header--selectable___R5ZXX",
  "table--has-selected": "lc-Table-module__table--has-selected___U7gSR",
  "table--pinned_leftColumn": "lc-Table-module__table--pinned_leftColumn___GWfss",
  table__cell: Js,
  table__selected: Qs,
  "table__selected--visible": "lc-Table-module__table__selected--visible___RTjMS",
  "table__selected--hidden": "lc-Table-module__table__selected--hidden___Wu9PE",
  table__selected__divider: ed,
  table__selected__checkbox: td,
  table__selected__content: ad,
  "table--stripped_rows": "lc-Table-module__table--stripped_rows___ALUEi",
  "table--stripped_columns": "lc-Table-module__table--stripped_columns___JQlQW"
}, aa = "table", xr = `${aa}__selected`, lm = ({
  data: e,
  columns: t,
  stripped: r,
  size: o = "medium",
  pin: _,
  selectable: l,
  getRowId: i,
  resizable: n,
  selectedRows: d,
  onSelectionChange: s,
  rowSelectionMessage: c,
  rowActions: p,
  testId: m
}) => {
  const f = b.useRef([]), [g, y] = b.useState(null), { isSelected: x, toggleRowSelection: S, toggleSelectAll: E, selectedCount: $ } = Os({
    data: e,
    getRowId: i,
    selectedRows: d,
    onSelectionChange: s
  }), [w, N] = b.useState({
    key: null,
    direction: Le.None
  }), [k, C] = b.useState(Array(t.length).fill(void 0)), I = (A, D) => {
    D.preventDefault();
    const G = D.clientX, P = k[A] || D.currentTarget.offsetWidth, L = k[A + 1] || 0, O = 1.05, q = (te) => {
      const ye = (te.clientX - G) * O;
      C((ge) => {
        const K = [...ge], Z = Math.max(50, P + ye), st = Math.max(50, L - ye);
        return K[A] = Z, A + 1 < K.length && (K[A + 1] = st), K;
      });
    }, Y = () => {
      document.removeEventListener("mousemove", q), document.removeEventListener("mouseup", Y);
    };
    document.addEventListener("mousemove", q), document.addEventListener("mouseup", Y);
  }, T = (A) => {
    const D = t.find((G) => G.key === A);
    !D || D.sortable === !1 || N((G) => {
      if (G.key === A) {
        let P;
        switch (G.direction) {
          case Le.None:
            P = Le.Ascending;
            break;
          case Le.Ascending:
            P = Le.Descending;
            break;
          default:
            P = Le.None;
        }
        return {
          key: P === Le.None ? null : A,
          direction: P
        };
      } else
        return { key: A, direction: Le.Ascending };
    });
  }, M = b.useMemo(() => {
    if (!w.key || w.direction === Le.None)
      return e;
    const A = t.find((D) => D.key === w.key);
    return A ? [...e].sort((D, G) => {
      const P = A.sortable ? A.sortValue(D) : D[w.key], L = A.sortable ? A.sortValue(G) : G[w.key];
      return P < L ? w.direction === Le.Ascending ? -1 : 1 : P > L ? w.direction === Le.Ascending ? 1 : -1 : 0;
    }) : e;
  }, [e, w, t]);
  return b.useEffect(() => {
    const A = f.current.map(
      (D) => (D == null ? void 0 : D.offsetWidth) || 0
    );
    C(A);
  }, []), /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ h(
      "div",
      {
        className: u(It[`${xr}`], {
          [It[`${xr}--visible`]]: l && !!$,
          [It[`${xr}--hidden`]]: !l
        }),
        children: [
          /* @__PURE__ */ a("div", { className: It[`${xr}__content`], children: c || /* @__PURE__ */ h(F, { noMargin: !0, bold: !0, size: "sm", children: [
            $,
            " selected"
          ] }) }),
          /* @__PURE__ */ a("div", { children: p })
        ]
      }
    ),
    /* @__PURE__ */ h(
      "table",
      {
        className: u(
          It[`${aa}`],
          It[`${aa}--${o}`],
          It[`${aa}--pinned_${_}`],
          l && It[`${aa}--pinned_header--selectable`],
          l && !!$ && It[`${aa}--has-selected`],
          It[`${aa}--stripped_${r}`]
        ),
        "data-testid": m,
        children: [
          /* @__PURE__ */ a(
            Zs,
            {
              columns: t,
              sortConfig: w,
              handleSort: T,
              resizable: n,
              handleMouseDown: I,
              columnRefs: f,
              selectable: l,
              hoveredColumnIndex: g,
              setHoveredColumnIndex: y,
              selectedCount: $,
              dataLength: e.length,
              toggleSelectAll: E
            }
          ),
          /* @__PURE__ */ a(
            Gs,
            {
              data: M,
              columns: t,
              getRowId: i,
              columnWidths: k,
              selectable: l,
              isSelected: x,
              toggleRowSelection: S
            }
          )
        ]
      }
    )
  ] });
}, ja = {
  "tag-input": "lc-TagInput-module__tag-input___zQKuG",
  "tag-input--error": "lc-TagInput-module__tag-input--error___0iuR-",
  "tag-input__input": "lc-TagInput-module__tag-input__input___skuNT",
  "tag-input__input--medium": "lc-TagInput-module__tag-input__input--medium___9ifYO",
  "tag-input__input--large": "lc-TagInput-module__tag-input__input--large___0xBUb",
  "tag-input__tag__content": "lc-TagInput-module__tag-input__tag__content___glcu0"
}, rd = ({
  className: e = "",
  innerEditableRef: t,
  inputRef: r,
  change: o,
  remove: _,
  value: l
}) => {
  const [i, n] = b.useState(!1), d = () => t.current, s = () => {
    const g = d();
    return g ? g.innerText : "";
  }, c = () => {
    r && r.current && r.current.focus();
  };
  return /* @__PURE__ */ a(
    "div",
    {
      ref: t,
      className: e,
      contentEditable: !0,
      onPaste: (g) => {
        g.preventDefault();
        const y = g.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", !1, Lo(y));
      },
      onBlur: () => {
        const g = d();
        if (!(i || !g)) {
          if (g.innerText === "") {
            _();
            return;
          }
          o(g.innerText);
        }
      },
      onKeyDown: (g) => {
        if (g.key === se.enter) {
          g.preventDefault(), c();
          return;
        }
        g.key === se.backspace && s() === "" && (n(!0), _(), c());
      },
      dangerouslySetInnerHTML: { __html: Lo(l) }
    }
  );
}, od = "tag-input__tag", m_ = ({
  children: e,
  index: t,
  remove: r,
  validator: o,
  inputRef: _,
  update: l,
  size: i,
  tagProps: n
}) => {
  const d = b.useMemo(() => o !== void 0 ? o(e) : !0, [e, o]), s = b.useRef(null), c = () => r(t), p = () => d ? n ? n.kind : "default" : "error";
  return /* @__PURE__ */ a(q_, B(v({ size: i }, n), { kind: p(), onRemove: c, children: /* @__PURE__ */ a(
    rd,
    {
      value: e,
      inputRef: _,
      innerEditableRef: s,
      className: ja[`${od}__content`],
      change: (m) => l(t, m),
      remove: c,
      validator: o
    }
  ) }));
}, Er = "tag-input", _d = [
  se.enter,
  se.spacebar,
  se.tab,
  se.semicolon,
  se.comma
], ld = [se.backspace, se.delete], id = (g) => {
  var y = g, {
    id: e,
    tags: t,
    onChange: r,
    validator: o,
    error: _,
    placeholder: l,
    size: i = "medium",
    className: n,
    inputClassName: d,
    onBlur: s,
    addOnBlur: c = !0,
    readOnly: p,
    noDataFallbackText: m = "No data"
  } = y, f = U(y, [
    "id",
    "tags",
    "onChange",
    "validator",
    "error",
    "placeholder",
    "size",
    "className",
    "inputClassName",
    "onBlur",
    "addOnBlur",
    "readOnly",
    "noDataFallbackText"
  ]);
  const x = u(
    ja[Er],
    {
      [ja[`${Er}--error`]]: _
    },
    n
  ), S = u(
    d,
    ja[`${Er}__input`],
    ja[`${Er}__input--${i}`]
  ), [E, $] = b.useState(""), w = b.useRef(null), { readOnly: N } = At(), k = N || p, C = (O) => {
    O.trim() !== "" && (r([...t || [], O]), $(""));
  }, I = (O) => {
    const q = [...t || []];
    q.splice(O, 1), r(q);
  }, T = (O) => $(O.target.value), M = (O) => {
    if (_d.includes(O.key)) {
      if (O.preventDefault(), E === "")
        return;
      C(E);
    } else if (ld.includes(O.key)) {
      if (E !== "" || !(t != null && t.length))
        return;
      I(t.length - 1);
    }
  }, A = (O) => {
    c && C(E), s == null || s(O);
  }, D = (O, q) => {
    const Y = [...t || []];
    Y.reduce(
      (ye, ge, K) => ye + (ge === q && K !== O ? 1 : 0),
      0
    ) > 0 ? Y.splice(O, 1) : Y[O] = q, r(Y);
  }, G = (O) => {
    O.preventDefault();
    const Y = O.clipboardData.getData("text/plain").split(/[\s,;\n]+/);
    r([...t || [], ...Y]);
  }, P = (O) => typeof O == "string" ? O : O.value || (typeof O.children == "string" ? O.children : "");
  if (k)
    return /* @__PURE__ */ a(
      Na,
      {
        value: t == null ? void 0 : t.filter(Boolean).map(P).join(", "),
        noDataFallbackText: m
      }
    );
  const L = (O, q) => typeof O == "string" ? /* @__PURE__ */ a(
    m_,
    {
      index: q,
      update: D,
      remove: I,
      inputRef: w,
      validator: o,
      size: i,
      children: O
    },
    `${q}${O}`
  ) : /* @__PURE__ */ a(
    m_,
    {
      index: q,
      update: D,
      remove: I,
      inputRef: w,
      validator: o,
      size: i,
      tagProps: O,
      children: O.value || O.children
    },
    `${q}${O.children}`
  );
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ h(F, { as: "div", className: x, children: [
      t == null ? void 0 : t.map(L),
      /* @__PURE__ */ a(
        "input",
        B(v({}, f), {
          id: e,
          ref: w,
          className: S,
          placeholder: l,
          value: E,
          onChange: T,
          onKeyDown: M,
          onPaste: G,
          onBlur: A
        })
      )
    ] }),
    _ && /* @__PURE__ */ a(Ao, { children: _ })
  ] });
}, nd = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/i, cd = "name@company.com", sd = (e) => nd.test(e), im = (r) => {
  var o = r, {
    placeholder: e = cd
  } = o, t = U(o, [
    "placeholder"
  ]);
  return /* @__PURE__ */ a(id, B(v({}, t), { placeholder: e, validator: sd }));
}, dd = "lc-Toast-module__toast___ngbBR", ud = "lc-Toast-module__toast__content___XGt2m", md = "lc-Toast-module__toast__actions___iFshW", pd = "lc-Toast-module__toast__actions__button___sQIbQ", ke = {
  toast: dd,
  toast__content: ud,
  toast__actions: md,
  toast__actions__button: pd,
  "toast__actions__button--success": "lc-Toast-module__toast__actions__button--success___p53MR",
  "toast__actions__button--warning": "lc-Toast-module__toast__actions__button--warning___fCMO5",
  "toast__actions__button--error": "lc-Toast-module__toast__actions__button--error___hct1w",
  "toast__actions__button--info": "lc-Toast-module__toast__actions__button--info___KLzoG",
  "toast__actions--custom": "lc-Toast-module__toast__actions--custom___Lao00",
  "toast--success": "lc-Toast-module__toast--success___AcCed",
  "toast--warning": "lc-Toast-module__toast--warning___RsGqU",
  "toast--error": "lc-Toast-module__toast--error___a7RTS",
  "toast--info": "lc-Toast-module__toast--info___9t8Za",
  "toast-wrapper": "lc-Toast-module__toast-wrapper___jVb0j",
  "toast-wrapper--fixed": "lc-Toast-module__toast-wrapper--fixed___Wo3QO",
  "toast-wrapper--block": "lc-Toast-module__toast-wrapper--block___LNWD0",
  "toast-wrapper--horizontal-center": "lc-Toast-module__toast-wrapper--horizontal-center___yR1at",
  "toast-wrapper--horizontal-left": "lc-Toast-module__toast-wrapper--horizontal-left___CY-Z-",
  "toast-wrapper--horizontal-right": "lc-Toast-module__toast-wrapper--horizontal-right___f7ts5",
  "toast-wrapper--vertical-top": "lc-Toast-module__toast-wrapper--vertical-top___-8YHw",
  "toast-appear--slide": "lc-Toast-module__toast-appear--slide___vNvCV",
  "toast-appear-active--slide": "lc-Toast-module__toast-appear-active--slide___ROIEb",
  "toast-exit--slide": "lc-Toast-module__toast-exit--slide___DVOQp",
  "toast-exit-active--slide": "lc-Toast-module__toast-exit-active--slide___rBWPS",
  "toast-wrapper--vertical-bottom": "lc-Toast-module__toast-wrapper--vertical-bottom___rihzw",
  "toast-appear--fade": "lc-Toast-module__toast-appear--fade___AcODR",
  "toast-appear-active--fade": "lc-Toast-module__toast-appear-active--fade___Z39eu",
  "toast-exit--fade": "lc-Toast-module__toast-exit--fade___1t0Qp",
  "toast-exit-active--fade": "lc-Toast-module__toast-exit-active--fade___UK5Kw"
}, gd = {
  success: {
    source: So
  },
  warning: {
    source: b_
  },
  error: {
    source: v_
  },
  info: {
    source: Ir
  }
}, Zt = "toast", hd = (n) => {
  var d = n, {
    action: e,
    className: t,
    children: r,
    removable: o,
    kind: _ = "info",
    onClose: l
  } = d, i = U(d, [
    "action",
    "className",
    "children",
    "removable",
    "kind",
    "onClose"
  ]);
  const s = u(
    ke[Zt],
    ke[`${Zt}--${_}`],
    t
  ), c = typeof r == "string", p = (m) => m && m.closesOnClick && l ? (m.onClick(), l()) : m.onClick();
  return /* @__PURE__ */ h("div", B(v({ className: s }, i), { children: [
    /* @__PURE__ */ a("div", { className: ke[`${Zt}__icon`], children: /* @__PURE__ */ a(R, B(v({}, gd[_]), { size: "medium" })) }),
    /* @__PURE__ */ a("div", { className: ke[`${Zt}__content`], children: c ? /* @__PURE__ */ a(F, { as: "div", children: r }) : r }),
    (e || o) && /* @__PURE__ */ h("div", { className: ke[`${Zt}__actions`], children: [
      e && /* @__PURE__ */ a(
        W,
        {
          className: ke[`${Zt}__actions--custom`],
          kind: "text",
          size: "compact",
          onClick: () => p(e),
          children: e.label
        }
      ),
      o && /* @__PURE__ */ a(
        "button",
        {
          className: u(
            ke[`${Zt}__actions__button`],
            ke[`${Zt}__actions__button--${_}`]
          ),
          "aria-label": "Close toast",
          onClick: l,
          children: /* @__PURE__ */ a(R, { source: ct, size: "medium" })
        }
      )
    ] })
  ] }));
}, fd = 200, Xa = "toast-wrapper", nm = ({
  className: e,
  toasts: t = [],
  fixed: r = !0,
  block: o = !1,
  animationType: _ = "slide",
  verticalPosition: l = "top",
  horizontalPosition: i = "center"
}) => {
  const n = u(
    ke[Xa],
    {
      [ke[`${Xa}--fixed`]]: r,
      [ke[`${Xa}--block`]]: !r && o,
      [ke[`${Xa}--horizontal-${i}`]]: i,
      [ke[`${Xa}--vertical-${l}`]]: l
    },
    e
  );
  return /* @__PURE__ */ a("div", { className: n, children: /* @__PURE__ */ a(N_, { component: null, children: t.map(({ id: d, kind: s, content: c, removable: p, action: m, onClose: f }) => /* @__PURE__ */ a(
    S_,
    {
      classNames: {
        enter: ke[`toast-appear--${_}`],
        enterActive: ke[`toast-appear-active--${_}`],
        exit: ke[`toast-exit--${_}`],
        exitActive: ke[`toast-exit-active--${_}`]
      },
      timeout: fd,
      children: /* @__PURE__ */ a(
        hd,
        {
          kind: s,
          onClose: f,
          removable: p,
          action: m,
          children: c
        }
      )
    },
    d
  )) }) });
}, bd = "lc-Textarea-module__textarea___yE6jp", Tr = {
  textarea: bd,
  "textarea--focused": "lc-Textarea-module__textarea--focused___YnB5S",
  "textarea--disabled": "lc-Textarea-module__textarea--disabled___zZJAq",
  "textarea--error": "lc-Textarea-module__textarea--error___n-fD5"
}, Br = "textarea", cm = b.forwardRef(
  (l, _) => {
    var i = l, { className: e, noDataFallbackText: t = "No data", error: r } = i, o = U(i, ["className", "noDataFallbackText", "error"]);
    var S;
    const { disabled: n, onBlur: d, onFocus: s } = o, { readOnly: c } = At(), p = c || o.readOnly, [m, f] = b.useState(!1), g = u(e, Tr[Br], {
      [Tr[`${Br}--disabled`]]: n,
      [Tr[`${Br}--focused`]]: m,
      [Tr[`${Br}--error`]]: r
    }), y = (E) => {
      f(!1), d == null || d(E);
    }, x = (E) => {
      f(!0), s == null || s(E);
    };
    return p ? /* @__PURE__ */ a(
      Na,
      {
        value: (S = o == null ? void 0 : o.value) == null ? void 0 : S.toString(),
        noDataFallbackText: t
      }
    ) : /* @__PURE__ */ a(F, { as: "div", className: g, children: /* @__PURE__ */ a(
      "textarea",
      B(v({}, o), {
        ref: _,
        onFocus: x,
        onBlur: y
      })
    ) });
  }
), vd = {
  "update-badge": "lc-UpdateBadge-module__update-badge___heZyU"
}, kd = "update-badge", sm = () => /* @__PURE__ */ a("span", { className: vd[kd] }), yd = "data:image/svg+xml,%3csvg%20width='40'%20height='43'%20viewBox='0%200%2040%2043'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20filter='url(%23filter0_d_2511_27812)'%3e%3cpath%20d='M12.1399%2028.6143L20.0002%2010.6475L27.8604%2028.6143L20.0002%2025.3255L12.1399%2028.6143Z'%20fill='%23050505'/%3e%3cpath%20d='M20.9164%2010.2467C20.7572%209.88266%2020.3976%209.64746%2020.0002%209.64746C19.6029%209.64746%2019.2433%209.88266%2019.0841%2010.2466L11.2237%2028.2134C11.0599%2028.5879%2011.1404%2029.0243%2011.4271%2029.3156C11.7138%2029.607%2012.1488%2029.6945%2012.5259%2029.5368L20.0002%2026.4095L27.4744%2029.5368C27.8514%2029.6945%2028.2865%2029.607%2028.5731%2029.3156C28.8598%2029.0243%2028.9403%2028.5879%2028.7765%2028.2135L20.9164%2010.2467Z'%20stroke='url(%23paint0_linear_2511_27812)'%20stroke-width='2'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_2511_27812'%20x='0.139893'%20y='0.647461'%20width='39.7205'%20height='41.9668'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='2'/%3e%3cfeGaussianBlur%20stdDeviation='5'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_2511_27812'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_2511_27812'%20result='shape'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear_2511_27812'%20x1='19'%20y1='37'%20x2='19.9864'%20y2='9.0268'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20offset='0.318907'%20stop-color='%23CE97FE'/%3e%3cstop%20offset='0.456699'%20stop-color='%237000FF'/%3e%3cstop%20offset='0.690444'%20stop-color='%2300B3FF'/%3e%3cstop%20offset='0.955729'%20stop-color='white'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";
class Cd {
  constructor(t, r) {
    eo(this, "element");
    eo(this, "padding");
    this.element = t, this.padding = r;
  }
  addPadding(t) {
    const r = Math.ceil(t.left) - this.padding, o = Math.ceil(t.top) - this.padding, _ = Math.ceil(t.width) + 2 * this.padding, l = Math.ceil(t.height) + 2 * this.padding, i = o, n = r, d = i + l, s = n + _;
    return {
      x: r,
      y: o,
      width: _,
      height: l,
      top: i,
      left: n,
      bottom: d,
      right: s
    };
  }
  getBoundingClientRect() {
    return this.addPadding(this.element.getBoundingClientRect());
  }
  get clientWidth() {
    return this.getBoundingClientRect().width;
  }
  get clientHeight() {
    return this.getBoundingClientRect().height;
  }
}
const gt = {
  "user-guide__overlay": "lc-UserGuide-module__user-guide__overlay___xc8t9",
  "fade-in": "lc-UserGuide-module__fade-in___KEPPX",
  "user-guide__overlay__content": "lc-UserGuide-module__user-guide__overlay__content___Yu-6p",
  "user-guide__floating": "lc-UserGuide-module__user-guide__floating___RgxA2",
  "user-guide__floating--fast1": "lc-UserGuide-module__user-guide__floating--fast1___atd8C",
  "user-guide__floating--fast2": "lc-UserGuide-module__user-guide__floating--fast2___9zmT1",
  "user-guide__floating--moderate1": "lc-UserGuide-module__user-guide__floating--moderate1___4ZyOo",
  "user-guide__floating--moderate2": "lc-UserGuide-module__user-guide__floating--moderate2___-21Qx",
  "user-guide__guide": "lc-UserGuide-module__user-guide__guide___jCOMd",
  "user-guide__guide--right-start": "lc-UserGuide-module__user-guide__guide--right-start___dL15C",
  "user-guide__guide--left-start": "lc-UserGuide-module__user-guide__guide--left-start___d0zgg",
  "user-guide__guide--right": "lc-UserGuide-module__user-guide__guide--right___l-xa1",
  "user-guide__guide--left": "lc-UserGuide-module__user-guide__guide--left___b37DE",
  "user-guide__guide--right-end": "lc-UserGuide-module__user-guide__guide--right-end___ZrcKz",
  "user-guide__guide--left-end": "lc-UserGuide-module__user-guide__guide--left-end___P2R4X",
  "user-guide__guide--bottom-start": "lc-UserGuide-module__user-guide__guide--bottom-start___2nDLB",
  "user-guide__guide--top-start": "lc-UserGuide-module__user-guide__guide--top-start___dVZk-",
  "user-guide__guide--bottom": "lc-UserGuide-module__user-guide__guide--bottom___xKUf7",
  "user-guide__guide--top": "lc-UserGuide-module__user-guide__guide--top___VyXt3",
  "user-guide__guide--bottom-end": "lc-UserGuide-module__user-guide__guide--bottom-end___Sb3iU",
  "user-guide__guide--top-end": "lc-UserGuide-module__user-guide__guide--top-end___8BFCP",
  "user-guide__guide__arrow": "lc-UserGuide-module__user-guide__guide__arrow___Q5eJf",
  "user-guide__guide__arrow--fast1": "lc-UserGuide-module__user-guide__guide__arrow--fast1___p2D2X",
  "user-guide__guide__arrow--fast2": "lc-UserGuide-module__user-guide__guide__arrow--fast2___0uHUD",
  "user-guide__guide__arrow--moderate1": "lc-UserGuide-module__user-guide__guide__arrow--moderate1___5HE6Z",
  "user-guide__guide__arrow--moderate2": "lc-UserGuide-module__user-guide__guide__arrow--moderate2___jc9X8",
  "user-guide__guide__arrow--right-start": "lc-UserGuide-module__user-guide__guide__arrow--right-start___-uKZa",
  "user-guide__guide__arrow--right": "lc-UserGuide-module__user-guide__guide__arrow--right___gk-Jy",
  "user-guide__guide__arrow--right-end": "lc-UserGuide-module__user-guide__guide__arrow--right-end___FivLG",
  "user-guide__guide__arrow--bottom-start": "lc-UserGuide-module__user-guide__guide__arrow--bottom-start___RgKv9",
  "user-guide__guide__arrow--bottom": "lc-UserGuide-module__user-guide__guide__arrow--bottom___biAvs",
  "user-guide__guide__arrow--bottom-end": "lc-UserGuide-module__user-guide__guide__arrow--bottom-end___-UTZt",
  "user-guide__guide__arrow--top-start": "lc-UserGuide-module__user-guide__guide__arrow--top-start___suNzB",
  "user-guide__guide__arrow--top": "lc-UserGuide-module__user-guide__guide__arrow--top___2Jhvm",
  "user-guide__guide__arrow--top-end": "lc-UserGuide-module__user-guide__guide__arrow--top-end___flgo3",
  "user-guide__guide__arrow--left-start": "lc-UserGuide-module__user-guide__guide__arrow--left-start___wsidk",
  "user-guide__guide__arrow--left": "lc-UserGuide-module__user-guide__guide__arrow--left___44rSO",
  "user-guide__guide__arrow--left-end": "lc-UserGuide-module__user-guide__guide__arrow--left-end___SkNP2",
  "user-guide__guide__content": "lc-UserGuide-module__user-guide__guide__content___zlQji",
  "user-guide__guide__content--right-start": "lc-UserGuide-module__user-guide__guide__content--right-start___O1mf7",
  "fade-in-right-start": "lc-UserGuide-module__fade-in-right-start___n3frf",
  "user-guide__guide__content--right": "lc-UserGuide-module__user-guide__guide__content--right___G8NhS",
  "fade-in-right": "lc-UserGuide-module__fade-in-right___BBHBW",
  "user-guide__guide__content--right-end": "lc-UserGuide-module__user-guide__guide__content--right-end___1SSSy",
  "fade-in-right-end": "lc-UserGuide-module__fade-in-right-end___ETdwQ",
  "user-guide__guide__content--left-start": "lc-UserGuide-module__user-guide__guide__content--left-start___oCXn1",
  "fade-in-left-start": "lc-UserGuide-module__fade-in-left-start___8ggIA",
  "user-guide__guide__content--left": "lc-UserGuide-module__user-guide__guide__content--left___fgI-F",
  "fade-in-left": "lc-UserGuide-module__fade-in-left___hg0J0",
  "user-guide__guide__content--left-end": "lc-UserGuide-module__user-guide__guide__content--left-end___bR-YA",
  "fade-in-left-end": "lc-UserGuide-module__fade-in-left-end___Ui4wF",
  "user-guide__guide__content--top-start": "lc-UserGuide-module__user-guide__guide__content--top-start___zEKyj",
  "fade-in-top-start": "lc-UserGuide-module__fade-in-top-start___Ha6DR",
  "user-guide__guide__content--top": "lc-UserGuide-module__user-guide__guide__content--top___IsroR",
  "fade-in-top": "lc-UserGuide-module__fade-in-top___rYKUp",
  "user-guide__guide__content--top-end": "lc-UserGuide-module__user-guide__guide__content--top-end___dsuZm",
  "fade-in-top-end": "lc-UserGuide-module__fade-in-top-end___n2H6-",
  "user-guide__guide__content--bottom-start": "lc-UserGuide-module__user-guide__guide__content--bottom-start___o7-Uf",
  "fade-in-bottom-start": "lc-UserGuide-module__fade-in-bottom-start___tPQd1",
  "user-guide__guide__content--bottom": "lc-UserGuide-module__user-guide__guide__content--bottom___2gxXf",
  "fade-in-bottom": "lc-UserGuide-module__fade-in-bottom___2nyvW",
  "user-guide__guide__content--bottom-end": "lc-UserGuide-module__user-guide__guide__content--bottom-end___nT-g2",
  "fade-in-bottom-end": "lc-UserGuide-module__fade-in-bottom-end___89qmL",
  "user-guide__cursor": "lc-UserGuide-module__user-guide__cursor___9IuMJ",
  "user-guide__cursor--bottom": "lc-UserGuide-module__user-guide__cursor--bottom___jYXJ1",
  "user-guide__cursor--left": "lc-UserGuide-module__user-guide__cursor--left___h0ToJ",
  "user-guide__cursor--right": "lc-UserGuide-module__user-guide__cursor--right___Wc-yj"
}, ht = "user-guide", p_ = (e, t = 0) => new Cd(e, t), dm = ({
  className: e,
  children: t,
  cursorPosition: r = "bottom-start",
  cursorTiming: o = "fast2",
  parentElementName: _,
  isVisible: l = !1,
  elementClassName: i,
  zIndex: n,
  isFirstStep: d,
  isLastStep: s
}) => {
  const [c, p] = ce(null), [m, f] = ce(null), g = Kt(null), y = Kt(null), x = d || s ? "bottom-start" : r, { refs: S, x: E, y: $, strategy: w, placement: N, update: k } = Jl({
    middleware: [Ql(), ei()],
    placement: x,
    open: !0,
    whileElementsMounted: ti
  }), C = () => {
    c && f(
      p_(c).getBoundingClientRect()
    );
  };
  z(() => {
    if (c !== null)
      return window.addEventListener("resize", C), window.addEventListener("scroll", C), () => {
        window.removeEventListener("resize", C), window.removeEventListener("scroll", C);
      };
  }, [c]), z(() => (window.addEventListener("resize", k), () => window.removeEventListener("resize", k)), [k]), z(() => {
    if (_) {
      const T = document.querySelector(_);
      p(T), S.setReference(T);
    }
  }, [_]), z(() => {
    c && f(
      p_(c).getBoundingClientRect()
    );
  }, [c]), z(() => {
    if (c && g.current) {
      g.current.innerHTML = "";
      const T = c.cloneNode(!0);
      i && (T.className += ` ${i}`), g.current.appendChild(T);
    }
    return () => {
      g.current && (g.current.innerHTML = "");
    };
  }, [c, g.current, i]), z(() => (l ? document.body.classList.add("user-guide-visible") : document.body.classList.remove("user-guide-visible"), () => {
    document.body.classList.remove("user-guide-visible");
  }), [l]);
  const I = () => m ? /* @__PURE__ */ a(
    "div",
    {
      ref: g,
      style: {
        position: "absolute",
        top: m.top,
        left: m.left,
        width: m.width,
        height: m.height,
        pointerEvents: "none"
      }
    }
  ) : null;
  return /* @__PURE__ */ h(Q, { children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: u(gt[`${ht}__overlay`]),
        style: {
          display: l ? "flex" : "none",
          zIndex: n
        },
        children: c && I()
      }
    ),
    l && /* @__PURE__ */ a(Ca, { children: /* @__PURE__ */ a(
      "div",
      {
        ref: S.setFloating,
        style: {
          position: w,
          top: d || s ? "40%" : $,
          left: d || s ? "calc(50% - 211px)" : E
        },
        className: u(
          gt[`${ht}__floating`],
          gt[`${ht}__floating--${o}`],
          e
        ),
        children: /* @__PURE__ */ h(
          "div",
          {
            ref: y,
            className: u(
              gt[`${ht}__guide`],
              gt[`${ht}__guide--${N}`]
            ),
            children: [
              /* @__PURE__ */ a(
                "div",
                {
                  className: u(
                    gt[`${ht}__guide__arrow`],
                    gt[`${ht}__guide__arrow--${N}`],
                    gt[`${ht}__guide__arrow--${o}`]
                  ),
                  children: /* @__PURE__ */ a("img", { src: yd, alt: "cursor" })
                }
              ),
              t && /* @__PURE__ */ a(
                "div",
                {
                  className: u(
                    gt[`${ht}__guide__content`],
                    gt[`${ht}__guide__content--${N}`],
                    gt[`${ht}__guide__content--${o}`]
                  ),
                  children: t
                },
                _
              )
            ]
          }
        )
      }
    ) })
  ] });
}, Ee = {
  "user-guide-bubble-step": "lc-UserGuideBubbleStep-module__user-guide-bubble-step___85b6K",
  "user-guide-bubble-step__bubble-wrapper": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper___CsEDk",
  "user-guide-bubble-step__bubble-wrapper--completed": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble-wrapper--completed___Ed8ua",
  "shadow-glow": "lc-UserGuideBubbleStep-module__shadow-glow___uMRE-",
  "user-guide-bubble-step__bubble": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble___CoHl4",
  "fade-in": "lc-UserGuideBubbleStep-module__fade-in___Pjz6d",
  "user-guide-bubble-step__bubble--next-msg": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--next-msg___bzw2-",
  "user-guide-bubble-step__bubble--header": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--header___frxyc",
  "user-guide-bubble-step__bubble--message": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--message___dCGqv",
  "user-guide-bubble-step__bubble--cta": "lc-UserGuideBubbleStep-module__user-guide-bubble-step__bubble--cta___NcXxo"
}, Te = "user-guide-bubble-step", um = ({
  headerMessage: e,
  message: t,
  cta: r,
  isCompleted: o,
  handleAnimationComplete: _,
  disableTypingAnimations: l,
  typingDelay: i,
  typingSpeed: n,
  className: d
}) => {
  const [s, c] = ce(["header"]), p = s.includes("header"), m = s.includes("message"), f = r && s.includes("cta");
  return z(() => {
    s.length === 3 && _ && _();
  }, [s]), /* @__PURE__ */ h("div", { className: u("lc-light-theme", Ee[`${Te}`], d), children: [
    p && /* @__PURE__ */ a(
      "div",
      {
        className: u(Ee[`${Te}__bubble-wrapper`], {
          [Ee[`${Te}__bubble-wrapper--completed`]]: o
        }),
        children: /* @__PURE__ */ h(
          "div",
          {
            className: u(
              Ee[`${Te}__bubble`],
              Ee[`${Te}__bubble--header`],
              {
                [Ee[`${Te}__bubble--next-msg`]]: m
              }
            ),
            children: [
              /* @__PURE__ */ a("div", { className: Ee[`${Te}__bubble__icon`], children: /* @__PURE__ */ a(R, { size: "large", source: y_ }) }),
              /* @__PURE__ */ a(F, { as: "span", children: /* @__PURE__ */ a(
                wo,
                {
                  text: e,
                  typingAnimation: !l,
                  typingDelay: i,
                  typingSpeed: n,
                  onTypingEnd: () => c([...s, "message"])
                }
              ) })
            ]
          }
        )
      }
    ),
    m && /* @__PURE__ */ a(
      "div",
      {
        className: u(Ee[`${Te}__bubble-wrapper`], {
          [Ee[`${Te}__bubble-wrapper--completed`]]: o
        }),
        children: /* @__PURE__ */ a(
          "div",
          {
            className: u(
              Ee[`${Te}__bubble`],
              Ee[`${Te}__bubble--message`],
              {
                [Ee[`${Te}__bubble--next-msg`]]: f
              }
            ),
            children: /* @__PURE__ */ a(F, { as: "span", children: /* @__PURE__ */ a(
              wo,
              {
                text: t,
                typingAnimation: !l,
                typingSpeed: n,
                typingDelay: 0,
                onTypingEnd: () => c([...s, "cta"])
              }
            ) })
          }
        )
      }
    ),
    f && /* @__PURE__ */ a(
      "div",
      {
        className: u(Ee[`${Te}__bubble-wrapper`], {
          [Ee[`${Te}__bubble-wrapper--completed`]]: o
        }),
        children: /* @__PURE__ */ a(
          "div",
          {
            className: u(
              Ee[`${Te}__bubble`],
              Ee[`${Te}__bubble--cta`]
            ),
            children: r
          }
        )
      }
    )
  ] });
}, rt = {
  "user-guide-step": "lc-UserGuideStep-module__user-guide-step___WxRx-",
  "user-guide-step__heading": "lc-UserGuideStep-module__user-guide-step__heading___TmHOq",
  "user-guide-step__content": "lc-UserGuideStep-module__user-guide-step__content___1hIeo",
  "user-guide-step__media-wrapper": "lc-UserGuideStep-module__user-guide-step__media-wrapper___RF2FB",
  "user-guide-step__media": "lc-UserGuideStep-module__user-guide-step__media___GyJrq",
  "user-guide-step__footer": "lc-UserGuideStep-module__user-guide-step__footer___jhJ3K",
  "fade-in": "lc-UserGuideStep-module__fade-in___3sI4D",
  "user-guide-step__footer__step-counter": "lc-UserGuideStep-module__user-guide-step__footer__step-counter___GWY-W",
  "user-guide-step__footer__step-counter__current-step": "lc-UserGuideStep-module__user-guide-step__footer__step-counter__current-step___EfyHm",
  "user-guide-step__footer__button-primary": "lc-UserGuideStep-module__user-guide-step__footer__button-primary___1PHEv",
  "user-guide-step__footer__button-close": "lc-UserGuideStep-module__user-guide-step__footer__button-close___ShrtZ"
}, ot = "user-guide-step", mm = ({
  header: e,
  text: t,
  image: r,
  video: o,
  currentStep: _,
  stepMax: l,
  typingAnimation: i = !1,
  typingDelay: n,
  typingSpeed: d,
  handleCloseAction: s,
  handleClickPrimary: c,
  className: p
}) => {
  const [m, f] = ce(!1);
  return z(() => {
    if (s)
      return document.addEventListener("keydown", s), () => {
        document.removeEventListener("keydown", s);
      };
  }, [s]), /* @__PURE__ */ h("div", { className: u("lc-light-theme", rt[`${ot}`], p), children: [
    /* @__PURE__ */ h("span", { className: rt[`${ot}__heading`], children: [
      /* @__PURE__ */ a(R, { size: "large", source: y_ }),
      /* @__PURE__ */ a(F, { size: "lg", bold: !0, as: "span", children: e })
    ] }),
    r && /* @__PURE__ */ a("div", { className: rt[`${ot}__media-wrapper`], children: /* @__PURE__ */ a(
      "img",
      {
        className: rt[`${ot}__media`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    o && !r && /* @__PURE__ */ a("div", { className: rt[`${ot}__media-wrapper`], children: /* @__PURE__ */ a(
      "video",
      {
        className: rt[`${ot}__media`],
        "data-testid": "user-guide-step-video",
        src: o.src,
        playsInline: o.playsInline,
        autoPlay: o.autoPlay,
        muted: o.muted,
        loop: o.loop,
        controls: o.controls
      }
    ) }),
    /* @__PURE__ */ a(
      F,
      {
        id: "user-guide-step-typed-text",
        as: "span",
        className: rt[`${ot}__content`],
        children: /* @__PURE__ */ a(
          wo,
          {
            text: t,
            typingAnimation: i,
            typingDelay: n,
            typingSpeed: d,
            onTypingEnd: () => f(!0)
          }
        )
      }
    ),
    m && /* @__PURE__ */ h("div", { className: rt[`${ot}__footer`], children: [
      /* @__PURE__ */ a(
        W,
        {
          kind: "high-contrast",
          size: "large",
          onClick: c,
          className: rt[`${ot}__footer__button-primary`],
          children: _ === l ? "Finish" : "Next"
        }
      ),
      /* @__PURE__ */ h("span", { children: [
        s && /* @__PURE__ */ a(
          W,
          {
            kind: "plain",
            size: "large",
            onClick: s,
            className: rt[`${ot}__footer__button-close`],
            children: "Skip all"
          }
        ),
        /* @__PURE__ */ h(
          F,
          {
            as: "span",
            className: rt[`${ot}__footer__step-counter`],
            children: [
              /* @__PURE__ */ a(
                "span",
                {
                  className: rt[`${ot}__footer__step-counter__current-step`],
                  children: _
                }
              ),
              " ",
              "/ ",
              l,
              " steps"
            ]
          }
        )
      ] })
    ] })
  ] });
}, fo = {
  "file-upload-progress-actions": "lc-FileUploadProgressActions-module__file-upload-progress-actions___XINkF",
  "file-upload-progress-actions__close-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__close-button___BHRcO",
  "file-upload-progress-actions__retry-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__retry-button___2Xd72"
}, bo = "file-upload-progress-actions", No = ({ status: e, onCloseButtonClick: t, onRetryButtonClick: r }) => /* @__PURE__ */ h("div", { className: fo[`${bo}`], children: [
  r && e === "error" && /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      className: fo[`${bo}__retry-button`],
      "aria-label": "Retry",
      onClick: r,
      children: /* @__PURE__ */ a(R, { size: "small", source: Ol })
    }
  ),
  t && e !== "success" && /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      className: fo[`${bo}__close-button`],
      "aria-label": "Close",
      onClick: t,
      children: /* @__PURE__ */ a(R, { size: "small", source: ct })
    }
  )
] }), ft = {
  "file-upload-progress": "lc-FileUploadProgress-module__file-upload-progress___cAUbT",
  "file-upload-progress__icon": "lc-FileUploadProgress-module__file-upload-progress__icon___ZCOg9",
  "file-upload-progress__icon--success": "lc-FileUploadProgress-module__file-upload-progress__icon--success___mQkAS",
  "file-upload-progress__wrapper": "lc-FileUploadProgress-module__file-upload-progress__wrapper___Hrlp6",
  "file-upload-progress__wrapper--with-icon": "lc-FileUploadProgress-module__file-upload-progress__wrapper--with-icon___t56aA",
  "file-upload-progress__wrapper__header": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header___DKuHl",
  "file-upload-progress__wrapper__header__actions": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__actions___AM74G",
  "file-upload-progress__wrapper__header__title": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title___EYxE3",
  "file-upload-progress__wrapper__header__title--success": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--success___P0XSe",
  "file-upload-progress__wrapper__header__title--error": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--error___la8oa"
}, Ht = "file-upload-progress", vo = `${Ht}__wrapper__header__title`, wd = b.forwardRef(
  ({
    actionsVisibility: e = "hidden",
    className: t,
    icon: r,
    title: o,
    progressValue: _,
    size: l,
    status: i = "normal",
    onCloseButtonClick: n,
    onRetryButtonClick: d
  }, s) => /* @__PURE__ */ h("div", { className: ft[Ht], ref: s, children: [
    r && i !== "success" && /* @__PURE__ */ a("div", { className: ft[`${Ht}__icon`], children: r }),
    i === "success" && /* @__PURE__ */ a(
      "div",
      {
        className: u(
          ft[`${Ht}__icon`],
          ft[`${Ht}__icon--success`]
        ),
        children: /* @__PURE__ */ a(R, { source: wa })
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        className: u(ft[`${Ht}__wrapper`], {
          [ft[`${Ht}__wrapper--with-icon`]]: r
        }),
        children: [
          /* @__PURE__ */ h("div", { className: ft[`${Ht}__wrapper__header`], children: [
            o && /* @__PURE__ */ a(
              "div",
              {
                className: u(ft[vo], {
                  [ft[`${vo}--success`]]: i === "success",
                  [ft[`${vo}--error`]]: i === "error"
                }),
                children: /* @__PURE__ */ a(F, { size: "sm", as: "div", children: o })
              }
            ),
            e !== "hidden" && /* @__PURE__ */ a(
              "div",
              {
                className: u({
                  [ft[`${Ht}__wrapper__header__actions`]]: e === "hover"
                }),
                children: /* @__PURE__ */ a(
                  No,
                  {
                    status: i,
                    onCloseButtonClick: n,
                    onRetryButtonClick: d
                  }
                )
              }
            )
          ] }),
          i !== "success" && /* @__PURE__ */ a(
            ds,
            {
              className: t,
              percent: _,
              status: i,
              size: l
            }
          )
        ]
      }
    )
  ] })
), ee = {
  "upload-bar": "lc-UploadBar-module__upload-bar___0ZOP3",
  "upload-bar__loader-test": "lc-UploadBar-module__upload-bar__loader-test___4QKID",
  "upload-bar--error": "lc-UploadBar-module__upload-bar--error___83It3",
  "upload-bar__wrapper": "lc-UploadBar-module__upload-bar__wrapper___vk3pI",
  "upload-bar__wrapper__header": "lc-UploadBar-module__upload-bar__wrapper__header___3z6fH",
  "upload-bar__wrapper__header__icon": "lc-UploadBar-module__upload-bar__wrapper__header__icon___97HQo",
  "upload-bar__wrapper__header__title": "lc-UploadBar-module__upload-bar__wrapper__header__title___CqykW",
  "upload-bar__wrapper__header__collapse-button": "lc-UploadBar-module__upload-bar__wrapper__header__collapse-button___9n0O7",
  "upload-bar__wrapper__header__actions-container": "lc-UploadBar-module__upload-bar__wrapper__header__actions-container___80EgZ",
  "upload-bar__wrapper__header__success-icon": "lc-UploadBar-module__upload-bar__wrapper__header__success-icon___eau3A",
  "upload-bar__wrapper__header__error-icon": "lc-UploadBar-module__upload-bar__wrapper__header__error-icon___VZLl2",
  "upload-bar__wrapper__header__loader": "lc-UploadBar-module__upload-bar__wrapper__header__loader___h0F6t",
  "upload-bar__files": "lc-UploadBar-module__upload-bar__files___jMFT-",
  "upload-bar__files--enter": "lc-UploadBar-module__upload-bar__files--enter___BNcoJ",
  "upload-bar__files--enter-active": "lc-UploadBar-module__upload-bar__files--enter-active___yj9Mq",
  "upload-bar__files--exit": "lc-UploadBar-module__upload-bar__files--exit___iEuiQ",
  "upload-bar__files--exit-active": "lc-UploadBar-module__upload-bar__files--exit-active___mz8u3",
  "upload-bar__files--exit-done": "lc-UploadBar-module__upload-bar__files--exit-done___-N5nJ",
  "upload-bar__files-wrapper": "lc-UploadBar-module__upload-bar__files-wrapper___C3au9",
  "upload-bar__files__list": "lc-UploadBar-module__upload-bar__files__list___95G7b"
}, Ue = "upload-bar", Wt = `${Ue}__wrapper__header`, $d = 300, Nd = (e, t) => e === "success" ? /* @__PURE__ */ a(
  "div",
  {
    "data-testid": "success-icon",
    className: ee[`${Wt}__success-icon`],
    children: /* @__PURE__ */ a(R, { source: wa })
  }
) : e === "error" ? /* @__PURE__ */ a(
  "div",
  {
    "data-testid": "error-icon",
    className: ee[`${Wt}__error-icon`],
    children: /* @__PURE__ */ a(R, { source: k_ })
  }
) : /* @__PURE__ */ a(
  ss,
  {
    className: ee[`${Wt}__loader`],
    status: e,
    progressValue: t
  }
), pm = ({
  children: e,
  className: t,
  progressValue: r,
  title: o,
  isExpanded: _,
  errorMessage: l,
  status: i = "normal",
  icon: n,
  size: d,
  mode: s = "multiple",
  onCloseButtonClick: c,
  onRetryButtonClick: p
}) => {
  const [m, f] = b.useState(_ || !1), g = i === "error", y = i === "success", x = u(ee[Ue], t, {
    [ee[`${Ue}--error`]]: g,
    [ee[`${Ue}--success`]]: y
  }), S = !(g && (p || c)), E = () => f(!m);
  return s === "single" ? /* @__PURE__ */ a("div", { className: x, children: /* @__PURE__ */ h("div", { className: ee[`${Ue}__wrapper`], children: [
    /* @__PURE__ */ a("div", { className: ee[`${Wt}`], children: /* @__PURE__ */ a(
      wd,
      {
        title: g && l || o,
        progressValue: r,
        status: i,
        icon: n,
        size: d
      }
    ) }),
    i === "error" && /* @__PURE__ */ a(
      No,
      {
        status: i,
        onCloseButtonClick: c,
        onRetryButtonClick: p
      }
    )
  ] }) }) : /* @__PURE__ */ h("div", { className: x, children: [
    /* @__PURE__ */ a(
      "div",
      {
        className: ee[`${Ue}__wrapper`],
        onClick: E,
        children: /* @__PURE__ */ h("div", { className: ee[`${Wt}`], children: [
          /* @__PURE__ */ a("div", { className: ee[`${Wt}__icon`], children: Nd(i, r) }),
          /* @__PURE__ */ a("div", { className: ee[`${Wt}__title`], children: /* @__PURE__ */ a(F, { size: "sm", as: "div", children: g ? l : o }) }),
          S && /* @__PURE__ */ a(
            "button",
            {
              className: ee[`${Wt}__collapse-button`],
              type: "button",
              "aria-label": "Collapse button",
              onClick: E,
              children: m ? /* @__PURE__ */ a(R, { source: Rr }) : /* @__PURE__ */ a(R, { source: na })
            }
          ),
          i === "error" && /* @__PURE__ */ a("div", { className: ee[`${Wt}__actions-container`], children: /* @__PURE__ */ a(
            No,
            {
              status: i,
              onCloseButtonClick: c,
              onRetryButtonClick: p
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ a(N_, { component: null, children: m && /* @__PURE__ */ a(
      S_,
      {
        timeout: $d,
        classNames: {
          enter: ee[`${Ue}__files--enter`],
          enterActive: ee[`${Ue}__files--enter-active`],
          exit: ee[`${Ue}__files--exit`],
          exitActive: ee[`${Ue}__files--exit-active`],
          exitDone: ee[`${Ue}__files--exit-done`]
        },
        children: /* @__PURE__ */ a("div", { className: ee[`${Ue}__files`], children: /* @__PURE__ */ a("div", { className: ee[`${Ue}__files-wrapper`], children: /* @__PURE__ */ a("div", { className: ee[`${Ue}__files__list`], children: e }) }) })
      }
    ) })
  ] });
}, gm = ({
  children: e,
  id: t,
  root: r,
  preserveTabOrder: o
}) => /* @__PURE__ */ a(Ca, { id: t, root: r, preserveTabOrder: o, children: e }), Sd = "lc-Stepper-module__stepper__counter___K59ri", xd = "lc-Stepper-module__stepper__steps__container___sYhuT", Ed = "lc-Stepper-module__stepper__step___mCyT-", ba = {
  stepper__counter: Sd,
  stepper__steps__container: xd,
  stepper__step: Ed,
  "stepper__step--completed": "lc-Stepper-module__stepper__step--completed___unE6n",
  "stepper__step--active": "lc-Stepper-module__stepper__step--active___uirCz"
}, va = "stepper", hm = (l) => {
  var i = l, {
    activeStep: e,
    steps: t,
    className: r,
    "data-testid": o = "stepper"
  } = i, _ = U(i, [
    "activeStep",
    "steps",
    "className",
    "data-testid"
  ]);
  const n = Math.round(Math.max(1, t)), d = Math.round(
    Math.min(Math.max(1, e), n)
  ), s = u(ba[va], r);
  return /* @__PURE__ */ h(
    "div",
    B(v({
      className: s,
      "data-testid": o,
      "aria-label": "Stepper"
    }, _), {
      children: [
        /* @__PURE__ */ h(F, { size: "sm", className: ba[`${va}__counter`], children: [
          d,
          "/",
          n
        ] }),
        /* @__PURE__ */ a(
          "div",
          {
            className: ba[`${va}__steps__container`],
            "data-testid": `${o}-container`,
            children: Array.from({ length: n }, (c, p) => {
              const m = p + 1, f = m <= d, g = m > d;
              return /* @__PURE__ */ a(
                "div",
                {
                  "aria-completed": f,
                  className: u(ba[`${va}__step`], {
                    [ba[`${va}__step--completed`]]: f,
                    [ba[`${va}__step--active`]]: g
                  })
                },
                m
              );
            })
          }
        )
      ]
    })
  );
};
export {
  fd as ANIMATION_TIME,
  ru as Accordion,
  ui as AccordionAnimatedLabel,
  mi as AccordionMultilineElement,
  ou as AccordionPromo,
  cu as ActionBar,
  su as ActionCard,
  I_ as ActionMenu,
  _u as ActionMenuItem,
  Ru as ActionModalContent,
  du as Alert,
  wo as AnimatedTextContainer,
  uu as AppFrame,
  ni as AppFrameProvider,
  Cu as AutoComplete,
  Io as Avatar,
  Dr as Badge,
  W as Button,
  $u as Card,
  zr as Checkbox,
  yc as DatePicker,
  Nu as DatePickerRangeCalendarsWrapper,
  Vd as DesignToken,
  Su as DetailsCard,
  xu as DetailsCardInfo,
  Vo as Display,
  im as EmailTagInput,
  Eu as EmptyState,
  bu as ExpirationCounter,
  Hr as FieldDescription,
  Ao as FieldError,
  Tu as FieldGroup,
  wd as FileUploadProgress,
  No as FileUploadProgressActions,
  gm as FloatingPortal,
  Bu as Form,
  Iu as FormField,
  Au as FormGroup,
  Ku as GallerySelectableCard,
  ju as GridCol,
  Zu as GridRow,
  Xu as GridWrapper,
  au as HEADING_SIZES,
  pe as Heading,
  R as Icon,
  iu as Info,
  $n as Input,
  R_ as InputComponent,
  ku as InputPromo,
  Li as Interactive,
  Yu as InteractiveSelectableCard,
  Du as InviteAgents,
  Ou as Link,
  Ar as ListItem,
  Bo as Loader,
  vu as MobileNavigation,
  Pu as Modal,
  qc as ModalBase,
  i_ as ModalCloseButton,
  Mu as ModalHeader,
  Fu as ModalPortal,
  fu as Navigation,
  gu as NavigationGroup,
  hu as NavigationItem,
  F_ as NavigationTopBar,
  vn as NavigationTopBarAlert,
  bn as NavigationTopBarTitle,
  Gu as NumericInput,
  Uu as OnboardingChecklist,
  Lu as OverflowTooltipText,
  yu as Picker,
  L_ as PickerList,
  Xc as Popover,
  qu as ProductSwitcher,
  Jc as ProductSwitcherProducts,
  ds as ProgressBar,
  ss as ProgressCircle,
  zu as PromoBannerV2,
  us as RadioButton,
  Yd as RadiusToken,
  K_ as RangeDatePicker,
  Vu as RangeDatePickerV2,
  nu as Reports,
  _n as SIDE_NAVIGATION_ACTIVE_ITEM_TEST_ID,
  on as SIDE_NAVIGATION_ITEM_TEST_ID,
  ln as SIDE_NAVIGATION_PARENT_ICON_TEST_ID,
  fs as SearchInput,
  wu as SegmentedControl,
  Oo as SelectableCard,
  Kd as ShadowToken,
  mu as SideNavigation,
  pu as SideNavigationGroup,
  nn as SideNavigationItem,
  lu as Simple,
  Qu as SkeletonAvatar,
  em as SkeletonText,
  Ju as SkeletonWrapper,
  Wd as SpacingToken,
  tm as StatusBadge,
  hm as Stepper,
  am as Switch,
  rm as Tab,
  lm as Table,
  _m as TabsList,
  om as TabsWrapper,
  q_ as Tag,
  id as TagInput,
  F as Text,
  cm as Textarea,
  jt as ThemeClassName,
  eu as ThemeProvider,
  Wu as ThumbnailSelectableCard,
  hd as Toast,
  nm as ToastWrapper,
  ia as Tooltip,
  jd as TransitionDelayToken,
  Xd as TransitionDurationToken,
  Zd as TransitionTimingToken,
  sm as UpdateBadge,
  pm as UploadBar,
  dm as UserGuide,
  um as UserGuideBubbleStep,
  mm as UserGuideStep,
  Tn as generateAvatarColor,
  tu as getDesignTokenWithOpacity,
  Jd as getThemeClassName,
  la as useAnimations,
  To as useAppFrame,
  Hu as useProductSwitcher,
  Os as useTable,
  Qd as useTheme
};
